'undefined' == typeof WeakMap &&
  !(function () {
    var t = Object.defineProperty,
      e = Date.now() % 1e9,
      i = function () {
        this.name = '__st' + ((1e9 * Math.random()) >>> 0) + (e++ + '__');
      };
    (i.prototype = {
      set: function (e, i) {
        var n = e[this.name];
        return (
          n && n[0] === e
            ? (n[1] = i)
            : t(e, this.name, { value: [e, i], writable: !0 }),
          this
        );
      },
      get: function (t) {
        var e;
        return (e = t[this.name]) && e[0] === t ? e[1] : void 0;
      },
      delete: function (t) {
        var e = t[this.name];
        if (!e) return !1;
        var i = e[0] === t;
        return (e[0] = e[1] = void 0), i;
      },
      has: function (t) {
        var e = t[this.name];
        return !!e && e[0] === t;
      }
    }),
      (window.WeakMap = i);
  })(),
  'document' in self &&
    ('classList' in document.createElement('_')
      ? !(function () {
          'use strict';
          var t = document.createElement('_');
          if ((t.classList.add('c1', 'c2'), !t.classList.contains('c2'))) {
            var e = function (t) {
              var e = DOMTokenList.prototype[t];
              DOMTokenList.prototype[t] = function (t) {
                var i,
                  n = arguments.length;
                for (i = 0; i < n; i++) (t = arguments[i]), e.call(this, t);
              };
            };
            e('add'), e('remove');
          }
          if ((t.classList.toggle('c3', !1), t.classList.contains('c3'))) {
            var i = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function (t, e) {
              return 1 in arguments && !this.contains(t) == !e
                ? e
                : i.call(this, t);
            };
          }
          t = null;
        })()
      : !(function (t) {
          'use strict';
          if ('Element' in t) {
            var e = 'classList',
              i = 'prototype',
              n = t.Element[i],
              s = Object,
              o =
                String[i].trim ||
                function () {
                  return this.replace(/^\s+|\s+$/g, '');
                },
              r =
                Array[i].indexOf ||
                function (t) {
                  for (var e = 0, i = this.length; e < i; e++)
                    if (e in this && this[e] === t) return e;
                  return -1;
                },
              a = function (t, e) {
                (this.name = t),
                  (this.code = DOMException[t]),
                  (this.message = e);
              },
              l = function (t, e) {
                if ('' === e)
                  throw new a(
                    'SYNTAX_ERR',
                    'An invalid or illegal string was specified'
                  );
                if (/\s/.test(e))
                  throw new a(
                    'INVALID_CHARACTER_ERR',
                    'String contains an invalid character'
                  );
                return r.call(t, e);
              },
              c = function (t) {
                for (
                  var e = o.call(t.getAttribute('class') || ''),
                    i = e ? e.split(/\s+/) : [],
                    n = 0,
                    s = i.length;
                  n < s;
                  n++
                )
                  this.push(i[n]);
                this._updateClassName = function () {
                  t.setAttribute('class', this.toString());
                };
              },
              d = (c[i] = []),
              u = function () {
                return new c(this);
              };
            if (
              ((a[i] = Error[i]),
              (d.item = function (t) {
                return this[t] || null;
              }),
              (d.contains = function (t) {
                return (t += ''), l(this, t) !== -1;
              }),
              (d.add = function () {
                var t,
                  e = arguments,
                  i = 0,
                  n = e.length,
                  s = !1;
                do
                  (t = e[i] + ''),
                    l(this, t) === -1 && (this.push(t), (s = !0));
                while (++i < n);
                s && this._updateClassName();
              }),
              (d.remove = function () {
                var t,
                  e,
                  i = arguments,
                  n = 0,
                  s = i.length,
                  o = !1;
                do
                  for (t = i[n] + '', e = l(this, t); e !== -1; )
                    this.splice(e, 1), (o = !0), (e = l(this, t));
                while (++n < s);
                o && this._updateClassName();
              }),
              (d.toggle = function (t, e) {
                t += '';
                var i = this.contains(t),
                  n = i ? e !== !0 && 'remove' : e !== !1 && 'add';
                return n && this[n](t), e === !0 || e === !1 ? e : !i;
              }),
              (d.toString = function () {
                return this.join(' ');
              }),
              s.defineProperty)
            ) {
              var p = { get: u, enumerable: !0, configurable: !0 };
              try {
                s.defineProperty(n, e, p);
              } catch (h) {
                h.number === -2146823252 &&
                  ((p.enumerable = !1), s.defineProperty(n, e, p));
              }
            } else s[i].__defineGetter__ && n.__defineGetter__(e, u);
          }
        })(self)),
  (function (t) {
    function e(t) {
      b.push(t), y || ((y = !0), g(n));
    }
    function i(t) {
      return (
        (window.ShadowDOMPolyfill &&
          window.ShadowDOMPolyfill.wrapIfNeeded(t)) ||
        t
      );
    }
    function n() {
      y = !1;
      var t = b;
      (b = []),
        t.sort(function (t, e) {
          return t.uid_ - e.uid_;
        });
      var e = !1;
      t.forEach(function (t) {
        var i = t.takeRecords();
        s(t), i.length && (t.callback_(i, t), (e = !0));
      }),
        e && n();
    }
    function s(t) {
      t.nodes_.forEach(function (e) {
        var i = v.get(e);
        i &&
          i.forEach(function (e) {
            e.observer === t && e.removeTransientObservers();
          });
      });
    }
    function o(t, e) {
      for (var i = t; i; i = i.parentNode) {
        var n = v.get(i);
        if (n)
          for (var s = 0; s < n.length; s++) {
            var o = n[s],
              r = o.options;
            if (i === t || r.subtree) {
              var a = e(r);
              a && o.enqueue(a);
            }
          }
      }
    }
    function r(t) {
      (this.callback_ = t),
        (this.nodes_ = []),
        (this.records_ = []),
        (this.uid_ = ++x);
    }
    function a(t, e) {
      (this.type = t),
        (this.target = e),
        (this.addedNodes = []),
        (this.removedNodes = []),
        (this.previousSibling = null),
        (this.nextSibling = null),
        (this.attributeName = null),
        (this.attributeNamespace = null),
        (this.oldValue = null);
    }
    function l(t) {
      var e = new a(t.type, t.target);
      return (
        (e.addedNodes = t.addedNodes.slice()),
        (e.removedNodes = t.removedNodes.slice()),
        (e.previousSibling = t.previousSibling),
        (e.nextSibling = t.nextSibling),
        (e.attributeName = t.attributeName),
        (e.attributeNamespace = t.attributeNamespace),
        (e.oldValue = t.oldValue),
        e
      );
    }
    function c(t, e) {
      return (k = new a(t, e));
    }
    function d(t) {
      return T ? T : ((T = l(k)), (T.oldValue = t), T);
    }
    function u() {
      k = T = void 0;
    }
    function p(t) {
      return t === T || t === k;
    }
    function h(t, e) {
      return t === e ? t : T && p(t) ? T : null;
    }
    function f(t, e, i) {
      (this.observer = t),
        (this.target = e),
        (this.options = i),
        (this.transientObservedNodes = []);
    }
    var v = new WeakMap(),
      g = window.msSetImmediate;
    if (!g) {
      var m = [],
        w = String(Math.random());
      window.addEventListener('message', function (t) {
        if (t.data === w) {
          var e = m;
          (m = []),
            e.forEach(function (t) {
              t();
            });
        }
      }),
        (g = function (t) {
          m.push(t), window.postMessage(w, '*');
        });
    }
    var y = !1,
      b = [],
      x = 0;
    r.prototype = {
      observe: function (t, e) {
        if (
          ((t = i(t)),
          (!e.childList && !e.attributes && !e.characterData) ||
            (e.attributeOldValue && !e.attributes) ||
            (e.attributeFilter && e.attributeFilter.length && !e.attributes) ||
            (e.characterDataOldValue && !e.characterData))
        )
          throw new SyntaxError();
        var n = v.get(t);
        n || v.set(t, (n = []));
        for (var s, o = 0; o < n.length; o++)
          if (n[o].observer === this) {
            (s = n[o]), s.removeListeners(), (s.options = e);
            break;
          }
        s || ((s = new f(this, t, e)), n.push(s), this.nodes_.push(t)),
          s.addListeners();
      },
      disconnect: function () {
        this.nodes_.forEach(function (t) {
          for (var e = v.get(t), i = 0; i < e.length; i++) {
            var n = e[i];
            if (n.observer === this) {
              n.removeListeners(), e.splice(i, 1);
              break;
            }
          }
        }, this),
          (this.records_ = []);
      },
      takeRecords: function () {
        var t = this.records_;
        return (this.records_ = []), t;
      }
    };
    var k, T;
    (f.prototype = {
      enqueue: function (t) {
        var i = this.observer.records_,
          n = i.length;
        if (i.length > 0) {
          var s = i[n - 1],
            o = h(s, t);
          if (o) return void (i[n - 1] = o);
        } else e(this.observer);
        i[n] = t;
      },
      addListeners: function () {
        this.addListeners_(this.target);
      },
      addListeners_: function (t) {
        var e = this.options;
        e.attributes && t.addEventListener('DOMAttrModified', this, !0),
          e.characterData &&
            t.addEventListener('DOMCharacterDataModified', this, !0),
          e.childList && t.addEventListener('DOMNodeInserted', this, !0),
          (e.childList || e.subtree) &&
            t.addEventListener('DOMNodeRemoved', this, !0);
      },
      removeListeners: function () {
        this.removeListeners_(this.target);
      },
      removeListeners_: function (t) {
        var e = this.options;
        e.attributes && t.removeEventListener('DOMAttrModified', this, !0),
          e.characterData &&
            t.removeEventListener('DOMCharacterDataModified', this, !0),
          e.childList && t.removeEventListener('DOMNodeInserted', this, !0),
          (e.childList || e.subtree) &&
            t.removeEventListener('DOMNodeRemoved', this, !0);
      },
      addTransientObserver: function (t) {
        if (t !== this.target) {
          this.addListeners_(t), this.transientObservedNodes.push(t);
          var e = v.get(t);
          e || v.set(t, (e = [])), e.push(this);
        }
      },
      removeTransientObservers: function () {
        var t = this.transientObservedNodes;
        (this.transientObservedNodes = []),
          t.forEach(function (t) {
            this.removeListeners_(t);
            for (var e = v.get(t), i = 0; i < e.length; i++)
              if (e[i] === this) {
                e.splice(i, 1);
                break;
              }
          }, this);
      },
      handleEvent: function (t) {
        switch ((t.stopImmediatePropagation(), t.type)) {
          case 'DOMAttrModified':
            var e = t.attrName,
              i = t.relatedNode.namespaceURI,
              n = t.target,
              s = new c('attributes', n);
            (s.attributeName = e), (s.attributeNamespace = i);
            var r =
              t.attrChange === MutationEvent.ADDITION ? null : t.prevValue;
            o(n, function (t) {
              if (
                t.attributes &&
                (!t.attributeFilter ||
                  !t.attributeFilter.length ||
                  t.attributeFilter.indexOf(e) !== -1 ||
                  t.attributeFilter.indexOf(i) !== -1)
              )
                return t.attributeOldValue ? d(r) : s;
            });
            break;
          case 'DOMCharacterDataModified':
            var n = t.target,
              s = c('characterData', n),
              r = t.prevValue;
            o(n, function (t) {
              if (t.characterData) return t.characterDataOldValue ? d(r) : s;
            });
            break;
          case 'DOMNodeRemoved':
            this.addTransientObserver(t.target);
          case 'DOMNodeInserted':
            var a,
              l,
              n = t.relatedNode,
              p = t.target;
            'DOMNodeInserted' === t.type
              ? ((a = [p]), (l = []))
              : ((a = []), (l = [p]));
            var h = p.previousSibling,
              f = p.nextSibling,
              s = c('childList', n);
            (s.addedNodes = a),
              (s.removedNodes = l),
              (s.previousSibling = h),
              (s.nextSibling = f),
              o(n, function (t) {
                if (t.childList) return s;
              });
        }
        u();
      }
    }),
      (t.JsMutationObserver = r),
      t.MutationObserver || (t.MutationObserver = r);
  })(this),
  (function () {
    for (
      var t = 0, e = ['ms', 'moz', 'webkit', 'o'], i = 0;
      i < e.length && !window.requestAnimationFrame;
      ++i
    )
      (window.requestAnimationFrame = window[e[i] + 'RequestAnimationFrame']),
        (window.cancelAnimationFrame =
          window[e[i] + 'CancelAnimationFrame'] ||
          window[e[i] + 'CancelRequestAnimationFrame']);
    window.requestAnimationFrame ||
      (window.requestAnimationFrame = function (e, i) {
        var n = new Date().getTime(),
          s = Math.max(0, 16 - (n - t)),
          o = window.setTimeout(function () {
            e(n + s);
          }, s);
        return (t = n + s), o;
      }),
      window.cancelAnimationFrame ||
        (window.cancelAnimationFrame = function (t) {
          clearTimeout(t);
        });
  })(),
  (window.debounce = function (t, e, i) {
    var n;
    return function () {
      var s = this,
        o = arguments,
        r = function () {
          (n = null), i || t.apply(s, o);
        },
        a = i && !n;
      clearTimeout(n), (n = setTimeout(r, e)), a && t.apply(s, o);
    };
  }),
  (function (t, e) {
    'use strict';
    t.fn.delayedHover = function (e, i, n) {
      this.each(function (s, o) {
        var r,
          a = t(o);
        a.on('mouseenter', function () {
          r
            ? (clearTimeout(r), (r = null))
            : (r = setTimeout(function () {
                (r = null), e.call(o);
              }, n));
        }).on('mouseleave', function () {
          r
            ? (clearTimeout(r), (r = null))
            : (r = setTimeout(function () {
                (r = null), i.call(o);
              }, n));
        });
      });
    };
  })(jQuery),
  (jQuery.easing.jswing = jQuery.easing.swing),
  jQuery.extend(jQuery.easing, {
    def: 'easeOutQuad',
    swing: function (t, e, i, n, s) {
      return jQuery.easing[jQuery.easing.def](t, e, i, n, s);
    },
    easeInQuad: function (t, e, i, n, s) {
      return n * (e /= s) * e + i;
    },
    easeOutQuad: function (t, e, i, n, s) {
      return -n * (e /= s) * (e - 2) + i;
    },
    easeInOutQuad: function (t, e, i, n, s) {
      return (e /= s / 2) < 1
        ? (n / 2) * e * e + i
        : (-n / 2) * (--e * (e - 2) - 1) + i;
    },
    easeInCubic: function (t, e, i, n, s) {
      return n * (e /= s) * e * e + i;
    },
    easeOutCubic: function (t, e, i, n, s) {
      return n * ((e = e / s - 1) * e * e + 1) + i;
    },
    easeInOutCubic: function (t, e, i, n, s) {
      return (e /= s / 2) < 1
        ? (n / 2) * e * e * e + i
        : (n / 2) * ((e -= 2) * e * e + 2) + i;
    },
    easeInQuart: function (t, e, i, n, s) {
      return n * (e /= s) * e * e * e + i;
    },
    easeOutQuart: function (t, e, i, n, s) {
      return -n * ((e = e / s - 1) * e * e * e - 1) + i;
    },
    easeInOutQuart: function (t, e, i, n, s) {
      return (e /= s / 2) < 1
        ? (n / 2) * e * e * e * e + i
        : (-n / 2) * ((e -= 2) * e * e * e - 2) + i;
    },
    easeInQuint: function (t, e, i, n, s) {
      return n * (e /= s) * e * e * e * e + i;
    },
    easeOutQuint: function (t, e, i, n, s) {
      return n * ((e = e / s - 1) * e * e * e * e + 1) + i;
    },
    easeInOutQuint: function (t, e, i, n, s) {
      return (e /= s / 2) < 1
        ? (n / 2) * e * e * e * e * e + i
        : (n / 2) * ((e -= 2) * e * e * e * e + 2) + i;
    },
    easeInSine: function (t, e, i, n, s) {
      return -n * Math.cos((e / s) * (Math.PI / 2)) + n + i;
    },
    easeOutSine: function (t, e, i, n, s) {
      return n * Math.sin((e / s) * (Math.PI / 2)) + i;
    },
    easeInOutSine: function (t, e, i, n, s) {
      return (-n / 2) * (Math.cos((Math.PI * e) / s) - 1) + i;
    },
    easeInExpo: function (t, e, i, n, s) {
      return 0 == e ? i : n * Math.pow(2, 10 * (e / s - 1)) + i;
    },
    easeOutExpo: function (t, e, i, n, s) {
      return e == s ? i + n : n * (-Math.pow(2, (-10 * e) / s) + 1) + i;
    },
    easeInOutExpo: function (t, e, i, n, s) {
      return 0 == e
        ? i
        : e == s
        ? i + n
        : (e /= s / 2) < 1
        ? (n / 2) * Math.pow(2, 10 * (e - 1)) + i
        : (n / 2) * (-Math.pow(2, -10 * --e) + 2) + i;
    },
    easeInCirc: function (t, e, i, n, s) {
      return -n * (Math.sqrt(1 - (e /= s) * e) - 1) + i;
    },
    easeOutCirc: function (t, e, i, n, s) {
      return n * Math.sqrt(1 - (e = e / s - 1) * e) + i;
    },
    easeInOutCirc: function (t, e, i, n, s) {
      return (e /= s / 2) < 1
        ? (-n / 2) * (Math.sqrt(1 - e * e) - 1) + i
        : (n / 2) * (Math.sqrt(1 - (e -= 2) * e) + 1) + i;
    },
    easeInElastic: function (t, e, i, n, s) {
      var o = 1.70158,
        r = 0,
        a = n;
      if (0 == e) return i;
      if (1 == (e /= s)) return i + n;
      if ((r || (r = 0.3 * s), a < Math.abs(n))) {
        a = n;
        var o = r / 4;
      } else var o = (r / (2 * Math.PI)) * Math.asin(n / a);
      return (
        -(
          a *
          Math.pow(2, 10 * (e -= 1)) *
          Math.sin(((e * s - o) * (2 * Math.PI)) / r)
        ) + i
      );
    },
    easeOutElastic: function (t, e, i, n, s) {
      var o = 1.70158,
        r = 0,
        a = n;
      if (0 == e) return i;
      if (1 == (e /= s)) return i + n;
      if ((r || (r = 0.3 * s), a < Math.abs(n))) {
        a = n;
        var o = r / 4;
      } else var o = (r / (2 * Math.PI)) * Math.asin(n / a);
      return (
        a * Math.pow(2, -10 * e) * Math.sin(((e * s - o) * (2 * Math.PI)) / r) +
        n +
        i
      );
    },
    easeInOutElastic: function (t, e, i, n, s) {
      var o = 1.70158,
        r = 0,
        a = n;
      if (0 == e) return i;
      if (2 == (e /= s / 2)) return i + n;
      if ((r || (r = s * (0.3 * 1.5)), a < Math.abs(n))) {
        a = n;
        var o = r / 4;
      } else var o = (r / (2 * Math.PI)) * Math.asin(n / a);
      return e < 1
        ? -0.5 *
            (a *
              Math.pow(2, 10 * (e -= 1)) *
              Math.sin(((e * s - o) * (2 * Math.PI)) / r)) +
            i
        : a *
            Math.pow(2, -10 * (e -= 1)) *
            Math.sin(((e * s - o) * (2 * Math.PI)) / r) *
            0.5 +
            n +
            i;
    },
    easeInBack: function (t, e, i, n, s, o) {
      return (
        void 0 == o && (o = 1.70158), n * (e /= s) * e * ((o + 1) * e - o) + i
      );
    },
    easeOutBack: function (t, e, i, n, s, o) {
      return (
        void 0 == o && (o = 1.70158),
        n * ((e = e / s - 1) * e * ((o + 1) * e + o) + 1) + i
      );
    },
    easeInOutBack: function (t, e, i, n, s, o) {
      return (
        void 0 == o && (o = 1.70158),
        (e /= s / 2) < 1
          ? (n / 2) * (e * e * (((o *= 1.525) + 1) * e - o)) + i
          : (n / 2) * ((e -= 2) * e * (((o *= 1.525) + 1) * e + o) + 2) + i
      );
    },
    easeInBounce: function (t, e, i, n, s) {
      return n - jQuery.easing.easeOutBounce(t, s - e, 0, n, s) + i;
    },
    easeOutBounce: function (t, e, i, n, s) {
      return (e /= s) < 1 / 2.75
        ? n * (7.5625 * e * e) + i
        : e < 2 / 2.75
        ? n * (7.5625 * (e -= 1.5 / 2.75) * e + 0.75) + i
        : e < 2.5 / 2.75
        ? n * (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375) + i
        : n * (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375) + i;
    },
    easeInOutBounce: function (t, e, i, n, s) {
      return e < s / 2
        ? 0.5 * jQuery.easing.easeInBounce(t, 2 * e, 0, n, s) + i
        : 0.5 * jQuery.easing.easeOutBounce(t, 2 * e - s, 0, n, s) +
            0.5 * n +
            i;
    }
  }),
  (function (t) {
    'function' == typeof define && define.amd
      ? define(['jquery'], t)
      : t(
          'object' == typeof exports
            ? require('jquery')
            : window.jQuery || window.Zepto
        );
  })(function (t) {
    var e,
      i,
      n,
      s,
      o,
      r,
      a = 'Close',
      l = 'BeforeClose',
      c = 'AfterClose',
      d = 'BeforeAppend',
      u = 'MarkupParse',
      p = 'Open',
      h = 'Change',
      f = 'mfp',
      v = '.' + f,
      g = 'mfp-ready',
      m = 'mfp-removing',
      w = 'mfp-prevent-close',
      y = function () {},
      b = !!window.jQuery,
      x = t(window),
      k = function (t, i) {
        e.ev.on(f + t + v, i);
      },
      T = function (e, i, n, s) {
        var o = document.createElement('div');
        return (
          (o.className = 'mfp-' + e),
          n && (o.innerHTML = n),
          s ? i && i.appendChild(o) : ((o = t(o)), i && o.appendTo(i)),
          o
        );
      },
      S = function (i, n) {
        e.ev.triggerHandler(f + i, n),
          e.st.callbacks &&
            ((i = i.charAt(0).toLowerCase() + i.slice(1)),
            e.st.callbacks[i] &&
              e.st.callbacks[i].apply(e, t.isArray(n) ? n : [n]));
      },
      C = function (i) {
        return (
          (i === r && e.currTemplate.closeBtn) ||
            ((e.currTemplate.closeBtn = t(
              e.st.closeMarkup.replace('%title%', e.st.tClose)
            )),
            (r = i)),
          e.currTemplate.closeBtn
        );
      },
      E = function () {
        t.magnificPopup.instance ||
          ((e = new y()), e.init(), (t.magnificPopup.instance = e));
      },
      j = function () {
        var t = document.createElement('p').style,
          e = ['ms', 'O', 'Moz', 'Webkit'];
        if (void 0 !== t.transition) return !0;
        for (; e.length; ) if (e.pop() + 'Transition' in t) return !0;
        return !1;
      };
    (y.prototype = {
      constructor: y,
      init: function () {
        var i = navigator.appVersion;
        (e.isIE7 = i.indexOf('MSIE 7.') !== -1),
          (e.isIE8 = i.indexOf('MSIE 8.') !== -1),
          (e.isLowIE = e.isIE7 || e.isIE8),
          (e.isAndroid = /android/gi.test(i)),
          (e.isIOS = /iphone|ipad|ipod/gi.test(i)),
          (e.supportsTransition = j()),
          (e.probablyMobile =
            e.isAndroid ||
            e.isIOS ||
            /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
              navigator.userAgent
            )),
          (n = t(document)),
          (e.popupsCache = {});
      },
      open: function (i) {
        var s;
        if (i.isObj === !1) {
          (e.items = i.items.toArray()), (e.index = 0);
          var r,
            a = i.items;
          for (s = 0; s < a.length; s++)
            if (((r = a[s]), r.parsed && (r = r.el[0]), r === i.el[0])) {
              e.index = s;
              break;
            }
        } else
          (e.items = t.isArray(i.items) ? i.items : [i.items]),
            (e.index = i.index || 0);
        if (e.isOpen) return void e.updateItemHTML();
        (e.types = []),
          (o = ''),
          i.mainEl && i.mainEl.length ? (e.ev = i.mainEl.eq(0)) : (e.ev = n),
          i.key
            ? (e.popupsCache[i.key] || (e.popupsCache[i.key] = {}),
              (e.currTemplate = e.popupsCache[i.key]))
            : (e.currTemplate = {}),
          (e.st = t.extend(!0, {}, t.magnificPopup.defaults, i)),
          (e.fixedContentPos =
            'auto' === e.st.fixedContentPos
              ? !e.probablyMobile
              : e.st.fixedContentPos),
          e.st.modal &&
            ((e.st.closeOnContentClick = !1),
            (e.st.closeOnBgClick = !1),
            (e.st.showCloseBtn = !1),
            (e.st.enableEscapeKey = !1)),
          e.bgOverlay ||
            ((e.bgOverlay = T('bg').on('click' + v, function () {
              e.close();
            })),
            (e.wrap = T('wrap')
              .attr('tabindex', -1)
              .on('click' + v, function (t) {
                e._checkIfClose(t.target) && e.close();
              })),
            (e.container = T('container', e.wrap))),
          (e.contentContainer = T('content')),
          e.st.preloader &&
            (e.preloader = T('preloader', e.container, e.st.tLoading));
        var l = t.magnificPopup.modules;
        for (s = 0; s < l.length; s++) {
          var c = l[s];
          (c = c.charAt(0).toUpperCase() + c.slice(1)), e['init' + c].call(e);
        }
        S('BeforeOpen'),
          e.st.showCloseBtn &&
            (e.st.closeBtnInside
              ? (k(u, function (t, e, i, n) {
                  i.close_replaceWith = C(n.type);
                }),
                (o += ' mfp-close-btn-in'))
              : e.wrap.append(C())),
          e.st.alignTop && (o += ' mfp-align-top'),
          e.fixedContentPos
            ? e.wrap.css({
                overflow: e.st.overflowY,
                overflowX: 'hidden',
                overflowY: e.st.overflowY
              })
            : e.wrap.css({ top: x.scrollTop(), position: 'absolute' }),
          (e.st.fixedBgPos === !1 ||
            ('auto' === e.st.fixedBgPos && !e.fixedContentPos)) &&
            e.bgOverlay.css({ height: n.height(), position: 'absolute' }),
          e.st.enableEscapeKey &&
            n.on('keyup' + v, function (t) {
              27 === t.keyCode && e.close();
            }),
          x.on('resize' + v, function () {
            e.updateSize();
          }),
          e.st.closeOnContentClick || (o += ' mfp-auto-cursor'),
          o && e.wrap.addClass(o);
        var d = (e.wH = x.height()),
          h = {};
        if (e.fixedContentPos && e._hasScrollBar(d)) {
          var f = e._getScrollbarSize();
          f && (h.marginRight = f);
        }
        e.fixedContentPos &&
          (e.isIE7
            ? t('body, html').css('overflow', 'hidden')
            : (h.overflow = 'hidden'));
        var m = e.st.mainClass;
        return (
          e.isIE7 && (m += ' mfp-ie7'),
          m && e._addClassToMFP(m),
          e.updateItemHTML(),
          S('BuildControls'),
          t('html').css(h),
          e.bgOverlay.add(e.wrap).prependTo(e.st.prependTo || t(document.body)),
          (e._lastFocusedEl = document.activeElement),
          setTimeout(function () {
            e.content
              ? (e._addClassToMFP(g), e._setFocus())
              : e.bgOverlay.addClass(g),
              n.on('focusin' + v, e._onFocusIn);
          }, 16),
          (e.isOpen = !0),
          e.updateSize(d),
          S(p),
          i
        );
      },
      close: function () {
        e.isOpen &&
          (S(l),
          (e.isOpen = !1),
          e.st.removalDelay && !e.isLowIE && e.supportsTransition
            ? (e._addClassToMFP(m),
              setTimeout(function () {
                e._close();
              }, e.st.removalDelay))
            : e._close());
      },
      _close: function () {
        S(a);
        var i = m + ' ' + g + ' ';
        if (
          (e.bgOverlay.detach(),
          e.wrap.detach(),
          e.container.empty(),
          e.st.mainClass && (i += e.st.mainClass + ' '),
          e._removeClassFromMFP(i),
          e.fixedContentPos)
        ) {
          var s = { marginRight: '' };
          e.isIE7 ? t('body, html').css('overflow', '') : (s.overflow = ''),
            t('html').css(s);
        }
        n.off('keyup' + v + ' focusin' + v),
          e.ev.off(v),
          e.wrap.attr('class', 'mfp-wrap').removeAttr('style'),
          e.bgOverlay.attr('class', 'mfp-bg'),
          e.container.attr('class', 'mfp-container'),
          !e.st.showCloseBtn ||
            (e.st.closeBtnInside && e.currTemplate[e.currItem.type] !== !0) ||
            (e.currTemplate.closeBtn && e.currTemplate.closeBtn.detach()),
          e._lastFocusedEl && t(e._lastFocusedEl).focus(),
          (e.currItem = null),
          (e.content = null),
          (e.currTemplate = null),
          (e.prevHeight = 0),
          S(c);
      },
      updateSize: function (t) {
        if (e.isIOS) {
          var i = document.documentElement.clientWidth / window.innerWidth,
            n = window.innerHeight * i;
          e.wrap.css('height', n), (e.wH = n);
        } else e.wH = t || x.height();
        e.fixedContentPos || e.wrap.css('height', e.wH), S('Resize');
      },
      updateItemHTML: function () {
        var i = e.items[e.index];
        e.contentContainer.detach(),
          e.content && e.content.detach(),
          i.parsed || (i = e.parseEl(e.index));
        var n = i.type;
        if (
          (S('BeforeChange', [e.currItem ? e.currItem.type : '', n]),
          (e.currItem = i),
          !e.currTemplate[n])
        ) {
          var o = !!e.st[n] && e.st[n].markup;
          S('FirstMarkupParse', o),
            o ? (e.currTemplate[n] = t(o)) : (e.currTemplate[n] = !0);
        }
        s && s !== i.type && e.container.removeClass('mfp-' + s + '-holder');
        var r = e['get' + n.charAt(0).toUpperCase() + n.slice(1)](
          i,
          e.currTemplate[n]
        );
        e.appendContent(r, n),
          (i.preloaded = !0),
          S(h, i),
          (s = i.type),
          e.container.prepend(e.contentContainer),
          S('AfterChange');
      },
      appendContent: function (t, i) {
        (e.content = t),
          t
            ? e.st.showCloseBtn &&
              e.st.closeBtnInside &&
              e.currTemplate[i] === !0
              ? e.content.find('.mfp-close').length || e.content.append(C())
              : (e.content = t)
            : (e.content = ''),
          S(d),
          e.container.addClass('mfp-' + i + '-holder'),
          e.contentContainer.append(e.content);
      },
      parseEl: function (i) {
        var n,
          s = e.items[i];
        if (
          (s.tagName
            ? (s = { el: t(s) })
            : ((n = s.type), (s = { data: s, src: s.src })),
          s.el)
        ) {
          for (var o = e.types, r = 0; r < o.length; r++)
            if (s.el.hasClass('mfp-' + o[r])) {
              n = o[r];
              break;
            }
          (s.src = s.el.attr('data-mfp-src')),
            s.src || (s.src = s.el.attr('href'));
        }
        return (
          (s.type = n || e.st.type || 'inline'),
          (s.index = i),
          (s.parsed = !0),
          (e.items[i] = s),
          S('ElementParse', s),
          e.items[i]
        );
      },
      addGroup: function (t, i) {
        var n = function (n) {
          (n.mfpEl = this), e._openClick(n, t, i);
        };
        i || (i = {});
        var s = 'click.magnificPopup';
        (i.mainEl = t),
          i.items
            ? ((i.isObj = !0), t.off(s).on(s, n))
            : ((i.isObj = !1),
              i.delegate
                ? t.off(s).on(s, i.delegate, n)
                : ((i.items = t), t.off(s).on(s, n)));
      },
      _openClick: function (i, n, s) {
        var o =
          void 0 !== s.midClick
            ? s.midClick
            : t.magnificPopup.defaults.midClick;
        if (o || (2 !== i.which && !i.ctrlKey && !i.metaKey)) {
          var r =
            void 0 !== s.disableOn
              ? s.disableOn
              : t.magnificPopup.defaults.disableOn;
          if (r)
            if (t.isFunction(r)) {
              if (!r.call(e)) return !0;
            } else if (x.width() < r) return !0;
          i.type && (i.preventDefault(), e.isOpen && i.stopPropagation()),
            (s.el = t(i.mfpEl)),
            s.delegate && (s.items = n.find(s.delegate)),
            e.open(s);
        }
      },
      updateStatus: function (t, n) {
        if (e.preloader) {
          i !== t && e.container.removeClass('mfp-s-' + i),
            n || 'loading' !== t || (n = e.st.tLoading);
          var s = { status: t, text: n };
          S('UpdateStatus', s),
            (t = s.status),
            (n = s.text),
            e.preloader.html(n),
            e.preloader.find('a').on('click', function (t) {
              t.stopImmediatePropagation();
            }),
            e.container.addClass('mfp-s-' + t),
            (i = t);
        }
      },
      _checkIfClose: function (i) {
        if (!t(i).hasClass(w)) {
          var n = e.st.closeOnContentClick,
            s = e.st.closeOnBgClick;
          if (n && s) return !0;
          if (
            !e.content ||
            t(i).hasClass('mfp-close') ||
            (e.preloader && i === e.preloader[0])
          )
            return !0;
          if (i === e.content[0] || t.contains(e.content[0], i)) {
            if (n) return !0;
          } else if (s && t.contains(document, i)) return !0;
          return !1;
        }
      },
      _addClassToMFP: function (t) {
        e.bgOverlay.addClass(t), e.wrap.addClass(t);
      },
      _removeClassFromMFP: function (t) {
        this.bgOverlay.removeClass(t), e.wrap.removeClass(t);
      },
      _hasScrollBar: function (t) {
        return (
          (e.isIE7 ? n.height() : document.body.scrollHeight) >
          (t || x.height())
        );
      },
      _setFocus: function () {
        (e.st.focus ? e.content.find(e.st.focus).eq(0) : e.wrap).focus();
      },
      _onFocusIn: function (i) {
        if (i.target !== e.wrap[0] && !t.contains(e.wrap[0], i.target))
          return e._setFocus(), !1;
      },
      _parseMarkup: function (e, i, n) {
        var s;
        n.data && (i = t.extend(n.data, i)),
          S(u, [e, i, n]),
          t.each(i, function (t, i) {
            if (void 0 === i || i === !1) return !0;
            if (((s = t.split('_')), s.length > 1)) {
              var n = e.find(v + '-' + s[0]);
              if (n.length > 0) {
                var o = s[1];
                'replaceWith' === o
                  ? n[0] !== i[0] && n.replaceWith(i)
                  : 'img' === o
                  ? n.is('img')
                    ? n.attr('src', i)
                    : n.replaceWith(
                        '<img src="' +
                          i +
                          '" class="' +
                          n.attr('class') +
                          '" />'
                      )
                  : n.attr(s[1], i);
              }
            } else e.find(v + '-' + t).html(i);
          });
      },
      _getScrollbarSize: function () {
        if (void 0 === e.scrollbarSize) {
          var t = document.createElement('div');
          (t.style.cssText =
            'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;'),
            document.body.appendChild(t),
            (e.scrollbarSize = t.offsetWidth - t.clientWidth),
            document.body.removeChild(t);
        }
        return e.scrollbarSize;
      }
    }),
      (t.magnificPopup = {
        instance: null,
        proto: y.prototype,
        modules: [],
        open: function (e, i) {
          return (
            E(),
            (e = e ? t.extend(!0, {}, e) : {}),
            (e.isObj = !0),
            (e.index = i || 0),
            this.instance.open(e)
          );
        },
        close: function () {
          return t.magnificPopup.instance && t.magnificPopup.instance.close();
        },
        registerModule: function (e, i) {
          i.options && (t.magnificPopup.defaults[e] = i.options),
            t.extend(this.proto, i.proto),
            this.modules.push(e);
        },
        defaults: {
          disableOn: 0,
          key: null,
          midClick: !1,
          mainClass: '',
          preloader: !0,
          focus: '',
          closeOnContentClick: !1,
          closeOnBgClick: !0,
          closeBtnInside: !0,
          showCloseBtn: !0,
          enableEscapeKey: !0,
          modal: !1,
          alignTop: !1,
          removalDelay: 0,
          prependTo: null,
          fixedContentPos: 'auto',
          fixedBgPos: 'auto',
          overflowY: 'auto',
          closeMarkup:
            '<button title="%title%" type="button" class="mfp-close">&times;</button>',
          tClose: 'Close (Esc)',
          tLoading: 'Loading...'
        }
      }),
      (t.fn.magnificPopup = function (i) {
        E();
        var n = t(this);
        if ('string' == typeof i)
          if ('open' === i) {
            var s,
              o = b ? n.data('magnificPopup') : n[0].magnificPopup,
              r = parseInt(arguments[1], 10) || 0;
            o.items
              ? (s = o.items[r])
              : ((s = n),
                o.delegate && (s = s.find(o.delegate)),
                (s = s.eq(r))),
              e._openClick({ mfpEl: s }, n, o);
          } else
            e.isOpen && e[i].apply(e, Array.prototype.slice.call(arguments, 1));
        else
          (i = t.extend(!0, {}, i)),
            b ? n.data('magnificPopup', i) : (n[0].magnificPopup = i),
            e.addGroup(n, i);
        return n;
      });
    var O,
      A,
      I,
      M = 'inline',
      $ = function () {
        I && (A.after(I.addClass(O)).detach(), (I = null));
      };
    t.magnificPopup.registerModule(M, {
      options: {
        hiddenClass: 'hide',
        markup: '',
        tNotFound: 'Content not found'
      },
      proto: {
        initInline: function () {
          e.types.push(M),
            k(a + '.' + M, function () {
              $();
            });
        },
        getInline: function (i, n) {
          if (($(), i.src)) {
            var s = e.st.inline,
              o = t(i.src);
            if (o.length) {
              var r = o[0].parentNode;
              r &&
                r.tagName &&
                (A || ((O = s.hiddenClass), (A = T(O)), (O = 'mfp-' + O)),
                (I = o.after(A).detach().removeClass(O))),
                e.updateStatus('ready');
            } else e.updateStatus('error', s.tNotFound), (o = t('<div>'));
            return (i.inlineElement = o), o;
          }
          return e.updateStatus('ready'), e._parseMarkup(n, {}, i), n;
        }
      }
    });
    var z,
      H = 'ajax',
      _ = function () {
        z && t(document.body).removeClass(z);
      },
      P = function () {
        _(), e.req && e.req.abort();
      };
    t.magnificPopup.registerModule(H, {
      options: {
        settings: null,
        cursor: 'mfp-ajax-cur',
        tError: '<a href="%url%">The content</a> could not be loaded.'
      },
      proto: {
        initAjax: function () {
          e.types.push(H),
            (z = e.st.ajax.cursor),
            k(a + '.' + H, P),
            k('BeforeChange.' + H, P);
        },
        getAjax: function (i) {
          z && t(document.body).addClass(z), e.updateStatus('loading');
          var n = t.extend(
            {
              url: i.src,
              success: function (n, s, o) {
                var r = { data: n, xhr: o };
                S('ParseAjax', r),
                  e.appendContent(t(r.data), H),
                  (i.finished = !0),
                  _(),
                  e._setFocus(),
                  setTimeout(function () {
                    e.wrap.addClass(g);
                  }, 16),
                  e.updateStatus('ready'),
                  S('AjaxContentAdded');
              },
              error: function () {
                _(),
                  (i.finished = i.loadError = !0),
                  e.updateStatus(
                    'error',
                    e.st.ajax.tError.replace('%url%', i.src)
                  );
              }
            },
            e.st.ajax.settings
          );
          return (e.req = t.ajax(n)), '';
        }
      }
    });
    var D,
      L = function (i) {
        if (i.data && void 0 !== i.data.title) return i.data.title;
        var n = e.st.image.titleSrc;
        if (n) {
          if (t.isFunction(n)) return n.call(e, i);
          if (i.el) return i.el.attr(n) || '';
        }
        return '';
      };
    t.magnificPopup.registerModule('image', {
      options: {
        markup:
          '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
        cursor: 'mfp-zoom-out-cur',
        titleSrc: 'title',
        verticalFit: !0,
        tError: '<a href="%url%">The image</a> could not be loaded.'
      },
      proto: {
        initImage: function () {
          var i = e.st.image,
            n = '.image';
          e.types.push('image'),
            k(p + n, function () {
              'image' === e.currItem.type &&
                i.cursor &&
                t(document.body).addClass(i.cursor);
            }),
            k(a + n, function () {
              i.cursor && t(document.body).removeClass(i.cursor),
                x.off('resize' + v);
            }),
            k('Resize' + n, e.resizeImage),
            e.isLowIE && k('AfterChange', e.resizeImage);
        },
        resizeImage: function () {
          var t = e.currItem;
          if (t && t.img && e.st.image.verticalFit) {
            var i = 0;
            e.isLowIE &&
              (i =
                parseInt(t.img.css('padding-top'), 10) +
                parseInt(t.img.css('padding-bottom'), 10)),
              t.img.css('max-height', e.wH - i);
          }
        },
        _onImageHasSize: function (t) {
          t.img &&
            ((t.hasSize = !0),
            D && clearInterval(D),
            (t.isCheckingImgSize = !1),
            S('ImageHasSize', t),
            t.imgHidden &&
              (e.content && e.content.removeClass('mfp-loading'),
              (t.imgHidden = !1)));
        },
        findImageSize: function (t) {
          var i = 0,
            n = t.img[0],
            s = function (o) {
              D && clearInterval(D),
                (D = setInterval(function () {
                  return n.naturalWidth > 0
                    ? void e._onImageHasSize(t)
                    : (i > 200 && clearInterval(D),
                      i++,
                      void (3 === i
                        ? s(10)
                        : 40 === i
                        ? s(50)
                        : 100 === i && s(500)));
                }, o));
            };
          s(1);
        },
        getImage: function (i, n) {
          var s = 0,
            o = function () {
              i &&
                (i.img[0].complete
                  ? (i.img.off('.mfploader'),
                    i === e.currItem &&
                      (e._onImageHasSize(i), e.updateStatus('ready')),
                    (i.hasSize = !0),
                    (i.loaded = !0),
                    S('ImageLoadComplete'))
                  : (s++, s < 200 ? setTimeout(o, 100) : r()));
            },
            r = function () {
              i &&
                (i.img.off('.mfploader'),
                i === e.currItem &&
                  (e._onImageHasSize(i),
                  e.updateStatus('error', a.tError.replace('%url%', i.src))),
                (i.hasSize = !0),
                (i.loaded = !0),
                (i.loadError = !0));
            },
            a = e.st.image,
            l = n.find('.mfp-img');
          if (l.length) {
            var c = document.createElement('img');
            (c.className = 'mfp-img'),
              i.el &&
                i.el.find('img').length &&
                (c.alt = i.el.find('img').attr('alt')),
              (i.img = t(c).on('load.mfploader', o).on('error.mfploader', r)),
              (c.src = i.src),
              l.is('img') && (i.img = i.img.clone()),
              (c = i.img[0]),
              c.naturalWidth > 0
                ? (i.hasSize = !0)
                : c.width || (i.hasSize = !1);
          }
          return (
            e._parseMarkup(n, { title: L(i), img_replaceWith: i.img }, i),
            e.resizeImage(),
            i.hasSize
              ? (D && clearInterval(D),
                i.loadError
                  ? (n.addClass('mfp-loading'),
                    e.updateStatus('error', a.tError.replace('%url%', i.src)))
                  : (n.removeClass('mfp-loading'), e.updateStatus('ready')),
                n)
              : (e.updateStatus('loading'),
                (i.loading = !0),
                i.hasSize ||
                  ((i.imgHidden = !0),
                  n.addClass('mfp-loading'),
                  e.findImageSize(i)),
                n)
          );
        }
      }
    });
    var N,
      F = function () {
        return (
          void 0 === N &&
            (N = void 0 !== document.createElement('p').style.MozTransform),
          N
        );
      };
    t.magnificPopup.registerModule('zoom', {
      options: {
        enabled: !1,
        easing: 'ease-in-out',
        duration: 300,
        opener: function (t) {
          return t.is('img') ? t : t.find('img');
        }
      },
      proto: {
        initZoom: function () {
          var t,
            i = e.st.zoom,
            n = '.zoom';
          if (i.enabled && e.supportsTransition) {
            var s,
              o,
              r = i.duration,
              c = function (t) {
                var e = t
                    .clone()
                    .removeAttr('style')
                    .removeAttr('class')
                    .addClass('mfp-animated-image'),
                  n = 'all ' + i.duration / 1e3 + 's ' + i.easing,
                  s = {
                    position: 'fixed',
                    zIndex: 9999,
                    left: 0,
                    top: 0,
                    '-webkit-backface-visibility': 'hidden'
                  },
                  o = 'transition';
                return (
                  (s['-webkit-' + o] =
                    s['-moz-' + o] =
                    s['-o-' + o] =
                    s[o] =
                      n),
                  e.css(s),
                  e
                );
              },
              d = function () {
                e.content.css('visibility', 'visible');
              };
            k('BuildControls' + n, function () {
              if (e._allowZoom()) {
                if (
                  (clearTimeout(s),
                  e.content.css('visibility', 'hidden'),
                  (t = e._getItemToZoom()),
                  !t)
                )
                  return void d();
                (o = c(t)),
                  o.css(e._getOffset()),
                  e.wrap.append(o),
                  (s = setTimeout(function () {
                    o.css(e._getOffset(!0)),
                      (s = setTimeout(function () {
                        d(),
                          setTimeout(function () {
                            o.remove(), (t = o = null), S('ZoomAnimationEnded');
                          }, 16);
                      }, r));
                  }, 16));
              }
            }),
              k(l + n, function () {
                if (e._allowZoom()) {
                  if ((clearTimeout(s), (e.st.removalDelay = r), !t)) {
                    if (((t = e._getItemToZoom()), !t)) return;
                    o = c(t);
                  }
                  o.css(e._getOffset(!0)),
                    e.wrap.append(o),
                    e.content.css('visibility', 'hidden'),
                    setTimeout(function () {
                      o.css(e._getOffset());
                    }, 16);
                }
              }),
              k(a + n, function () {
                e._allowZoom() && (d(), o && o.remove(), (t = null));
              });
          }
        },
        _allowZoom: function () {
          return 'image' === e.currItem.type;
        },
        _getItemToZoom: function () {
          return !!e.currItem.hasSize && e.currItem.img;
        },
        _getOffset: function (i) {
          var n;
          n = i
            ? e.currItem.img
            : e.st.zoom.opener(e.currItem.el || e.currItem);
          var s = n.offset(),
            o = parseInt(n.css('padding-top'), 10),
            r = parseInt(n.css('padding-bottom'), 10);
          s.top -= t(window).scrollTop() - o;
          var a = {
            width: n.width(),
            height: (b ? n.innerHeight() : n[0].offsetHeight) - r - o
          };
          return (
            F()
              ? (a['-moz-transform'] = a.transform =
                  'translate(' + s.left + 'px,' + s.top + 'px)')
              : ((a.left = s.left), (a.top = s.top)),
            a
          );
        }
      }
    });
    var q = 'iframe',
      B = '//about:blank',
      R = function (t) {
        if (e.currTemplate[q]) {
          var i = e.currTemplate[q].find('iframe');
          i.length &&
            (t || (i[0].src = B),
            e.isIE8 && i.css('display', t ? 'block' : 'none'));
        }
      };
    t.magnificPopup.registerModule(q, {
      options: {
        markup:
          '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
        srcAction: 'iframe_src',
        patterns: {
          youtube: {
            index: 'youtube.com',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?autoplay=1'
          },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1'
          },
          gmaps: { index: '//maps.google.', src: '%id%&output=embed' }
        }
      },
      proto: {
        initIframe: function () {
          e.types.push(q),
            k('BeforeChange', function (t, e, i) {
              e !== i && (e === q ? R() : i === q && R(!0));
            }),
            k(a + '.' + q, function () {
              R();
            });
        },
        getIframe: function (i, n) {
          var s = i.src,
            o = e.st.iframe;
          t.each(o.patterns, function () {
            if (s.indexOf(this.index) > -1)
              return (
                this.id &&
                  (s =
                    'string' == typeof this.id
                      ? s.substr(
                          s.lastIndexOf(this.id) + this.id.length,
                          s.length
                        )
                      : this.id.call(this, s)),
                (s = this.src.replace('%id%', s)),
                !1
              );
          });
          var r = {};
          return (
            o.srcAction && (r[o.srcAction] = s),
            e._parseMarkup(n, r, i),
            e.updateStatus('ready'),
            n
          );
        }
      }
    });
    var W = function (t) {
        var i = e.items.length;
        return t > i - 1 ? t - i : t < 0 ? i + t : t;
      },
      X = function (t, e, i) {
        return t.replace(/%curr%/gi, e + 1).replace(/%total%/gi, i);
      };
    t.magnificPopup.registerModule('gallery', {
      options: {
        enabled: !1,
        arrowMarkup:
          '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
        preload: [0, 2],
        navigateByImgClick: !0,
        arrows: !0,
        tPrev: 'Previous (Left arrow key)',
        tNext: 'Next (Right arrow key)',
        tCounter: '%curr% of %total%'
      },
      proto: {
        initGallery: function () {
          var i = e.st.gallery,
            s = '.mfp-gallery',
            r = Boolean(t.fn.mfpFastClick);
          return (
            (e.direction = !0),
            !(!i || !i.enabled) &&
              ((o += ' mfp-gallery'),
              k(p + s, function () {
                i.navigateByImgClick &&
                  e.wrap.on('click' + s, '.mfp-img', function () {
                    if (e.items.length > 1) return e.next(), !1;
                  }),
                  n.on('keydown' + s, function (t) {
                    37 === t.keyCode ? e.prev() : 39 === t.keyCode && e.next();
                  });
              }),
              k('UpdateStatus' + s, function (t, i) {
                i.text &&
                  (i.text = X(i.text, e.currItem.index, e.items.length));
              }),
              k(u + s, function (t, n, s, o) {
                var r = e.items.length;
                s.counter = r > 1 ? X(i.tCounter, o.index, r) : '';
              }),
              k('BuildControls' + s, function () {
                if (e.items.length > 1 && i.arrows && !e.arrowLeft) {
                  var n = i.arrowMarkup,
                    s = (e.arrowLeft = t(
                      n.replace(/%title%/gi, i.tPrev).replace(/%dir%/gi, 'left')
                    ).addClass(w)),
                    o = (e.arrowRight = t(
                      n
                        .replace(/%title%/gi, i.tNext)
                        .replace(/%dir%/gi, 'right')
                    ).addClass(w)),
                    a = r ? 'mfpFastClick' : 'click';
                  s[a](function () {
                    e.prev();
                  }),
                    o[a](function () {
                      e.next();
                    }),
                    e.isIE7 &&
                      (T('b', s[0], !1, !0),
                      T('a', s[0], !1, !0),
                      T('b', o[0], !1, !0),
                      T('a', o[0], !1, !0)),
                    e.container.append(s.add(o));
                }
              }),
              k(h + s, function () {
                e._preloadTimeout && clearTimeout(e._preloadTimeout),
                  (e._preloadTimeout = setTimeout(function () {
                    e.preloadNearbyImages(), (e._preloadTimeout = null);
                  }, 16));
              }),
              void k(a + s, function () {
                n.off(s),
                  e.wrap.off('click' + s),
                  e.arrowLeft &&
                    r &&
                    e.arrowLeft.add(e.arrowRight).destroyMfpFastClick(),
                  (e.arrowRight = e.arrowLeft = null);
              }))
          );
        },
        next: function () {
          (e.direction = !0), (e.index = W(e.index + 1)), e.updateItemHTML();
        },
        prev: function () {
          (e.direction = !1), (e.index = W(e.index - 1)), e.updateItemHTML();
        },
        goTo: function (t) {
          (e.direction = t >= e.index), (e.index = t), e.updateItemHTML();
        },
        preloadNearbyImages: function () {
          var t,
            i = e.st.gallery.preload,
            n = Math.min(i[0], e.items.length),
            s = Math.min(i[1], e.items.length);
          for (t = 1; t <= (e.direction ? s : n); t++)
            e._preloadItem(e.index + t);
          for (t = 1; t <= (e.direction ? n : s); t++)
            e._preloadItem(e.index - t);
        },
        _preloadItem: function (i) {
          if (((i = W(i)), !e.items[i].preloaded)) {
            var n = e.items[i];
            n.parsed || (n = e.parseEl(i)),
              S('LazyLoad', n),
              'image' === n.type &&
                (n.img = t('<img class="mfp-img" />')
                  .on('load.mfploader', function () {
                    n.hasSize = !0;
                  })
                  .on('error.mfploader', function () {
                    (n.hasSize = !0), (n.loadError = !0), S('LazyLoadError', n);
                  })
                  .attr('src', n.src)),
              (n.preloaded = !0);
          }
        }
      }
    });
    var U = 'retina';
    t.magnificPopup.registerModule(U, {
      options: {
        replaceSrc: function (t) {
          return t.src.replace(/\.\w+$/, function (t) {
            return '@2x' + t;
          });
        },
        ratio: 1
      },
      proto: {
        initRetina: function () {
          if (window.devicePixelRatio > 1) {
            var t = e.st.retina,
              i = t.ratio;
            (i = isNaN(i) ? i() : i),
              i > 1 &&
                (k('ImageHasSize.' + U, function (t, e) {
                  e.img.css({
                    'max-width': e.img[0].naturalWidth / i,
                    width: '100%'
                  });
                }),
                k('ElementParse.' + U, function (e, n) {
                  n.src = t.replaceSrc(n, i);
                }));
          }
        }
      }
    }),
      (function () {
        var e = 1e3,
          i = 'ontouchstart' in window,
          n = function () {
            x.off('touchmove' + o + ' touchend' + o);
          },
          s = 'mfpFastClick',
          o = '.' + s;
        (t.fn.mfpFastClick = function (s) {
          return t(this).each(function () {
            var r,
              a = t(this);
            if (i) {
              var l, c, d, u, p, h;
              a.on('touchstart' + o, function (t) {
                (u = !1),
                  (h = 1),
                  (p = t.originalEvent
                    ? t.originalEvent.touches[0]
                    : t.touches[0]),
                  (c = p.clientX),
                  (d = p.clientY),
                  x
                    .on('touchmove' + o, function (t) {
                      (p = t.originalEvent
                        ? t.originalEvent.touches
                        : t.touches),
                        (h = p.length),
                        (p = p[0]),
                        (Math.abs(p.clientX - c) > 10 ||
                          Math.abs(p.clientY - d) > 10) &&
                          ((u = !0), n());
                    })
                    .on('touchend' + o, function (t) {
                      n(),
                        u ||
                          h > 1 ||
                          ((r = !0),
                          t.preventDefault(),
                          clearTimeout(l),
                          (l = setTimeout(function () {
                            r = !1;
                          }, e)),
                          s());
                    });
              });
            }
            a.on('click' + o, function () {
              r || s();
            });
          });
        }),
          (t.fn.destroyMfpFastClick = function () {
            t(this).off('touchstart' + o + ' click' + o),
              i && x.off('touchmove' + o + ' touchend' + o);
          });
      })(),
      E();
  }),
  (function (t, e) {
    function i(e, i) {
      var s;
      return (s = t.data(e, r)) ? s : t.data(e, r, new n(e, i));
    }
    function n(e, i) {
      function n(e, i) {
        t(document).on('touchstart', w),
          (p.hasFocus = !0),
          (h = 'sxy-focus'),
          e && e(i),
          (h = 'sxy-hover');
      }
      function s() {
        t(document).off('touchstart', w),
          (p.hasFocus = !1),
          (h = 'sxy-blur'),
          p.el.triggerHandler(h),
          (h = 'sxy-hover');
      }
      function r(t) {
        (u = t), (f.x = t.pageX), (f.y = t.pageY), (p.pt = [f]), p.trigger(h);
      }
      function c(t) {
        (u = t), (t = t.originalEvent.targetTouches);
        for (var e = (p.pt = []), i = 0, n = t.length; i < n; ++i)
          e.push({ x: t[i].pageX, y: t[i].pageY, type: 1, down: !0 });
        p.trigger(h);
      }
      function d(t, e, i, n) {
        for (
          v.push((t = { e: t, hnd: i, l: 0, el: n || p.el })),
            i = 0,
            n = e.length;
          i < n;
          ++i
        )
          g[l[e[i]]].push(t);
      }
      var u,
        p = this,
        h = 'sxy-hover',
        f = { x: 0, y: 0, down: !1, type: 0 },
        v = [],
        g = {};
      (this.options = i = t.extend({}, a, t.isPlainObject(i) ? i : {})),
        (this.el = t(e)),
        (this.pt = []),
        (this.g = {}),
        (this.h = {}),
        (this.hasFocus = !1);
      for (var m = 0; m < l.length; ++m) g[l[m]] = [];
      o ||
        (d('mouseenter', [0, 2, 4], function (t) {
          p.hasFocus || n(r, t), (h = 'sxy-hover'), r(t);
        }),
        d('mouseleave', [1, 2, 5], function (t) {
          (h = f.down ? 'sxy-up' : 'sxy-hover'), (f.down = !1), r(t), s(r, t);
        }),
        d('mousedown', [3, 4], function (t) {
          (h = 'sxy-down'), (f.down = !0), r(t), (h = 'sxy-move');
        }),
        d('mouseup', [0, 1, 2, 3, 4, 5], function (t) {
          (h = 'sxy-up'), (f.down = !1), r(t), (h = 'sxy-hover');
        }),
        d('mousemove', [2, 4], r)),
        d('touchstart', [0, 1, 2, 3, 4, 5], function (t) {
          (h = 'sxy-down'), p.hasFocus || n(c, t), c(t), (h = 'sxy-move');
        }),
        d('touchend', [0, 1, 2, 3, 4, 5], function (t) {
          (h = 'sxy-up'), (u = t);
          var e = t.originalEvent.targetTouches;
          t = t.originalEvent.changedTouches;
          for (var i = (p.pt = []), n = 0, s = e.length; n < s; ++n)
            i.push({ x: e[n].pageX, y: e[n].pageY, type: 1, down: !0 });
          for (n = 0, s = t.length; n < s; ++n)
            i.push({ x: t[n].pageX, y: t[n].pageY, type: 1, down: !1 });
          p.trigger(h), (h = 'sxy-hover');
        }),
        d('touchmove', [0, 1, 2, 3, 4, 5], c);
      var w = function (t) {
          for (var e = !0, i = p.pt, n = 0, o = i.length; n < o; ++n)
            if (1 == i[n].down) {
              e = !1;
              break;
            }
          e && s(c, t);
        },
        y = t.Event;
      (this.trigger = function (t, e) {
        this.options.preventDefault && u.preventDefault(),
          (e = e || {}),
          (e.pointers = p.pt),
          (e.originalEvent = u),
          p.el.trigger(y(t, e));
      }),
        (this.eventEnabler = function (t, e) {
          for (var i, n = g[t], s = e ? 1 : -1, o = 0, r = n.length; o < r; ++o)
            switch (((i = n[o]).l += s)) {
              case 0:
                i.el.off(i.e, i.hnd);
                break;
              case 1:
                i.el.on(i.e, i.hnd);
            }
        }),
        (p.focus = n),
        (p.blur = s);
    }
    for (
      var s = navigator.userAgent.toLowerCase(),
        o = -1 < s.indexOf('android') && -1 < s.indexOf('mobile'),
        r = 'swinxytouch',
        a = { preventDefault: !0, stopPropagation: !1 },
        l = 'sxy-focus sxy-blur sxy-hover sxy-down sxy-move sxy-up'.split(' '),
        s = function (t) {
          return function () {
            i(this).eventEnabler(t, !0);
          };
        },
        c = function (t) {
          return function () {
            i(this).eventEnabler(t, !1);
          };
        },
        d = 0,
        u = l.length;
      d < u;
      ++d
    ) {
      var p = l[d];
      t.event.special[p] = { setup: s(p), teardown: c(p) };
    }
    (t.fn[r] = function (t) {
      return this.each(function () {
        var e = i(this, t);
        t && e[t] && e[t].apply(e, Array.prototype.slice.call(arguments, 1));
      });
    }),
      (t.fn[r].g = function (e, n, s) {
        t.event.special[e] = {
          setup: function () {
            var o,
              r = i(this);
            (o = r.g[e] =
              new n(r, r.options[e] ? t.extend({}, s, r.options[e]) : s)),
              t.each(o, function (t, e) {
                'sxy-' == t.substr(0, 4) && r.el.on(t, o[t]);
              });
          },
          teardown: function () {
            var n = i(this),
              s = n.g[e];
            t.each(s, function (t, e) {
              'sxy-' == t.substr(0, 4) && n.el.off(t, s[t]);
            }),
              (n.g[e] = null);
          }
        };
      }),
      (t.fn[r].d = function (t, e) {
        var i = t.x - e.x,
          n = t.y - e.y;
        return Math.sqrt(i * i + n * n);
      }),
      (t.fn[r].a = function (t, e) {
        var i;
        return 0 < (i = Math.atan2(t.y - e.y, t.x - e.x))
          ? (180 / Math.PI) * i
          : (180 / Math.PI) * (2 * Math.PI + i);
      }),
      (t.fn[r].h = function (t, e) {
        n.prototype[t] = function () {
          this.h[t] = new e(this);
        };
      }),
      (t.fn[r].m = function (t, e) {
        return { x: (t.x + e.x) / 2, y: (t.y + e.y) / 2 };
      });
  })(jQuery),
  (function (t, e) {
    t.fn.swinxytouch.g(
      'sxy-doubletap',
      function (t, e) {
        var i,
          n,
          s = Math.abs;
        this['sxy-tap'] = function (o) {
          (o = o.position),
            null != i &&
            new Date().getTime() - i < e.maxDelay &&
            s(n.x - o.x) < e.maxMove &&
            s(n.y - o.y) < e.maxMove
              ? (t.trigger('sxy-doubletap', { position: n }), (i = null))
              : ((i = new Date().getTime()), (n = { x: o.x, y: o.y }));
        };
      },
      { maxDelay: 300, maxMove: 4 }
    );
  })(jQuery),
  (function (t, e) {
    t.fn.swinxytouch.g('sxy-drag', function (t) {
      function e(e, i) {
        var s = e.pointers;
        (n.state = i),
          0 < s.length && ((n.position.x = s[0].x), (n.position.y = s[0].y)),
          t.trigger('sxy-drag', n);
      }
      var i,
        n = { position: {} };
      (this['sxy-up'] = function (t) {
        i && e(t, 3), (i = !1);
      }),
        (this['sxy-move'] = function (t) {
          1 == t.pointers.length && (i ? e(t, 2) : ((i = !0), e(t, 1)));
        });
    });
  })(jQuery),
  (function (t, e) {
    t.fn.swinxytouch.g(
      'sxy-longpress',
      function (t, e) {
        var i,
          n = {},
          s = function () {
            var s = t.pt,
              o = Math.abs;
            (i = null),
              o(n.x - s[0].x) < e.maxMove &&
                o(n.y - s[0].y) < e.maxMove &&
                t.trigger('sxy-longpress', { position: n });
          };
        (this['sxy-down'] = function (t) {
          (t = t.pointers),
            (n = { x: t[0].x, y: t[0].y }),
            i && clearTimeout(i),
            (i = setTimeout(s, e.minDelay));
        }),
          (this['sxy-up'] = function (t) {
            clearTimeout(i);
          });
      },
      { minDelay: 1e3, maxMove: 5 }
    );
  })(jQuery),
  (function (t, e) {
    t.fn.swinxytouch.g(
      'sxy-rotate',
      function (e, i) {
        function n(t, i) {
          var n, s;
          (l.state = i),
            (l.rotation +=
              180 > Math.abs((n = (s = a(t.pointers[0], t.pointers[1])) - r))
                ? n
                : 0),
            (r = s),
            e.trigger('sxy-rotate', l);
        }
        var s,
          o,
          r,
          a = t.fn.swinxytouch.a,
          l = {};
        (this['sxy-down'] = function (t) {
          2 == t.pointers.length &&
            ((s = !1), (o = r = a(t.pointers[0], t.pointers[1])));
        }),
          (this['sxy-up'] = function (t) {
            s && ((s = !1), n(t, 3));
          }),
          (this['sxy-move'] = function (t) {
            var e = t.pointers;
            2 == e.length &&
              (s
                ? n(t, 2)
                : Math.abs(o - a(e[0], e[1])) > i.minRotate &&
                  ((s = !0), (l.rotation = 0), n(t, 1)));
          });
      },
      { minRotate: 3 }
    );
  })(jQuery),
  (function (t, e) {
    t.fn.swinxytouch.g(
      'sxy-scale',
      function (e, i) {
        function n(t, i) {
          var n = t.pointers,
            s = r(n[0], n[1]);
          (l.state = i),
            (l.scale = s / o),
            (l.distance = s - o),
            (l.position = a(n[0], n[1])),
            e.trigger('sxy-scale', l);
        }
        var s,
          o,
          r = t.fn.swinxytouch.d,
          a = t.fn.swinxytouch.m,
          l = {};
        (this['sxy-down'] = function (t) {
          (t = t.pointers),
            2 == t.length &&
              ((s = !1),
              (o = r({ x: t[0].x, y: t[0].y }, { x: t[1].x, y: t[1].y })));
        }),
          (this['sxy-up'] = function (t) {
            s && n(t, 3);
          }),
          (this['sxy-move'] = function (t) {
            var e = t.pointers;
            2 == e.length &&
              (s
                ? n(t, 2)
                : Math.abs(1 - r(e[0], e[1]) / o) > i.minScale &&
                  ((s = !0), n(t, 1)));
          });
      },
      { minScale: 0.2 }
    );
  })(jQuery),
  (function (t, e) {
    t.fn.swinxytouch.g(
      'sxy-swipe',
      function (e, i) {
        var n,
          s,
          o = t.fn.swinxytouch.d,
          r = t.fn.swinxytouch.a,
          a = {};
        (this['sxy-down'] = function (t) {
          (t = t.pointers),
            (n = new Date().getTime()),
            (s = { x: t[0].x, y: t[0].y });
        }),
          (this['sxy-up'] = function (t) {
            (t = t.pointers),
              new Date().getTime() - n < i.maxTime &&
                o(s, t[0]) > i.minMove &&
                ((a.direction =
                  i.map[
                    Math.round(r(s, t[0]) / (360 / i.map.length)) % i.map.length
                  ]),
                (a.distance = Math.abs(o(s, t[0]))),
                e.trigger('sxy-swipe', a));
          });
      },
      { maxTime: 300, minMove: 10, map: ['left', 'up', 'right', 'down'] }
    );
  })(jQuery),
  (function (t, e) {
    t.fn.swinxytouch.g(
      'sxy-tap',
      function (t, e) {
        var i,
          n,
          s = Math.abs;
        (this['sxy-down'] = function (t) {
          (t = t.pointers),
            1 == t.length &&
              ((i = new Date().getTime()), (n = { x: t[0].x, y: t[0].y }));
        }),
          (this['sxy-up'] = function (o) {
            (o = o.pointers),
              1 == o.length &&
                new Date().getTime() - i < e.maxDelay &&
                s(n.x - o[0].x) < e.maxMove &&
                s(n.y - o[0].y) < e.maxMove &&
                t.trigger('sxy-tap', { position: n });
          });
      },
      { maxDelay: 150, maxMove: 2 }
    );
  })(jQuery),
  (function (t, e) {
    t.fn.swinxytouch.h('bound', function (e) {
      var i = e.el.offset(),
        n = i.left,
        s = i.top,
        o = n + e.el.width(),
        r = s + e.el.height();
      e.el.on('sxy-hover sxy-down sxy-up sxy-move sxy-focus', function (i) {
        var a = i.pointers[0];
        a.y < s || a.x > o || a.y > r || a.x < n
          ? e.hasFocus && e.blur()
          : e.hasFocus ||
            (e.focus(),
            e.el.trigger(
              t.Event('sxy-focus', {
                pointers: i.pointers,
                originalEvent: i.originalEvent
              })
            ));
      });
    });
  })(jQuery),
  (function (t, e) {
    t.fn.swinxytouch.h('smartclick', function (e) {
      var i = this;
      (i.allow = !1),
        (i._hndClick = function (t) {
          i.allow || t.preventDefault(), (i.allow = !1);
        }),
        (i._hndTap = function (e) {
          (i.allow = !0), t(e.originalEvent.target).trigger('click');
        }),
        e.el.on('click', i._hndClick),
        e.el.on('sxy-tap', i._hndTap);
    });
  })(jQuery),
  (function (t, e) {
    function i(i, n) {
      (this.e = i.get(0)), (this.j = i.first()), n != e && t.extend(this, n);
    }
    function n(e, i) {
      var n = this;
      (n.element = t(e)),
        (n.options = t.extend({}, s, i)),
        (n.driver = new t.fn.swinxyzoom.modes[n.options.mode](this)),
        (n.initialised = !1),
        (n.enabled = !1),
        (n.waiting = null),
        n.element.css({ cursor: 'default' }),
        (n.dmp = { cX: 0, tX: 0, cY: 0, tY: 0, timer: !1 }),
        (n.last = !1),
        (n.hasFocus = !1),
        (n._animate = function () {
          var t = n.dmp,
            e = n.si.e.style,
            i = n.options.damping,
            s = t.tX - t.cX,
            o = t.tY - t.cY;
          (e.left = (t.cX += s / i) + 'px'),
            (e.top = (t.cY += o / i) + 'px'),
            0 == ~~s && 0 == ~~o && (clearTimeout(t.timer), (t.timer = !1));
        }),
        (n._moveSlider = function (t) {
          t = t.pointers[0].y;
          var e = n.ct.sl.j.offset(),
            i = n.maxZoom / n.ct.sl.j.height();
          (t = n.ct.sl.j.height() - (t - e.top)),
            n.zoom(t * i, n.cursor.lastX, n.cursor.lastY);
        }),
        (n._focus = function () {
          var t = n.dp.j.offset();
          (n.dp.ol = t.left),
            (n.dp.ot = t.top),
            (n.hasFocus = !0),
            n.options.controls &&
              (n.ct.j.show(),
              n.ct.ol.j.stop().animate({ opacity: 0.5 }, { queue: !1 }),
              n.ct.j.show()),
            !1 === n.last ||
              (n.last.w == n.rt.j.width() && n.last.h == n.rt.j.height()) ||
              n.rebuild(function () {
                n.zoom(n.maxZoom, n.cursor.lastX, n.cursor.lastY),
                  n.driver.load &&
                    n.driver.load(n.cursor.lastX, n.cursor.lastY),
                  n.zoom(n.maxZoom, n.cursor.lastX, n.cursor.lastY);
              }),
            (n.last = { w: n.rt.j.width(), h: n.rt.j.height() });
        }),
        (n._blur = function (t) {
          (n.hasFocus = !1),
            n.options.controls &&
              (n.ct.j.hide(),
              n.ct.ol.j
                .stop()
                .animate(
                  { opacity: 0 },
                  { queue: !1, complete: function () {} }
                ));
        }),
        (n._mousewheel = function (t, e, i, s) {
          t.preventDefault(),
            n.zoom(
              n.level + Math.round((n.maxZoom / n.options.steps) * s),
              t.pageX,
              t.pageY
            );
        }),
        (n._stepIn = function (t) {
          t.preventDefault(),
            n.zoom(
              n.level + Math.round((n.maxZoom / n.options.steps) * 1),
              n.cursor.lastX,
              n.cursor.lastY
            );
        }),
        (n._stepOut = function (t) {
          t.preventDefault(),
            n.zoom(
              n.level + Math.round((n.maxZoom / n.options.steps) * -1),
              n.cursor.lastX,
              n.cursor.lastY
            );
        });
      var o;
      (n._scale = []),
        (n._scale[1] = function (e) {
          (o = n.level), t('#info').append('start[' + o + '] ');
        }),
        (n._scale[2] = function (e) {
          t('#info').append('s '),
            t('#info').append(
              's[' + Math.abs(o * e.scale) + ',' + e.position.x + '] '
            ),
            n.zoom(o * e.scale, e.position.x, e.position.y);
        }),
        (n._scale[3] = function (t) {});
      var r = n.element.children().first().attr('src'),
        a = n.element.attr('href'),
        l = new Image();
      (l.onload = function () {
        n.load(r, a);
      }),
        (l.src = r);
    }
    var s = {
      damping: 8,
      steps: 15,
      mode: 'dock',
      zoom: 15,
      controls: !0,
      size: 'actual'
    };
    (n.prototype.load = function (t, e, i) {
      var n = this;
      t || (t = n.dp.tn.src), e || (e = n.si.src);
      var s = function () {
        i && n._focus(),
          (n.dp.tn.src = t),
          (n.si.src = e),
          n.dp.tn.j.attr('src') != n.dp.tn.src &&
            (n.dp.tn.j.one('load', function () {
              'actual' == n.options.size &&
                n.rt.j.css({
                  width: n.dp.tn.j.width(),
                  height: n.dp.tn.j.height()
                }),
                n.dp.tn.j.stop().animate(
                  { opacity: 1 },
                  {
                    queue: !1,
                    complete: function () {
                      n.rt.bg.j.attr('src', n.dp.tn.src),
                        n.dp.tn.j.css({ opacity: 0 });
                    }
                  }
                );
            }),
            n.dp.tn.j.attr('src', n.dp.tn.src));
        var s = function (t, e) {
          var i;
          n.si.j.one('load', function () {
            n.dp.j.off('sxy-move sxy-hover', i),
              (n.waiting = null),
              n.rebuild(function () {
                n.zoom(
                  (n.maxZoom / n.options.steps) * n.options.zoom,
                  n.cursor.lastX,
                  n.cursor.lastY
                ),
                  n.driver.load &&
                    n.driver.load(n.cursor.lastX, n.cursor.lastY),
                  n.zoom(
                    (n.maxZoom / n.options.steps) * n.options.zoom,
                    n.cursor.lastX,
                    n.cursor.lastY
                  ),
                  n.rt.j.toggleClass('sxy-zoom-loading');
              });
          }),
            (n.cursor = { lastX: t, lastY: e }),
            n.dp.j.on(
              'sxy-move sxy-hover',
              (i = function (t) {
                (t = t.pointers[0]), (n.cursor = { lastX: t.x, lastY: t.y });
              })
            ),
            n.si.j.attr('src', n.si.src);
        };
        i
          ? ((n.waiting = null),
            n.rt.j.toggleClass('sxy-zoom-loading'),
            s(0, 0))
          : n.waiting ||
            n.rt.j.one(
              'sxy-focus',
              (n.waiting = function (t) {
                n.rt.j.toggleClass('sxy-zoom-loading'),
                  s(t.pointers[0].x, t.pointers[0].y);
              })
            );
      };
      0 == n.initialised ? n.tearUp(s) : s();
    }),
      (n.prototype.getNaturalSize = function (t, e) {
        var i = new Image();
        (i.onload = function () {
          e({ w: i.width, h: i.height });
        }),
          (i.src = t);
      }),
      (n.prototype.rebuild = function (e) {
        var i = this,
          n = i.dp,
          s = i.vp,
          o = i.si,
          r = i.vf;
        switch (
          (t.extend(n, {
            w: 'actual' == i.options.size ? n.tn.j.width() : i.rt.j.width(),
            h: 'actual' == i.options.size ? n.tn.j.height() : i.rt.j.height(),
            ol: n.j.offset().left,
            ot: n.j.offset().top,
            hyp: Math.round(
              Math.sqrt(
                Math.pow(n.tn.j.width(), 2) + Math.pow(n.tn.j.height(), 2)
              )
            )
          }),
          i.options.size)
        ) {
          case 'actual':
            i.rt.j.css({ width: n.w, height: n.h });
            break;
          case 'src':
            i.rt.j.css({ width: n.w, height: n.h });
        }
        t.extend(s, { w: n.w, h: n.h }),
          i.vp.j.css({ width: n.w, height: n.h }),
          i.getNaturalSize(i.si.src, function (s) {
            t.extend(o, {
              w: 0,
              h: 0,
              l: 0,
              t: 0,
              mL: 0,
              mT: 0,
              oHyp: Math.round(Math.sqrt(Math.pow(s.w, 2) + Math.pow(s.h, 2))),
              oH: s.h,
              oW: s.w
            }),
              t.extend(r, { w: 0, h: 0, l: 0, t: 0 }),
              i.ct.sl.j.css({
                height: (i.ct.sl.h =
                  i.ct.j.height() -
                  (i.ct.zin.j.outerHeight() + i.ct.zout.j.outerHeight()))
              }),
              (i.ct.sl.h -= 16),
              clearTimeout(i.dmp.timer),
              (i.dmp = { cX: 0, tX: 0, cY: 0, tY: 0, timer: !1 }),
              (i.scale = Math.atan(i.si.oH / i.si.oW)),
              (i.angle = 0),
              (i.maxZoom = o.oHyp - n.hyp),
              (i.level = 0),
              e();
          });
      }),
      (n.prototype.tearUp = function (e) {
        var n = this;
        (n.initialised = !0),
          (n.el = new i(n.element)),
          (n.el.tn = new i(n.element.children())),
          n.getNaturalSize(n.el.tn.j.attr('src'), function (s) {
            var o, r;
            switch (n.options.size) {
              case 'actual':
                (o = s.w + 'px'), (r = s.h + 'px');
                break;
              case 'src':
                (o = n.el.tn.j.attr('width') + 'px'), (r = 'auto');
                break;
              default:
                (o = n.options.size), (r = 'auto');
            }
            var a = {
              w: o,
              h: r,
              srcthumb: n.el.tn.j.attr('src'),
              mode: n.options.mode,
              auto:
                'auto' == r
                  ? '<div style="padding-top: ' + (100 / s.w) * s.h + '%;" />'
                  : ''
            };
            n.el.j.wrap(
              '<div class="sxy-zoom-container sxy-zoom-mode-{mode}" style="width: {w}; height: {h}; position: relative;" ></div>'.replace(
                /\{(\w+)\}/g,
                function (t, e) {
                  return a[e] || t;
                }
              )
            ),
              n.element.hide(),
              (n.rt = new i(n.el.j.parent())),
              n.rt.j.append(
                '<img class="sxy-zoom-bg" src="{srcthumb}" />{auto}<div class="sxy-controls"><div class="overlay"></div><a class="in" href="#"></a><div class="sxy-slider"><div class="sxy-handle" style="top: 0px;"></div></div><a class="out" href="#"></a></div><div class="sxy-zoom-dragpad"><div class="sxy-overlay"></div><div class="sxy-zoom-viewport"><img galleryimg="no" /></div><img class="inner-thumb" src="{srcthumb}" /><div class="sxy-zoom-viewfinder"></div></div><div class="sxy-loading"><span></span></div>'.replace(
                  /\{(\w+)\}/g,
                  function (t, e) {
                    return a[e] || t;
                  }
                )
              ),
              (n.rt.bg = new i(n.rt.j.find('.sxy-zoom-bg'))),
              n.rt.j.on('dragstart', function (t) {
                return !1;
              }),
              (n.ct = new i(n.rt.j.find('.sxy-controls').hide())),
              (n.ct.ol = new i(n.ct.j.find('.overlay'))),
              (n.ct.zin = new i(n.ct.j.find('.in'))),
              (n.ct.zout = new i(n.ct.j.find('.out'))),
              (n.ct.sl = new i(n.ct.j.find('.sxy-slider').first(), { h: 0 })),
              (n.ct.hnd = new i(n.ct.j.find('.sxy-handle'))),
              (n.dp = new i(n.rt.j.find('.sxy-zoom-dragpad').first(), {
                w: 0,
                h: 0,
                ol: 0,
                ot: 0,
                hyp: 0
              })),
              (n.dp.ovl = new i(n.dp.j.find('.sxy-overlay'))),
              (n.dp.tn = new i(
                n.dp.j.find('.inner-thumb').css({ opacity: 0 }),
                { src: '' }
              )),
              (n.vp = new i(
                n.dp.j.find('.sxy-zoom-viewport').css({ opacity: 0 }),
                { w: 0, h: 0 }
              )),
              (n.si = new i(n.vp.j.find('img'), {
                w: 0,
                h: 0,
                l: 0,
                t: 0,
                mL: 0,
                mT: 0,
                oHyp: 0,
                oH: 0,
                oW: 0,
                src: ''
              })),
              (n.vf = new i(
                n.dp.j.find('.sxy-zoom-viewfinder').css({ display: 'none' }),
                { w: 0, h: 0, l: 0, t: 0, osl: 0, ost: 0 }
              )),
              n.rt.j.on('sxy-focus', n._focus),
              n.rt.j.on('sxy-blur', n._blur),
              t.event.special.mousewheel &&
                n.rt.j.on('mousewheel', n._mousewheel),
              n.dp.j.on('sxy-scale', function (t) {
                n._scale[t.state](t);
              }),
              n.ct.zin.j.on('click', n._stepIn),
              n.ct.zout.j.on('click', n._stepOut),
              n.ct.sl.j.on('sxy-down sxy-move', n._moveSlider),
              e();
          });
      }),
      (n.prototype.move = function (t, e, i) {
        var n = (t / this.scale) * -1,
          s = (e / this.scale) * -1;
        (this.cursor.lastX = n + this.vf.w / 2 + this.dp.ol),
          (this.cursor.lastY = s + this.vf.h / 2 + this.dp.ot),
          0 > n && (n = t = 0),
          0 > s && (s = e = 0),
          n + this.vf.w > this.dp.w &&
            ((n = this.dp.w - this.vf.w), (t = this.si.mL)),
          s + this.vf.h > this.dp.h &&
            ((s = this.dp.h - this.vf.h), (e = this.si.mT)),
          (this.vf.l = ~~n),
          (this.vf.t = ~~s),
          (this.dmp.tX = t),
          (this.dmp.tY = e),
          i && 0 != this.options.damping
            ? this.dmp.timer ||
              (this.dmp.timer = setInterval(this._animate, 16))
            : (clearTimeout(this.dmp.timer),
              (this.dmp.timer = !1),
              (i = this.si.e.style),
              (i.left = (this.dmp.tX = this.dmp.cX = t) + 'px'),
              (i.top = (this.dmp.tY = this.dmp.cY = e) + 'px'));
      }),
      (n.prototype.center = function (t, e, i) {
        this.move(
          -1 * (t - this.vf.w / 2) * this.scale,
          -1 * (e - this.vf.h / 2) * this.scale,
          i
        );
      }),
      (n.prototype.zoom = function (t, e, i) {
        (this.level = t),
          0 > this.level && (this.level = 0),
          this.level > this.maxZoom && (this.level = this.maxZoom),
          (t = ((this.si.oHyp - this.level) / this.si.oHyp) * 100),
          this.ct.hnd.j.css({
            top:
              this.ct.sl.h -
              (this.ct.sl.h / 100) * (this.level / this.maxZoom) * 100
          }),
          (this.vf.w = (this.vp.w / 100) * t),
          (this.vf.h = (this.vp.h / 100) * t),
          (this.vf.osl = parseInt(this.vf.j.css('border-left-width'), 10)),
          (this.vf.ost = parseInt(this.vf.j.css('border-top-width'), 10)),
          (this.scale =
            this.si.oW / this.vp.w / (((this.si.oW / 100) * t) / this.vp.w)),
          (this.si.w = this.si.oW / (((this.si.oW / 100) * t) / this.dp.w)),
          (this.si.h = this.si.oH / (((this.si.oH / 100) * t) / this.dp.h)),
          this.vf.j.css({ width: this.vf.w, height: this.vf.h }),
          this.si.j.css({ width: this.si.w, height: this.si.h }),
          (this.si.mL = 0 - (this.si.w - this.vp.w)),
          (this.si.mT = 0 - (this.si.h - this.vp.h)),
          this.driver.zoom && this.driver.zoom(e, i);
      }),
      (t.fn.swinxyzoom = function (e) {
        var i = Array.prototype.slice.call(arguments, 1);
        return this.each(function () {
          var s;
          if ((s = t.data(this, 'swinxyzoom'))) {
            if (s[e]) return s[e].apply(s, i);
            t.error('Method ' + e + ' does not exist on jQuery.swinxyzoom');
          } else t.data(this, 'swinxyzoom', new n(this, e));
        });
      }),
      (t.fn.swinxyzoom.modes = {});
  })(jQuery),
  (function (t, e) {
    function i(t) {
      var i,
        n = 0,
        s = 0;
      for (i in t) {
        ++n;
        for (var o = t[i], r = o.variations, a = 0, l = r.length; a < l; ++a)
          if (document.createElement('div').style[r[a]] !== e) {
            ++s, (o.supported = r[a]);
            break;
          }
      }
      return n == s;
    }
    var n = { position: 'right' },
      s = !1,
      o = {
        backgroundSize: {
          supported: !1,
          variations: [
            'backgroundSize',
            'WebkitBackgroundSize',
            'MozBackgroundSize',
            'OBackgroundSize',
            'msBackgroundSize'
          ]
        }
      };
    t.fn.swinxyzoom.modes.dock = function (r) {
      function a() {
        f &&
          ((f = !1),
          r.vf.j.hide(),
          r.dp.ovl.j.stop().animate({ opacity: 0 }, { queue: !1 }),
          r.vp.j.stop().animate(
            {
              opacity: 0,
              left: r.dp.w / 2,
              top: r.dp.h / 2,
              width: 0,
              height: 0
            },
            { queue: !1 }
          ));
      }
      function l(t, e) {
        r.waiting ||
          ((f = !0),
          r.si.j.show(),
          r.vp.j.show(),
          r.vf.j.show(),
          r.dp.ovl.j.stop().animate({ opacity: 0.5 }, { queue: !1 }),
          r.vp.j
            .stop()
            .animate(
              { opacity: 1, left: g, top: m, width: r.vp.w, height: r.vp.h },
              { queue: !1 }
            ),
          v.move(t, e, !0));
      }
      function c() {
        if (
          (r.rt.j.on('sxy-focus', function (t) {
            (t = t.pointers[0]), l(t.x, t.y);
          }),
          r.rt.j.on('sxy-blur', function (t) {
            a();
          }),
          r.dp.j.on('sxy-hover sxy-move sxy-down', y),
          0 == w)
        ) {
          var e = t(
            '<img src="" style="display: block; position: absolute;" />'
          );
          r.vf.j.append(e), (r.vf.img = { j: e, e: e.get(0) });
        }
        v.initialised = !0;
      }
      function d() {
        if (v.initialised) {
          var t = r.vf,
            e = r.vf.e.style;
          t.l != p || t.t != h
            ? ((e.left = (p = t.l) + 'px'),
              (e.top = (h = t.t) + 'px'),
              0 == w
                ? ((e = r.vf.img.e.style),
                  (e.left = '-' + (t.l + t.osl) + 'px'),
                  (e.top = '-' + (t.t + t.ost) + 'px'))
                : (e.backgroundPosition =
                    '-' + (t.l + t.osl) + 'px -' + (t.t + t.ost) + 'px'),
              (x = setTimeout(d, 8)))
            : (x = !1);
        }
      }
      function u(t, e, i) {
        var n = r.dp.j.offset(),
          s = n.left,
          n = n.top,
          o = s + r.dp.j.width(),
          c = n + r.dp.j.height();
        e < n || t > o || e > c || t < s
          ? a()
          : (f || l(t, e), r.center(t - r.dp.ol, e - r.dp.ot, i), x || d());
      }
      (this.initialised = !1), s || ((s = !0), (o._all = i(o)));
      var p,
        h,
        f = !1,
        v = this,
        g = 0,
        m = 0,
        w = o.backgroundSize.supported,
        y = function (t) {
          1 == t.pointers.length && ((t = t.pointers[0]), u(t.x, t.y, !0));
        },
        b = t.extend({}, n, r.options.dock != e ? r.options.dock : {}),
        x = !1;
      (v.tearUp = c),
        (v.load = function (t, e) {
          switch (b.position) {
            case 'top':
              (g = 0), (m = -1 * (r.dp.h + 10));
              break;
            case 'right':
              (g = r.dp.w + 10), (m = 0);
              break;
            case 'bottom':
              (g = 0), (m = r.dp.h + 10);
              break;
            case 'left':
              (g = -1 * (r.dp.w + 10)), (m = 0);
          }
          r.vp.j.css({
            width: 0,
            height: 0,
            left: r.dp.w / 2,
            top: r.dp.h / 2
          }),
            r.dp.ovl.j.css({ opacity: 0 }),
            r.vf.j.css({ position: 'relative', overflow: 'hidden' }),
            (p = h = 0),
            v.initialised || c(),
            0 == w
              ? (r.vf.img.j.attr('src', r.dp.tn.src),
                r.vf.img.j.css({ width: r.dp.w, height: r.dp.h }))
              : (r.vf.j.css('background-image', 'url(' + r.dp.tn.src + ')'),
                r.vf.j.css(w, r.dp.w + 'px ' + r.dp.h + 'px')),
            r.hasFocus && l(t, e);
        }),
        (v.focus = l),
        (v.blur = a),
        (v.move = u),
        (v.zoom = function (t, e) {
          u(t, e, !1);
        });
    };
  })(jQuery),
  (function (t, e) {
    t.fn.swinxyzoom.modes.window = function (t) {
      function e(e, i) {
        t.waiting ||
          (t.si.j.show(),
          t.vp.j.show(),
          t.vf.j.show(),
          t.vp.j.stop().animate({ opacity: 1 }, { queue: !1 }),
          s(e, i, !0));
      }
      function i() {
        t.vf.j.hide(), t.vp.j.stop().animate({ opacity: 0 }, { queue: !1 });
      }
      function n() {
        var e = t.vf,
          i = t.vf.e.style;
        e.l != o || e.t != r
          ? ((i.left = (o = e.l) + 'px'),
            (i.top = (r = e.t) + 'px'),
            (l = setTimeout(n, 8)))
          : (l = !1);
      }
      function s(e, i, s) {
        t.center(e - t.dp.ol, i - t.dp.ot, s), l || n();
      }
      var o,
        r,
        a = this,
        l = (this.initialised = !1);
      (a.tearUp = function (n, o) {
        t.rt.j.on('sxy-focus', function (t) {
          e(t.pointers[0].x, t.pointers[0].y);
        }),
          t.rt.j.on('sxy-blur', function () {
            i();
          }),
          t.dp.j.on('sxy-hover sxy-move sxy-down', function (t) {
            1 == t.pointers.length && ((t = t.pointers[0]), s(t.x, t.y, !0));
          });
      }),
        (a.load = function (e, i) {
          t.vp.j.css({
            opacity: 0,
            width: t.dp.w,
            height: t.dp.h,
            left: 0,
            top: 0
          }),
            (o = r = 0),
            a.initialised || a.tearUp(),
            t.hasFocus && a.focus(e, i);
        }),
        (a.focus = e),
        (a.blur = i),
        (a.move = s),
        (a.zoom = function (t, e) {
          s(t, e, !1);
        });
    };
  })(jQuery),
  (function (t, e) {
    var i = { width: 200, height: 200 };
    t.fn.swinxyzoom.modes.lens = function (n) {
      function s(t, e) {
        n.waiting ||
          ((u = !0),
          n.dp.j.on('sxy-hover sxy-move sxy-down', p),
          n.vp.j.show(),
          n.vp.j
            .stop()
            .animate(
              { opacity: 1, width: n.vp.w, height: n.vp.h },
              { queue: !1 }
            ),
          d.move(t, e, !0));
      }
      function o() {
        u &&
          ((u = !1),
          n.dp.j.off('sxy-hover sxy-move sxy-down', p),
          n.vp.j.stop().animate(
            { opacity: 0 },
            {
              queue: !1,
              complete: function () {
                n.vp.j.hide();
              }
            }
          ));
      }
      function r() {
        var t = n.vf,
          e = n.vp,
          i = n.vp.e.style;
        t.l != l || t.t != c
          ? ((i.left = n.cursor.lastX - n.dp.ol - e.w / 2 + 'px'),
            (i.top = n.cursor.lastY - n.dp.ot - e.h / 2 + 'px'),
            (f = setTimeout(r, 8)))
          : (f = !1);
      }
      function a(t, e, i) {
        n.center(t - n.dp.ol, e - n.dp.ot, i), f || r();
      }
      this.initialised = !1;
      var l,
        c,
        d = this,
        u = !0,
        p = function (t) {
          1 == t.pointers.length && ((t = t.pointers[0]), a(t.x, t.y, !0));
        },
        h = t.extend({}, i, n.options.lens != e ? n.options.lens : {}),
        f = !1;
      (d.tearUp = function (t, e) {
        n.dp.j.swinxytouch('bound'),
          n.dp.j.on('sxy-focus', function (t) {
            s(t.pointers[0].x, t.pointers[0].y);
          }),
          n.dp.j.on('sxy-blur', function () {
            o();
          });
      }),
        (d.load = function (t, e) {
          n.vp.j.css({
            opacity: 0,
            width: h.width,
            height: h.height,
            left: 0,
            top: 0
          }),
            (n.vp.w = h.width),
            (n.vp.h = h.height),
            n.vp.j.show(),
            n.si.j.show(),
            n.vf.j.hide(),
            (l = c = 0),
            d.initialised || d.tearUp(),
            n.hasFocus && s(t, e);
        }),
        (d.focus = s),
        (d.blur = o),
        (d.move = a),
        (d.zoom = function (t, e) {
          a(t, e, !1);
        });
    };
  })(jQuery),
  (function (t, e) {
    t.fn.swinxyzoom.modes.slippy = function (t) {
      function e() {
        t.dp.j.on('sxy-focus', function (t) {
          i(t.pointers[0].x, t.pointers[0].y);
        }),
          t.dp.j.on('sxy-blur', function (t) {
            n();
          }),
          t.dp.j.on('sxy-down', function (e) {
            t.dp.j.toggleClass('down'),
              (e = e.pointers[0]),
              (o = t.dmp.tX),
              (r = t.dmp.tY),
              (a = e.x - t.dp.ol),
              (l = e.y - t.dp.ot);
          }),
          t.dp.j.on('sxy-up', function (e) {
            t.dp.j.toggleClass('down');
          }),
          t.dp.j.on('sxy-move', function (e) {
            (e = e.pointers[0]),
              t.move(o + (e.x - t.dp.ol - a), r + (e.y - t.dp.ot - l), !0),
              p || s();
          });
      }
      function i(e, i) {
        t.waiting ||
          (t.si.j.show(),
          t.vp.j.show(),
          t.vf.j.show(),
          t.vp.j.stop().animate({ opacity: 1 }, { queue: !1 }));
      }
      function n(e, i) {
        t.vf.j.hide(), t.vp.j.animate({ opacity: 0 }, { queue: !1 });
      }
      function s() {
        var e = t.vf,
          i = t.vf.e.style;
        e.l != d || e.t != u
          ? ((i.left = (d = e.l) + 'px'),
            (i.top = (u = e.t) + 'px'),
            (p = setTimeout(s, 8)))
          : (p = !1);
      }
      var o, r, a, l;
      this.initialised = !1;
      var c = this;
      l = a = r = o = void 0;
      var d,
        u,
        p = !1;
      (c.tearUp = e),
        (c.load = function (n, s) {
          t.vp.j.css({
            opacity: 0,
            width: t.dp.w,
            height: t.dp.h,
            left: 0,
            top: 0
          }),
            (r = o = 0),
            (a = n),
            (l = s),
            t.center(t.dp.w / 2, t.dp.h / 2, !1),
            (d = u = 0),
            c.initialised || e(),
            t.hasFocus && i(n, s);
        }),
        (c.focus = i),
        (c.blur = n),
        (c.zoom = function (e, i) {
          t.center(t.cursor.lastX - t.dp.ol, t.cursor.lastY - t.dp.ot, !1),
            t.vf.j.css({ left: t.vf.l, top: t.vf.t });
        });
    };
  })(jQuery),
  (function (t) {
    function e(t, e) {
      for (var i = t.length; i--; ) if (t[i] === e) return i;
      return -1;
    }
    function i(t, e) {
      if (t.length != e.length) return !1;
      for (var i = 0; i < t.length; i++) if (t[i] !== e[i]) return !1;
      return !0;
    }
    function n(t) {
      for (y in x) x[y] = t[j[y]];
    }
    function s(t) {
      var i, s, o, r, l, c;
      if (
        ((i = t.keyCode),
        e(E, i) == -1 && E.push(i),
        (93 != i && 224 != i) || (i = 91),
        i in x)
      ) {
        x[i] = !0;
        for (o in T) T[o] == i && (a[o] = !0);
      } else if ((n(t), a.filter.call(this, t) && i in b))
        for (c = h(), r = 0; r < b[i].length; r++)
          if (((s = b[i][r]), s.scope == c || 'all' == s.scope)) {
            l = s.mods.length > 0;
            for (o in x)
              ((!x[o] && e(s.mods, +o) > -1) ||
                (x[o] && e(s.mods, +o) == -1)) &&
                (l = !1);
            ((0 != s.mods.length || x[16] || x[18] || x[17] || x[91]) && !l) ||
              (s.method(t, s) === !1 &&
                (t.preventDefault ? t.preventDefault() : (t.returnValue = !1),
                t.stopPropagation && t.stopPropagation(),
                t.cancelBubble && (t.cancelBubble = !0)));
          }
    }
    function o(t) {
      var i,
        n = t.keyCode,
        s = e(E, n);
      if (
        (s >= 0 && E.splice(s, 1), (93 != n && 224 != n) || (n = 91), n in x)
      ) {
        x[n] = !1;
        for (i in T) T[i] == n && (a[i] = !1);
      }
    }
    function r() {
      for (y in x) x[y] = !1;
      for (y in T) a[y] = !1;
    }
    function a(t, e, i) {
      var n, s;
      (n = v(t)), void 0 === i && ((i = e), (e = 'all'));
      for (var o = 0; o < n.length; o++)
        (s = []),
          (t = n[o].split('+')),
          t.length > 1 && ((s = g(t)), (t = [t[t.length - 1]])),
          (t = t[0]),
          (t = C(t)),
          t in b || (b[t] = []),
          b[t].push({
            shortcut: n[o],
            scope: e,
            method: i,
            key: n[o],
            mods: s
          });
    }
    function l(t, e) {
      var n,
        s,
        o,
        r,
        a,
        l = [];
      for (n = v(t), r = 0; r < n.length; r++) {
        if (
          ((s = n[r].split('+')),
          s.length > 1 && (l = g(s)),
          (t = s[s.length - 1]),
          (t = C(t)),
          void 0 === e && (e = h()),
          !b[t])
        )
          return;
        for (o = 0; o < b[t].length; o++)
          (a = b[t][o]), a.scope === e && i(a.mods, l) && (b[t][o] = {});
      }
    }
    function c(t) {
      return 'string' == typeof t && (t = C(t)), e(E, t) != -1;
    }
    function d() {
      return E.slice(0);
    }
    function u(t) {
      var e = (t.target || t.srcElement).tagName;
      return !('INPUT' == e || 'SELECT' == e || 'TEXTAREA' == e);
    }
    function p(t) {
      k = t || 'all';
    }
    function h() {
      return k || 'all';
    }
    function f(t) {
      var e, i, n;
      for (e in b)
        for (i = b[e], n = 0; n < i.length; )
          i[n].scope === t ? i.splice(n, 1) : n++;
    }
    function v(t) {
      var e;
      return (
        (t = t.replace(/\s/g, '')),
        (e = t.split(',')),
        '' == e[e.length - 1] && (e[e.length - 2] += ','),
        e
      );
    }
    function g(t) {
      for (var e = t.slice(0, t.length - 1), i = 0; i < e.length; i++)
        e[i] = T[e[i]];
      return e;
    }
    function m(t, e, i) {
      t.addEventListener
        ? t.addEventListener(e, i, !1)
        : t.attachEvent &&
          t.attachEvent('on' + e, function () {
            i(window.event);
          });
    }
    function w() {
      var e = t.key;
      return (t.key = O), e;
    }
    var y,
      b = {},
      x = { 16: !1, 18: !1, 17: !1, 91: !1 },
      k = 'all',
      T = {
        '⇧': 16,
        shift: 16,
        '⌥': 18,
        alt: 18,
        option: 18,
        '⌃': 17,
        ctrl: 17,
        control: 17,
        '⌘': 91,
        command: 91
      },
      S = {
        backspace: 8,
        tab: 9,
        clear: 12,
        enter: 13,
        return: 13,
        esc: 27,
        escape: 27,
        space: 32,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        del: 46,
        delete: 46,
        home: 36,
        end: 35,
        pageup: 33,
        pagedown: 34,
        ',': 188,
        '.': 190,
        '/': 191,
        '`': 192,
        '-': 189,
        '=': 187,
        ';': 186,
        "'": 222,
        '[': 219,
        ']': 221,
        '\\': 220
      },
      C = function (t) {
        return S[t] || t.toUpperCase().charCodeAt(0);
      },
      E = [];
    for (y = 1; y < 20; y++) S['f' + y] = 111 + y;
    var j = { 16: 'shiftKey', 18: 'altKey', 17: 'ctrlKey', 91: 'metaKey' };
    for (y in T) a[y] = !1;
    m(document, 'keydown', function (t) {
      s(t);
    }),
      m(document, 'keyup', o),
      m(window, 'focus', r);
    var O = t.key;
    (t.key = a),
      (t.key.setScope = p),
      (t.key.getScope = h),
      (t.key.deleteScope = f),
      (t.key.filter = u),
      (t.key.isPressed = c),
      (t.key.getPressedKeyCodes = d),
      (t.key.noConflict = w),
      (t.key.unbind = l),
      'undefined' != typeof module && (module.exports = a);
  })(this),
  !(function (t, e) {
    'use strict';
    'function' == typeof define && define.amd
      ? define('mediator-js', [], function () {
          return (t.Mediator = e()), t.Mediator;
        })
      : 'undefined' != typeof exports
      ? (exports.Mediator = e())
      : (t.Mediator = e());
  })(this, function () {
    'use strict';
    function t() {
      var t = function () {
        return (0 | (65536 * (1 + Math.random()))).toString(16).substring(1);
      };
      return (
        t() + t() + '-' + t() + '-' + t() + '-' + t() + '-' + t() + t() + t()
      );
    }
    function e(i, n, s) {
      return this instanceof e
        ? ((this.id = t()),
          (this.fn = i),
          (this.options = n),
          (this.context = s),
          void (this.channel = null))
        : new e(i, n, s);
    }
    function i(t, e) {
      return this instanceof i
        ? ((this.namespace = t || ''),
          (this._subscribers = []),
          (this._channels = {}),
          (this._parent = e),
          void (this.stopped = !1))
        : new i(t);
    }
    function n() {
      return this instanceof n ? void (this._channels = new i('')) : new n();
    }
    return (
      (e.prototype = {
        update: function (t) {
          t &&
            ((this.fn = t.fn || this.fn),
            (this.context = t.context || this.context),
            (this.options = t.options || this.options),
            this.channel &&
              this.options &&
              void 0 !== this.options.priority &&
              this.channel.setPriority(this.id, this.options.priority));
        }
      }),
      (i.prototype = {
        addSubscriber: function (t, i, n) {
          var s = new e(t, i, n);
          return (
            i && void 0 !== i.priority
              ? ((i.priority = i.priority >> 0),
                i.priority < 0 && (i.priority = 0),
                i.priority >= this._subscribers.length &&
                  (i.priority = this._subscribers.length - 1),
                this._subscribers.splice(i.priority, 0, s))
              : this._subscribers.push(s),
            (s.channel = this),
            s
          );
        },
        stopPropagation: function () {
          this.stopped = !0;
        },
        getSubscriber: function (t) {
          var e = 0,
            i = this._subscribers.length;
          for (i; i > e; e++)
            if (this._subscribers[e].id === t || this._subscribers[e].fn === t)
              return this._subscribers[e];
        },
        setPriority: function (t, e) {
          var i,
            n,
            s,
            o,
            r = 0,
            a = 0;
          for (
            a = 0, o = this._subscribers.length;
            o > a &&
            this._subscribers[a].id !== t &&
            this._subscribers[a].fn !== t;
            a++
          )
            r++;
          (i = this._subscribers[r]),
            (n = this._subscribers.slice(0, r)),
            (s = this._subscribers.slice(r + 1)),
            (this._subscribers = n.concat(s)),
            this._subscribers.splice(e, 0, i);
        },
        addChannel: function (t) {
          this._channels[t] = new i(
            (this.namespace ? this.namespace + ':' : '') + t,
            this
          );
        },
        hasChannel: function (t) {
          return this._channels.hasOwnProperty(t);
        },
        returnChannel: function (t) {
          return this._channels[t];
        },
        removeSubscriber: function (t) {
          var e = this._subscribers.length - 1;
          if (!t) return void (this._subscribers = []);
          for (e; e >= 0; e--)
            (this._subscribers[e].fn === t || this._subscribers[e].id === t) &&
              ((this._subscribers[e].channel = null),
              this._subscribers.splice(e, 1));
        },
        publish: function (t) {
          var e,
            i,
            n,
            s = 0,
            o = this._subscribers.length,
            r = !1;
          for (o; o > s; s++)
            (r = !1),
              (e = this._subscribers[s]),
              this.stopped ||
                ((i = this._subscribers.length),
                void 0 !== e.options && 'function' == typeof e.options.predicate
                  ? e.options.predicate.apply(e.context, t) && (r = !0)
                  : (r = !0)),
              r &&
                (e.options &&
                  void 0 !== e.options.calls &&
                  (e.options.calls--,
                  e.options.calls < 1 && this.removeSubscriber(e.id)),
                e.fn.apply(e.context, t),
                (n = this._subscribers.length),
                (o = n),
                n === i - 1 && s--);
          this._parent && this._parent.publish(t), (this.stopped = !1);
        }
      }),
      (n.prototype = {
        getChannel: function (t, e) {
          var i = this._channels,
            n = t.split(':'),
            s = 0,
            o = n.length;
          if ('' === t) return i;
          if (n.length > 0)
            for (o; o > s; s++) {
              if (!i.hasChannel(n[s])) {
                if (e) break;
                i.addChannel(n[s]);
              }
              i = i.returnChannel(n[s]);
            }
          return i;
        },
        subscribe: function (t, e, i, n) {
          var s = this.getChannel(t || '', !1);
          return (i = i || {}), (n = n || {}), s.addSubscriber(e, i, n);
        },
        once: function (t, e, i, n) {
          return (i = i || {}), (i.calls = 1), this.subscribe(t, e, i, n);
        },
        getSubscriber: function (t, e) {
          var i = this.getChannel(e || '', !0);
          return i.namespace !== e ? null : i.getSubscriber(t);
        },
        remove: function (t, e) {
          var i = this.getChannel(t || '', !0);
          return i.namespace === t && void i.removeSubscriber(e);
        },
        publish: function (t) {
          var e = this.getChannel(t || '', !0);
          if (e.namespace !== t) return null;
          var i = Array.prototype.slice.call(arguments, 1);
          i.push(e), e.publish(i);
        }
      }),
      (n.prototype.on = n.prototype.subscribe),
      (n.prototype.bind = n.prototype.subscribe),
      (n.prototype.emit = n.prototype.publish),
      (n.prototype.trigger = n.prototype.publish),
      (n.prototype.off = n.prototype.remove),
      (n.Channel = i),
      (n.Subscriber = e),
      (n.version = '0.9.8'),
      n
    );
  }),
  (function (t) {
    'use strict';
    function e() {}
    function i() {
      try {
        return document.activeElement;
      } catch (t) {}
    }
    function n(t, e) {
      for (var i = 0, n = t.length; i < n; i++) if (t[i] === e) return !0;
      return !1;
    }
    function s(t, e, i) {
      return t.addEventListener
        ? t.addEventListener(e, i, !1)
        : t.attachEvent
        ? t.attachEvent('on' + e, i)
        : void 0;
    }
    function o(t, e) {
      var i;
      t.createTextRange
        ? ((i = t.createTextRange()), i.move('character', e), i.select())
        : t.selectionStart && (t.focus(), t.setSelectionRange(e, e));
    }
    function r(t, e) {
      try {
        return (t.type = e), !0;
      } catch (i) {
        return !1;
      }
    }
    function a(t, e) {
      if (t && t.getAttribute(j)) e(t);
      else
        for (
          var i,
            n = t ? t.getElementsByTagName('input') : N,
            s = t ? t.getElementsByTagName('textarea') : F,
            o = n ? n.length : 0,
            r = s ? s.length : 0,
            a = o + r,
            l = 0;
          l < a;
          l++
        )
          (i = l < o ? n[l] : s[l - o]), e(i);
    }
    function l(t) {
      a(t, d);
    }
    function c(t) {
      a(t, u);
    }
    function d(t, e) {
      var i = !!e && t.value !== e,
        n = t.value === t.getAttribute(j);
      if ((i || n) && 'true' === t.getAttribute(O)) {
        t.removeAttribute(O),
          (t.value = t.value.replace(t.getAttribute(j), '')),
          (t.className = t.className.replace(E, ''));
        var s = t.getAttribute(H);
        parseInt(s, 10) >= 0 &&
          (t.setAttribute('maxLength', s), t.removeAttribute(H));
        var o = t.getAttribute(A);
        return o && (t.type = o), !0;
      }
      return !1;
    }
    function u(t) {
      var e = t.getAttribute(j);
      if ('' === t.value && e) {
        t.setAttribute(O, 'true'), (t.value = e), (t.className += ' ' + C);
        var i = t.getAttribute(H);
        i || (t.setAttribute(H, t.maxLength), t.removeAttribute('maxLength'));
        var n = t.getAttribute(A);
        return (
          n
            ? (t.type = 'text')
            : 'password' === t.type &&
              r(t, 'text') &&
              t.setAttribute(A, 'password'),
          !0
        );
      }
      return !1;
    }
    function p(t) {
      return function () {
        q && t.value === t.getAttribute(j) && 'true' === t.getAttribute(O)
          ? o(t, 0)
          : d(t);
      };
    }
    function h(t) {
      return function () {
        u(t);
      };
    }
    function f(t) {
      return function () {
        l(t);
      };
    }
    function v(t) {
      return function (e) {
        if (
          ((x = t.value),
          'true' === t.getAttribute(O) &&
            x === t.getAttribute(j) &&
            n(T, e.keyCode))
        )
          return e.preventDefault && e.preventDefault(), !1;
      };
    }
    function g(t) {
      return function () {
        d(t, x), '' === t.value && (t.blur(), o(t, 0));
      };
    }
    function m(t) {
      return function () {
        t === i() &&
          t.value === t.getAttribute(j) &&
          'true' === t.getAttribute(O) &&
          o(t, 0);
      };
    }
    function w(t) {
      var e = t.form;
      e &&
        'string' == typeof e &&
        ((e = document.getElementById(e)),
        e.getAttribute(I) || (s(e, 'submit', f(e)), e.setAttribute(I, 'true'))),
        s(t, 'focus', p(t)),
        s(t, 'blur', h(t)),
        q && (s(t, 'keydown', v(t)), s(t, 'keyup', g(t)), s(t, 'click', m(t))),
        t.setAttribute(M, 'true'),
        t.setAttribute(j, X),
        (q || t !== i()) && u(t);
    }
    var y = document.createElement('input'),
      b = void 0 !== y.placeholder;
    if (
      ((t.Placeholders = {
        nativeSupport: b,
        disable: b ? e : l,
        enable: b ? e : c
      }),
      !b)
    ) {
      var x,
        k = [
          'text',
          'search',
          'url',
          'tel',
          'email',
          'password',
          'number',
          'textarea'
        ],
        T = [27, 33, 34, 35, 36, 37, 38, 39, 40, 8, 46],
        S = '#ccc',
        C = 'placeholdersjs',
        E = new RegExp('(?:^|\\s)' + C + '(?!\\S)'),
        j = 'data-placeholder-value',
        O = 'data-placeholder-active',
        A = 'data-placeholder-type',
        I = 'data-placeholder-submit',
        M = 'data-placeholder-bound',
        $ = 'data-placeholder-focus',
        z = 'data-placeholder-live',
        H = 'data-placeholder-maxlength',
        _ = 100,
        P = document.getElementsByTagName('head')[0],
        D = document.documentElement,
        L = t.Placeholders,
        N = document.getElementsByTagName('input'),
        F = document.getElementsByTagName('textarea'),
        q = 'false' === D.getAttribute($),
        B = 'false' !== D.getAttribute(z),
        R = document.createElement('style');
      R.type = 'text/css';
      var W = document.createTextNode('.' + C + ' {color:' + S + ';}');
      R.styleSheet ? (R.styleSheet.cssText = W.nodeValue) : R.appendChild(W),
        P.insertBefore(R, P.firstChild);
      for (var X, U, Y = 0, Q = N.length + F.length; Y < Q; Y++)
        (U = Y < N.length ? N[Y] : F[Y - N.length]),
          (X = U.attributes.placeholder),
          X && ((X = X.nodeValue), X && n(k, U.type) && w(U));
      var G = setInterval(function () {
        for (var t = 0, e = N.length + F.length; t < e; t++)
          (U = t < N.length ? N[t] : F[t - N.length]),
            (X = U.attributes.placeholder),
            X
              ? ((X = X.nodeValue),
                X &&
                  n(k, U.type) &&
                  (U.getAttribute(M) || w(U),
                  (X !== U.getAttribute(j) ||
                    ('password' === U.type && !U.getAttribute(A))) &&
                    ('password' === U.type &&
                      !U.getAttribute(A) &&
                      r(U, 'text') &&
                      U.setAttribute(A, 'password'),
                    U.value === U.getAttribute(j) && (U.value = X),
                    U.setAttribute(j, X))))
              : U.getAttribute(O) && (d(U), U.removeAttribute(j));
        B || clearInterval(G);
      }, _);
      s(t, 'beforeunload', function () {
        L.disable();
      });
    }
  })(this),
  (function (t, e) {
    'use strict';
    var i = t.fn.val,
      n = t.fn.prop;
    e.Placeholders.nativeSupport ||
      ((t.fn.val = function (t) {
        var e = i.apply(this, arguments),
          n = this.eq(0).data('placeholder-value');
        return void 0 === t && this.eq(0).data('placeholder-active') && e === n
          ? ''
          : e;
      }),
      (t.fn.prop = function (t, e) {
        return void 0 === e &&
          this.eq(0).data('placeholder-active') &&
          'value' === t
          ? ''
          : n.apply(this, arguments);
      }));
  })(jQuery, this),
  (function (t, e) {
    'function' == typeof define && define.amd
      ? define([], e)
      : 'object' == typeof exports
      ? (module.exports = e())
      : (t.Proto = e());
  })(this, function () {
    function t(t, e, i, n) {
      return function () {
        var s = this._super;
        this._super = 'function' == typeof e ? e : t[i];
        var o = n.apply(this, arguments);
        return (this._super = s), o;
      };
    }
    function e(e, i) {
      var n,
        s = i || this,
        o = /\b_super\b/,
        r = Object.getPrototypeOf(s) || s.prototype;
      for (var a in e)
        (n = s[a]),
          (('function' == typeof e[a] && 'function' == typeof r[a]) ||
            ('function' == typeof n && 'function' == typeof e[a])) &&
          o.test(e[a])
            ? (s[a] = t(r, n, a, e[a]))
            : (s[a] = e[a]);
      return s;
    }
    function i(e, i) {
      var n = i || this,
        s = /\b_super\b/,
        o = Object.getPrototypeOf(n) || n.prototype,
        r = {},
        a = e,
        l = function (t) {
          r[t] || (r[t] = Object.getOwnPropertyDescriptor(a, t));
        };
      do Object.getOwnPropertyNames(a).forEach(l);
      while ((a = Object.getPrototypeOf(a)) && Object.getPrototypeOf(a));
      return (
        Object.keys(r).forEach(function (e) {
          var i = r[e];
          'function' == typeof i.value &&
            s.test(i.value) &&
            (i.value = t(o, n[e], e, i.value)),
            Object.defineProperty(n, e, i);
        }),
        n
      );
    }
    return {
      create: function () {
        var t = Object.create(this),
          e = 'string' == typeof t.__init ? t.__init : 'init';
        return 'function' == typeof t[e] && t[e].apply(t, arguments), t;
      },
      mixin: 'function' == typeof Object.defineProperty ? i : e,
      extend: function (t, e) {
        return this.mixin(t, Object.create(e || this));
      },
      proxy: function (t) {
        var e = this[t],
          i = Array.prototype.slice.call(arguments, 1);
        return i.unshift(this), e.bind.apply(e, i);
      }
    };
  }),
  (function (t) {
    'use strict';
    'function' == typeof define && define.amd
      ? define(['jquery'], t)
      : 'undefined' != typeof exports
      ? (module.exports = t(require('jquery')))
      : t(jQuery);
  })(function (t) {
    'use strict';
    var e = window.Slick || {};
    (e = (function () {
      function e(e, n) {
        var s,
          o = this;
        (o.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: t(e),
          appendDots: t(e),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
          nextArrow:
            '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: '50px',
          cssEase: 'ease',
          customPaging: function (e, i) {
            return t(
              '<button type="button" data-role="none" role="button" tabindex="0" />'
            ).text(i + 1);
          },
          dots: !1,
          dotsClass: 'slick-dots',
          draggable: !0,
          easing: 'linear',
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: 'ondemand',
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: 'window',
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: '',
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3
        }),
          (o.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1
          }),
          t.extend(o, o.initials),
          (o.activeBreakpoint = null),
          (o.animType = null),
          (o.animProp = null),
          (o.breakpoints = []),
          (o.breakpointSettings = []),
          (o.cssTransitions = !1),
          (o.focussed = !1),
          (o.interrupted = !1),
          (o.hidden = 'hidden'),
          (o.paused = !0),
          (o.positionProp = null),
          (o.respondTo = null),
          (o.rowCount = 1),
          (o.shouldClick = !0),
          (o.$slider = t(e)),
          (o.$slidesCache = null),
          (o.transformType = null),
          (o.transitionType = null),
          (o.visibilityChange = 'visibilitychange'),
          (o.windowWidth = 0),
          (o.windowTimer = null),
          (s = t(e).data('slick') || {}),
          (o.options = t.extend({}, o.defaults, n, s)),
          (o.currentSlide = o.options.initialSlide),
          (o.originalSettings = o.options),
          'undefined' != typeof document.mozHidden
            ? ((o.hidden = 'mozHidden'),
              (o.visibilityChange = 'mozvisibilitychange'))
            : 'undefined' != typeof document.webkitHidden &&
              ((o.hidden = 'webkitHidden'),
              (o.visibilityChange = 'webkitvisibilitychange')),
          (o.autoPlay = t.proxy(o.autoPlay, o)),
          (o.autoPlayClear = t.proxy(o.autoPlayClear, o)),
          (o.autoPlayIterator = t.proxy(o.autoPlayIterator, o)),
          (o.changeSlide = t.proxy(o.changeSlide, o)),
          (o.clickHandler = t.proxy(o.clickHandler, o)),
          (o.selectHandler = t.proxy(o.selectHandler, o)),
          (o.setPosition = t.proxy(o.setPosition, o)),
          (o.swipeHandler = t.proxy(o.swipeHandler, o)),
          (o.dragHandler = t.proxy(o.dragHandler, o)),
          (o.keyHandler = t.proxy(o.keyHandler, o)),
          (o.instanceUid = i++),
          (o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          o.registerBreakpoints(),
          o.init(!0);
      }
      var i = 0;
      return e;
    })()),
      (e.prototype.activateADA = function () {
        var t = this;
        t.$slideTrack
          .find('.slick-active')
          .attr({ 'aria-hidden': 'false' })
          .find('a, input, button, select')
          .attr({ tabindex: '0' });
      }),
      (e.prototype.addSlide = e.prototype.slickAdd =
        function (e, i, n) {
          var s = this;
          if ('boolean' == typeof i) (n = i), (i = null);
          else if (i < 0 || i >= s.slideCount) return !1;
          s.unload(),
            'number' == typeof i
              ? 0 === i && 0 === s.$slides.length
                ? t(e).appendTo(s.$slideTrack)
                : n
                ? t(e).insertBefore(s.$slides.eq(i))
                : t(e).insertAfter(s.$slides.eq(i))
              : n === !0
              ? t(e).prependTo(s.$slideTrack)
              : t(e).appendTo(s.$slideTrack),
            (s.$slides = s.$slideTrack.children(this.options.slide)),
            s.$slideTrack.children(this.options.slide).detach(),
            s.$slideTrack.append(s.$slides),
            s.$slides.each(function (e, i) {
              t(i).attr('data-slick-index', e);
            }),
            (s.$slidesCache = s.$slides),
            s.reinit();
        }),
      (e.prototype.animateHeight = function () {
        var t = this;
        if (
          1 === t.options.slidesToShow &&
          t.options.adaptiveHeight === !0 &&
          t.options.vertical === !1
        ) {
          var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
          t.$list.animate({ height: e }, t.options.speed);
        }
      }),
      (e.prototype.animateSlide = function (e, i) {
        var n = {},
          s = this;
        s.animateHeight(),
          s.options.rtl === !0 && s.options.vertical === !1 && (e = -e),
          s.transformsEnabled === !1
            ? s.options.vertical === !1
              ? s.$slideTrack.animate(
                  { left: e },
                  s.options.speed,
                  s.options.easing,
                  i
                )
              : s.$slideTrack.animate(
                  { top: e },
                  s.options.speed,
                  s.options.easing,
                  i
                )
            : s.cssTransitions === !1
            ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft),
              t({ animStart: s.currentLeft }).animate(
                { animStart: e },
                {
                  duration: s.options.speed,
                  easing: s.options.easing,
                  step: function (t) {
                    (t = Math.ceil(t)),
                      s.options.vertical === !1
                        ? ((n[s.animType] = 'translate(' + t + 'px, 0px)'),
                          s.$slideTrack.css(n))
                        : ((n[s.animType] = 'translate(0px,' + t + 'px)'),
                          s.$slideTrack.css(n));
                  },
                  complete: function () {
                    i && i.call();
                  }
                }
              ))
            : (s.applyTransition(),
              (e = Math.ceil(e)),
              s.options.vertical === !1
                ? (n[s.animType] = 'translate3d(' + e + 'px, 0px, 0px)')
                : (n[s.animType] = 'translate3d(0px,' + e + 'px, 0px)'),
              s.$slideTrack.css(n),
              i &&
                setTimeout(function () {
                  s.disableTransition(), i.call();
                }, s.options.speed));
      }),
      (e.prototype.getNavTarget = function () {
        var e = this,
          i = e.options.asNavFor;
        return i && null !== i && (i = t(i).not(e.$slider)), i;
      }),
      (e.prototype.asNavFor = function (e) {
        var i = this,
          n = i.getNavTarget();
        null !== n &&
          'object' == typeof n &&
          n.each(function () {
            var i = t(this).slick('getSlick');
            i.unslicked || i.slideHandler(e, !0);
          });
      }),
      (e.prototype.applyTransition = function (t) {
        var e = this,
          i = {};
        e.options.fade === !1
          ? (i[e.transitionType] =
              e.transformType +
              ' ' +
              e.options.speed +
              'ms ' +
              e.options.cssEase)
          : (i[e.transitionType] =
              'opacity ' + e.options.speed + 'ms ' + e.options.cssEase),
          e.options.fade === !1 ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i);
      }),
      (e.prototype.autoPlay = function () {
        var t = this;
        t.autoPlayClear(),
          t.slideCount > t.options.slidesToShow &&
            (t.autoPlayTimer = setInterval(
              t.autoPlayIterator,
              t.options.autoplaySpeed
            ));
      }),
      (e.prototype.autoPlayClear = function () {
        var t = this;
        t.autoPlayTimer && clearInterval(t.autoPlayTimer);
      }),
      (e.prototype.autoPlayIterator = function () {
        var t = this,
          e = t.currentSlide + t.options.slidesToScroll;
        t.paused ||
          t.interrupted ||
          t.focussed ||
          (t.options.infinite === !1 &&
            (1 === t.direction && t.currentSlide + 1 === t.slideCount - 1
              ? (t.direction = 0)
              : 0 === t.direction &&
                ((e = t.currentSlide - t.options.slidesToScroll),
                t.currentSlide - 1 === 0 && (t.direction = 1))),
          t.slideHandler(e));
      }),
      (e.prototype.buildArrows = function () {
        var e = this;
        e.options.arrows === !0 &&
          ((e.$prevArrow = t(e.options.prevArrow).addClass('slick-arrow')),
          (e.$nextArrow = t(e.options.nextArrow).addClass('slick-arrow')),
          e.slideCount > e.options.slidesToShow
            ? (e.$prevArrow
                .removeClass('slick-hidden')
                .removeAttr('aria-hidden tabindex'),
              e.$nextArrow
                .removeClass('slick-hidden')
                .removeAttr('aria-hidden tabindex'),
              e.htmlExpr.test(e.options.prevArrow) &&
                e.$prevArrow.prependTo(e.options.appendArrows),
              e.htmlExpr.test(e.options.nextArrow) &&
                e.$nextArrow.appendTo(e.options.appendArrows),
              e.options.infinite !== !0 &&
                e.$prevArrow
                  .addClass('slick-disabled')
                  .attr('aria-disabled', 'true'))
            : e.$prevArrow
                .add(e.$nextArrow)
                .addClass('slick-hidden')
                .attr({ 'aria-disabled': 'true', tabindex: '-1' }));
      }),
      (e.prototype.buildDots = function () {
        var e,
          i,
          n = this;
        if (n.options.dots === !0 && n.slideCount > n.options.slidesToShow) {
          for (
            n.$slider.addClass('slick-dotted'),
              i = t('<ul />').addClass(n.options.dotsClass),
              e = 0;
            e <= n.getDotCount();
            e += 1
          )
            i.append(
              t('<li />').append(n.options.customPaging.call(this, n, e))
            );
          (n.$dots = i.appendTo(n.options.appendDots)),
            n.$dots
              .find('li')
              .first()
              .addClass('slick-active')
              .attr('aria-hidden', 'false');
        }
      }),
      (e.prototype.buildOut = function () {
        var e = this;
        (e.$slides = e.$slider
          .children(e.options.slide + ':not(.slick-cloned)')
          .addClass('slick-slide')),
          (e.slideCount = e.$slides.length),
          e.$slides.each(function (e, i) {
            t(i)
              .attr('data-slick-index', e)
              .data('originalStyling', t(i).attr('style') || '');
          }),
          e.$slider.addClass('slick-slider'),
          (e.$slideTrack =
            0 === e.slideCount
              ? t('<div class="slick-track"/>').appendTo(e.$slider)
              : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (e.$list = e.$slideTrack
            .wrap('<div aria-live="polite" class="slick-list"/>')
            .parent()),
          e.$slideTrack.css('opacity', 0),
          (e.options.centerMode !== !0 && e.options.swipeToSlide !== !0) ||
            (e.options.slidesToScroll = 1),
          t('img[data-lazy]', e.$slider).not('[src]').addClass('slick-loading'),
          e.setupInfinite(),
          e.buildArrows(),
          e.buildDots(),
          e.updateDots(),
          e.setSlideClasses(
            'number' == typeof e.currentSlide ? e.currentSlide : 0
          ),
          e.options.draggable === !0 && e.$list.addClass('draggable');
      }),
      (e.prototype.buildRows = function () {
        var t,
          e,
          i,
          n,
          s,
          o,
          r,
          a = this;
        if (
          ((n = document.createDocumentFragment()),
          (o = a.$slider.children()),
          a.options.rows > 1)
        ) {
          for (
            r = a.options.slidesPerRow * a.options.rows,
              s = Math.ceil(o.length / r),
              t = 0;
            t < s;
            t++
          ) {
            var l = document.createElement('div');
            for (e = 0; e < a.options.rows; e++) {
              var c = document.createElement('div');
              for (i = 0; i < a.options.slidesPerRow; i++) {
                var d = t * r + (e * a.options.slidesPerRow + i);
                o.get(d) && c.appendChild(o.get(d));
              }
              l.appendChild(c);
            }
            n.appendChild(l);
          }
          a.$slider.empty().append(n),
            a.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / a.options.slidesPerRow + '%',
                display: 'inline-block'
              });
        }
      }),
      (e.prototype.checkResponsive = function (e, i) {
        var n,
          s,
          o,
          r = this,
          a = !1,
          l = r.$slider.width(),
          c = window.innerWidth || t(window).width();
        if (
          ('window' === r.respondTo
            ? (o = c)
            : 'slider' === r.respondTo
            ? (o = l)
            : 'min' === r.respondTo && (o = Math.min(c, l)),
          r.options.responsive &&
            r.options.responsive.length &&
            null !== r.options.responsive)
        ) {
          s = null;
          for (n in r.breakpoints)
            r.breakpoints.hasOwnProperty(n) &&
              (r.originalSettings.mobileFirst === !1
                ? o < r.breakpoints[n] && (s = r.breakpoints[n])
                : o > r.breakpoints[n] && (s = r.breakpoints[n]));
          null !== s
            ? null !== r.activeBreakpoint
              ? (s !== r.activeBreakpoint || i) &&
                ((r.activeBreakpoint = s),
                'unslick' === r.breakpointSettings[s]
                  ? r.unslick(s)
                  : ((r.options = t.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[s]
                    )),
                    e === !0 && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e)),
                (a = s))
              : ((r.activeBreakpoint = s),
                'unslick' === r.breakpointSettings[s]
                  ? r.unslick(s)
                  : ((r.options = t.extend(
                      {},
                      r.originalSettings,
                      r.breakpointSettings[s]
                    )),
                    e === !0 && (r.currentSlide = r.options.initialSlide),
                    r.refresh(e)),
                (a = s))
            : null !== r.activeBreakpoint &&
              ((r.activeBreakpoint = null),
              (r.options = r.originalSettings),
              e === !0 && (r.currentSlide = r.options.initialSlide),
              r.refresh(e),
              (a = s)),
            e || a === !1 || r.$slider.trigger('breakpoint', [r, a]);
        }
      }),
      (e.prototype.changeSlide = function (e, i) {
        var n,
          s,
          o,
          r = this,
          a = t(e.currentTarget);
        switch (
          (a.is('a') && e.preventDefault(),
          a.is('li') || (a = a.closest('li')),
          (o = r.slideCount % r.options.slidesToScroll !== 0),
          (n = o
            ? 0
            : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
          e.data.message)
        ) {
          case 'previous':
            (s =
              0 === n ? r.options.slidesToScroll : r.options.slidesToShow - n),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide - s, !1, i);
            break;
          case 'next':
            (s = 0 === n ? r.options.slidesToScroll : n),
              r.slideCount > r.options.slidesToShow &&
                r.slideHandler(r.currentSlide + s, !1, i);
            break;
          case 'index':
            var l =
              0 === e.data.index
                ? 0
                : e.data.index || a.index() * r.options.slidesToScroll;
            r.slideHandler(r.checkNavigable(l), !1, i),
              a.children().trigger('focus');
            break;
          default:
            return;
        }
      }),
      (e.prototype.checkNavigable = function (t) {
        var e,
          i,
          n = this;
        if (((e = n.getNavigableIndexes()), (i = 0), t > e[e.length - 1]))
          t = e[e.length - 1];
        else
          for (var s in e) {
            if (t < e[s]) {
              t = i;
              break;
            }
            i = e[s];
          }
        return t;
      }),
      (e.prototype.cleanUpEvents = function () {
        var e = this;
        e.options.dots &&
          null !== e.$dots &&
          t('li', e.$dots)
            .off('click.slick', e.changeSlide)
            .off('mouseenter.slick', t.proxy(e.interrupt, e, !0))
            .off('mouseleave.slick', t.proxy(e.interrupt, e, !1)),
          e.$slider.off('focus.slick blur.slick'),
          e.options.arrows === !0 &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow && e.$prevArrow.off('click.slick', e.changeSlide),
            e.$nextArrow && e.$nextArrow.off('click.slick', e.changeSlide)),
          e.$list.off('touchstart.slick mousedown.slick', e.swipeHandler),
          e.$list.off('touchmove.slick mousemove.slick', e.swipeHandler),
          e.$list.off('touchend.slick mouseup.slick', e.swipeHandler),
          e.$list.off('touchcancel.slick mouseleave.slick', e.swipeHandler),
          e.$list.off('click.slick', e.clickHandler),
          t(document).off(e.visibilityChange, e.visibility),
          e.cleanUpSlideEvents(),
          e.options.accessibility === !0 &&
            e.$list.off('keydown.slick', e.keyHandler),
          e.options.focusOnSelect === !0 &&
            t(e.$slideTrack).children().off('click.slick', e.selectHandler),
          t(window).off(
            'orientationchange.slick.slick-' + e.instanceUid,
            e.orientationChange
          ),
          t(window).off('resize.slick.slick-' + e.instanceUid, e.resize),
          t('[draggable!=true]', e.$slideTrack).off(
            'dragstart',
            e.preventDefault
          ),
          t(window).off('load.slick.slick-' + e.instanceUid, e.setPosition),
          t(document).off('ready.slick.slick-' + e.instanceUid, e.setPosition);
      }),
      (e.prototype.cleanUpSlideEvents = function () {
        var e = this;
        e.$list.off('mouseenter.slick', t.proxy(e.interrupt, e, !0)),
          e.$list.off('mouseleave.slick', t.proxy(e.interrupt, e, !1));
      }),
      (e.prototype.cleanUpRows = function () {
        var t,
          e = this;
        e.options.rows > 1 &&
          ((t = e.$slides.children().children()),
          t.removeAttr('style'),
          e.$slider.empty().append(t));
      }),
      (e.prototype.clickHandler = function (t) {
        var e = this;
        e.shouldClick === !1 &&
          (t.stopImmediatePropagation(),
          t.stopPropagation(),
          t.preventDefault());
      }),
      (e.prototype.destroy = function (e) {
        var i = this;
        i.autoPlayClear(),
          (i.touchObject = {}),
          i.cleanUpEvents(),
          t('.slick-cloned', i.$slider).detach(),
          i.$dots && i.$dots.remove(),
          i.$prevArrow &&
            i.$prevArrow.length &&
            (i.$prevArrow
              .removeClass('slick-disabled slick-arrow slick-hidden')
              .removeAttr('aria-hidden aria-disabled tabindex')
              .css('display', ''),
            i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove()),
          i.$nextArrow &&
            i.$nextArrow.length &&
            (i.$nextArrow
              .removeClass('slick-disabled slick-arrow slick-hidden')
              .removeAttr('aria-hidden aria-disabled tabindex')
              .css('display', ''),
            i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove()),
          i.$slides &&
            (i.$slides
              .removeClass(
                'slick-slide slick-active slick-center slick-visible slick-current'
              )
              .removeAttr('aria-hidden')
              .removeAttr('data-slick-index')
              .each(function () {
                t(this).attr('style', t(this).data('originalStyling'));
              }),
            i.$slideTrack.children(this.options.slide).detach(),
            i.$slideTrack.detach(),
            i.$list.detach(),
            i.$slider.append(i.$slides)),
          i.cleanUpRows(),
          i.$slider.removeClass('slick-slider'),
          i.$slider.removeClass('slick-initialized'),
          i.$slider.removeClass('slick-dotted'),
          (i.unslicked = !0),
          e || i.$slider.trigger('destroy', [i]);
      }),
      (e.prototype.disableTransition = function (t) {
        var e = this,
          i = {};
        (i[e.transitionType] = ''),
          e.options.fade === !1 ? e.$slideTrack.css(i) : e.$slides.eq(t).css(i);
      }),
      (e.prototype.fadeSlide = function (t, e) {
        var i = this;
        i.cssTransitions === !1
          ? (i.$slides.eq(t).css({ zIndex: i.options.zIndex }),
            i.$slides
              .eq(t)
              .animate({ opacity: 1 }, i.options.speed, i.options.easing, e))
          : (i.applyTransition(t),
            i.$slides.eq(t).css({ opacity: 1, zIndex: i.options.zIndex }),
            e &&
              setTimeout(function () {
                i.disableTransition(t), e.call();
              }, i.options.speed));
      }),
      (e.prototype.fadeSlideOut = function (t) {
        var e = this;
        e.cssTransitions === !1
          ? e.$slides
              .eq(t)
              .animate(
                { opacity: 0, zIndex: e.options.zIndex - 2 },
                e.options.speed,
                e.options.easing
              )
          : (e.applyTransition(t),
            e.$slides.eq(t).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
      }),
      (e.prototype.filterSlides = e.prototype.slickFilter =
        function (t) {
          var e = this;
          null !== t &&
            ((e.$slidesCache = e.$slides),
            e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.filter(t).appendTo(e.$slideTrack),
            e.reinit());
        }),
      (e.prototype.focusHandler = function () {
        var e = this;
        e.$slider
          .off('focus.slick blur.slick')
          .on('focus.slick blur.slick', '*:not(.slick-arrow)', function (i) {
            i.stopImmediatePropagation();
            var n = t(this);
            setTimeout(function () {
              e.options.pauseOnFocus &&
                ((e.focussed = n.is(':focus')), e.autoPlay());
            }, 0);
          });
      }),
      (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
        function () {
          var t = this;
          return t.currentSlide;
        }),
      (e.prototype.getDotCount = function () {
        var t = this,
          e = 0,
          i = 0,
          n = 0;
        if (t.options.infinite === !0)
          for (; e < t.slideCount; )
            ++n,
              (e = i + t.options.slidesToScroll),
              (i +=
                t.options.slidesToScroll <= t.options.slidesToShow
                  ? t.options.slidesToScroll
                  : t.options.slidesToShow);
        else if (t.options.centerMode === !0) n = t.slideCount;
        else if (t.options.asNavFor)
          for (; e < t.slideCount; )
            ++n,
              (e = i + t.options.slidesToScroll),
              (i +=
                t.options.slidesToScroll <= t.options.slidesToShow
                  ? t.options.slidesToScroll
                  : t.options.slidesToShow);
        else
          n =
            1 +
            Math.ceil(
              (t.slideCount - t.options.slidesToShow) / t.options.slidesToScroll
            );
        return n - 1;
      }),
      (e.prototype.getLeft = function (t) {
        var e,
          i,
          n,
          s = this,
          o = 0;
        return (
          (s.slideOffset = 0),
          (i = s.$slides.first().outerHeight(!0)),
          s.options.infinite === !0
            ? (s.slideCount > s.options.slidesToShow &&
                ((s.slideOffset = s.slideWidth * s.options.slidesToShow * -1),
                (o = i * s.options.slidesToShow * -1)),
              s.slideCount % s.options.slidesToScroll !== 0 &&
                t + s.options.slidesToScroll > s.slideCount &&
                s.slideCount > s.options.slidesToShow &&
                (t > s.slideCount
                  ? ((s.slideOffset =
                      (s.options.slidesToShow - (t - s.slideCount)) *
                      s.slideWidth *
                      -1),
                    (o =
                      (s.options.slidesToShow - (t - s.slideCount)) * i * -1))
                  : ((s.slideOffset =
                      (s.slideCount % s.options.slidesToScroll) *
                      s.slideWidth *
                      -1),
                    (o = (s.slideCount % s.options.slidesToScroll) * i * -1))))
            : t + s.options.slidesToShow > s.slideCount &&
              ((s.slideOffset =
                (t + s.options.slidesToShow - s.slideCount) * s.slideWidth),
              (o = (t + s.options.slidesToShow - s.slideCount) * i)),
          s.slideCount <= s.options.slidesToShow &&
            ((s.slideOffset = 0), (o = 0)),
          s.options.centerMode === !0 && s.options.infinite === !0
            ? (s.slideOffset +=
                s.slideWidth * Math.floor(s.options.slidesToShow / 2) -
                s.slideWidth)
            : s.options.centerMode === !0 &&
              ((s.slideOffset = 0),
              (s.slideOffset +=
                s.slideWidth * Math.floor(s.options.slidesToShow / 2))),
          (e =
            s.options.vertical === !1
              ? t * s.slideWidth * -1 + s.slideOffset
              : t * i * -1 + o),
          s.options.variableWidth === !0 &&
            ((n =
              s.slideCount <= s.options.slidesToShow ||
              s.options.infinite === !1
                ? s.$slideTrack.children('.slick-slide').eq(t)
                : s.$slideTrack
                    .children('.slick-slide')
                    .eq(t + s.options.slidesToShow)),
            (e =
              s.options.rtl === !0
                ? n[0]
                  ? (s.$slideTrack.width() - n[0].offsetLeft - n.width()) * -1
                  : 0
                : n[0]
                ? n[0].offsetLeft * -1
                : 0),
            s.options.centerMode === !0 &&
              ((n =
                s.slideCount <= s.options.slidesToShow ||
                s.options.infinite === !1
                  ? s.$slideTrack.children('.slick-slide').eq(t)
                  : s.$slideTrack
                      .children('.slick-slide')
                      .eq(t + s.options.slidesToShow + 1)),
              (e =
                s.options.rtl === !0
                  ? n[0]
                    ? (s.$slideTrack.width() - n[0].offsetLeft - n.width()) * -1
                    : 0
                  : n[0]
                  ? n[0].offsetLeft * -1
                  : 0),
              (e += (s.$list.width() - n.outerWidth()) / 2))),
          e
        );
      }),
      (e.prototype.getOption = e.prototype.slickGetOption =
        function (t) {
          var e = this;
          return e.options[t];
        }),
      (e.prototype.getNavigableIndexes = function () {
        var t,
          e = this,
          i = 0,
          n = 0,
          s = [];
        for (
          e.options.infinite === !1
            ? (t = e.slideCount)
            : ((i = e.options.slidesToScroll * -1),
              (n = e.options.slidesToScroll * -1),
              (t = 2 * e.slideCount));
          i < t;

        )
          s.push(i),
            (i = n + e.options.slidesToScroll),
            (n +=
              e.options.slidesToScroll <= e.options.slidesToShow
                ? e.options.slidesToScroll
                : e.options.slidesToShow);
        return s;
      }),
      (e.prototype.getSlick = function () {
        return this;
      }),
      (e.prototype.getSlideCount = function () {
        var e,
          i,
          n,
          s = this;
        return (
          (n =
            s.options.centerMode === !0
              ? s.slideWidth * Math.floor(s.options.slidesToShow / 2)
              : 0),
          s.options.swipeToSlide === !0
            ? (s.$slideTrack.find('.slick-slide').each(function (e, o) {
                if (o.offsetLeft - n + t(o).outerWidth() / 2 > s.swipeLeft * -1)
                  return (i = o), !1;
              }),
              (e =
                Math.abs(t(i).attr('data-slick-index') - s.currentSlide) || 1))
            : s.options.slidesToScroll
        );
      }),
      (e.prototype.goTo = e.prototype.slickGoTo =
        function (t, e) {
          var i = this;
          i.changeSlide({ data: { message: 'index', index: parseInt(t) } }, e);
        }),
      (e.prototype.init = function (e) {
        var i = this;
        t(i.$slider).hasClass('slick-initialized') ||
          (t(i.$slider).addClass('slick-initialized'),
          i.buildRows(),
          i.buildOut(),
          i.setProps(),
          i.startLoad(),
          i.loadSlider(),
          i.initializeEvents(),
          i.updateArrows(),
          i.updateDots(),
          i.checkResponsive(!0),
          i.focusHandler()),
          e && i.$slider.trigger('init', [i]),
          i.options.accessibility === !0 && i.initADA(),
          i.options.autoplay && ((i.paused = !1), i.autoPlay());
      }),
      (e.prototype.initADA = function () {
        var e = this;
        e.$slides
          .add(e.$slideTrack.find('.slick-cloned'))
          .attr({ 'aria-hidden': 'true', tabindex: '-1' })
          .find('a, input, button, select')
          .attr({ tabindex: '-1' }),
          e.$slideTrack.attr('role', 'listbox'),
          e.$slides.not(e.$slideTrack.find('.slick-cloned')).each(function (i) {
            t(this).attr({
              role: 'option',
              'aria-describedby': 'slick-slide' + e.instanceUid + i
            });
          }),
          null !== e.$dots &&
            e.$dots
              .attr('role', 'tablist')
              .find('li')
              .each(function (i) {
                t(this).attr({
                  role: 'presentation',
                  'aria-selected': 'false',
                  'aria-controls': 'navigation' + e.instanceUid + i,
                  id: 'slick-slide' + e.instanceUid + i
                });
              })
              .first()
              .attr('aria-selected', 'true')
              .end()
              .find('button')
              .attr('role', 'button')
              .end()
              .closest('div')
              .attr('role', 'toolbar'),
          e.activateADA();
      }),
      (e.prototype.initArrowEvents = function () {
        var t = this;
        t.options.arrows === !0 &&
          t.slideCount > t.options.slidesToShow &&
          (t.$prevArrow
            .off('click.slick')
            .on('click.slick', { message: 'previous' }, t.changeSlide),
          t.$nextArrow
            .off('click.slick')
            .on('click.slick', { message: 'next' }, t.changeSlide));
      }),
      (e.prototype.initDotEvents = function () {
        var e = this;
        e.options.dots === !0 &&
          e.slideCount > e.options.slidesToShow &&
          t('li', e.$dots).on(
            'click.slick',
            { message: 'index' },
            e.changeSlide
          ),
          e.options.dots === !0 &&
            e.options.pauseOnDotsHover === !0 &&
            t('li', e.$dots)
              .on('mouseenter.slick', t.proxy(e.interrupt, e, !0))
              .on('mouseleave.slick', t.proxy(e.interrupt, e, !1));
      }),
      (e.prototype.initSlideEvents = function () {
        var e = this;
        e.options.pauseOnHover &&
          (e.$list.on('mouseenter.slick', t.proxy(e.interrupt, e, !0)),
          e.$list.on('mouseleave.slick', t.proxy(e.interrupt, e, !1)));
      }),
      (e.prototype.initializeEvents = function () {
        var e = this;
        e.initArrowEvents(),
          e.initDotEvents(),
          e.initSlideEvents(),
          e.$list.on(
            'touchstart.slick mousedown.slick',
            { action: 'start' },
            e.swipeHandler
          ),
          e.$list.on(
            'touchmove.slick mousemove.slick',
            { action: 'move' },
            e.swipeHandler
          ),
          e.$list.on(
            'touchend.slick mouseup.slick',
            { action: 'end' },
            e.swipeHandler
          ),
          e.$list.on(
            'touchcancel.slick mouseleave.slick',
            { action: 'end' },
            e.swipeHandler
          ),
          e.$list.on('click.slick', e.clickHandler),
          t(document).on(e.visibilityChange, t.proxy(e.visibility, e)),
          e.options.accessibility === !0 &&
            e.$list.on('keydown.slick', e.keyHandler),
          e.options.focusOnSelect === !0 &&
            t(e.$slideTrack).children().on('click.slick', e.selectHandler),
          t(window).on(
            'orientationchange.slick.slick-' + e.instanceUid,
            t.proxy(e.orientationChange, e)
          ),
          t(window).on(
            'resize.slick.slick-' + e.instanceUid,
            t.proxy(e.resize, e)
          ),
          t('[draggable!=true]', e.$slideTrack).on(
            'dragstart',
            e.preventDefault
          ),
          t(window).on('load.slick.slick-' + e.instanceUid, e.setPosition),
          t(document).on('ready.slick.slick-' + e.instanceUid, e.setPosition);
      }),
      (e.prototype.initUI = function () {
        var t = this;
        t.options.arrows === !0 &&
          t.slideCount > t.options.slidesToShow &&
          (t.$prevArrow.show(), t.$nextArrow.show()),
          t.options.dots === !0 &&
            t.slideCount > t.options.slidesToShow &&
            t.$dots.show();
      }),
      (e.prototype.keyHandler = function (t) {
        var e = this;
        t.target.tagName.match('TEXTAREA|INPUT|SELECT') ||
          (37 === t.keyCode && e.options.accessibility === !0
            ? e.changeSlide({
                data: { message: e.options.rtl === !0 ? 'next' : 'previous' }
              })
            : 39 === t.keyCode &&
              e.options.accessibility === !0 &&
              e.changeSlide({
                data: { message: e.options.rtl === !0 ? 'previous' : 'next' }
              }));
      }),
      (e.prototype.lazyLoad = function () {
        function e(e) {
          t('img[data-lazy]', e).each(function () {
            var e = t(this),
              i = t(this).attr('data-lazy'),
              n = document.createElement('img');
            (n.onload = function () {
              e.animate({ opacity: 0 }, 100, function () {
                e.attr('src', i).animate({ opacity: 1 }, 200, function () {
                  e.removeAttr('data-lazy').removeClass('slick-loading');
                }),
                  r.$slider.trigger('lazyLoaded', [r, e, i]);
              });
            }),
              (n.onerror = function () {
                e
                  .removeAttr('data-lazy')
                  .removeClass('slick-loading')
                  .addClass('slick-lazyload-error'),
                  r.$slider.trigger('lazyLoadError', [r, e, i]);
              }),
              (n.src = i);
          });
        }
        var i,
          n,
          s,
          o,
          r = this;
        r.options.centerMode === !0
          ? r.options.infinite === !0
            ? ((s = r.currentSlide + (r.options.slidesToShow / 2 + 1)),
              (o = s + r.options.slidesToShow + 2))
            : ((s = Math.max(
                0,
                r.currentSlide - (r.options.slidesToShow / 2 + 1)
              )),
              (o = 2 + (r.options.slidesToShow / 2 + 1) + r.currentSlide))
          : ((s = r.options.infinite
              ? r.options.slidesToShow + r.currentSlide
              : r.currentSlide),
            (o = Math.ceil(s + r.options.slidesToShow)),
            r.options.fade === !0 && (s > 0 && s--, o <= r.slideCount && o++)),
          (i = r.$slider.find('.slick-slide').slice(s, o)),
          e(i),
          r.slideCount <= r.options.slidesToShow
            ? ((n = r.$slider.find('.slick-slide')), e(n))
            : r.currentSlide >= r.slideCount - r.options.slidesToShow
            ? ((n = r.$slider
                .find('.slick-cloned')
                .slice(0, r.options.slidesToShow)),
              e(n))
            : 0 === r.currentSlide &&
              ((n = r.$slider
                .find('.slick-cloned')
                .slice(r.options.slidesToShow * -1)),
              e(n));
      }),
      (e.prototype.loadSlider = function () {
        var t = this;
        t.setPosition(),
          t.$slideTrack.css({ opacity: 1 }),
          t.$slider.removeClass('slick-loading'),
          t.initUI(),
          'progressive' === t.options.lazyLoad && t.progressiveLazyLoad();
      }),
      (e.prototype.next = e.prototype.slickNext =
        function () {
          var t = this;
          t.changeSlide({ data: { message: 'next' } });
        }),
      (e.prototype.orientationChange = function () {
        var t = this;
        t.checkResponsive(), t.setPosition();
      }),
      (e.prototype.pause = e.prototype.slickPause =
        function () {
          var t = this;
          t.autoPlayClear(), (t.paused = !0);
        }),
      (e.prototype.play = e.prototype.slickPlay =
        function () {
          var t = this;
          t.autoPlay(),
            (t.options.autoplay = !0),
            (t.paused = !1),
            (t.focussed = !1),
            (t.interrupted = !1);
        }),
      (e.prototype.postSlide = function (t) {
        var e = this;
        e.unslicked ||
          (e.$slider.trigger('afterChange', [e, t]),
          (e.animating = !1),
          e.setPosition(),
          (e.swipeLeft = null),
          e.options.autoplay && e.autoPlay(),
          e.options.accessibility === !0 && e.initADA());
      }),
      (e.prototype.prev = e.prototype.slickPrev =
        function () {
          var t = this;
          t.changeSlide({ data: { message: 'previous' } });
        }),
      (e.prototype.preventDefault = function (t) {
        t.preventDefault();
      }),
      (e.prototype.progressiveLazyLoad = function (e) {
        e = e || 1;
        var i,
          n,
          s,
          o = this,
          r = t('img[data-lazy]', o.$slider);
        r.length
          ? ((i = r.first()),
            (n = i.attr('data-lazy')),
            (s = document.createElement('img')),
            (s.onload = function () {
              i
                .attr('src', n)
                .removeAttr('data-lazy')
                .removeClass('slick-loading'),
                o.options.adaptiveHeight === !0 && o.setPosition(),
                o.$slider.trigger('lazyLoaded', [o, i, n]),
                o.progressiveLazyLoad();
            }),
            (s.onerror = function () {
              e < 3
                ? setTimeout(function () {
                    o.progressiveLazyLoad(e + 1);
                  }, 500)
                : (i
                    .removeAttr('data-lazy')
                    .removeClass('slick-loading')
                    .addClass('slick-lazyload-error'),
                  o.$slider.trigger('lazyLoadError', [o, i, n]),
                  o.progressiveLazyLoad());
            }),
            (s.src = n))
          : o.$slider.trigger('allImagesLoaded', [o]);
      }),
      (e.prototype.refresh = function (e) {
        var i,
          n,
          s = this;
        (n = s.slideCount - s.options.slidesToShow),
          !s.options.infinite && s.currentSlide > n && (s.currentSlide = n),
          s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
          (i = s.currentSlide),
          s.destroy(!0),
          t.extend(s, s.initials, { currentSlide: i }),
          s.init(),
          e || s.changeSlide({ data: { message: 'index', index: i } }, !1);
      }),
      (e.prototype.registerBreakpoints = function () {
        var e,
          i,
          n,
          s = this,
          o = s.options.responsive || null;
        if ('array' === t.type(o) && o.length) {
          s.respondTo = s.options.respondTo || 'window';
          for (e in o)
            if (
              ((n = s.breakpoints.length - 1),
              (i = o[e].breakpoint),
              o.hasOwnProperty(e))
            ) {
              for (; n >= 0; )
                s.breakpoints[n] &&
                  s.breakpoints[n] === i &&
                  s.breakpoints.splice(n, 1),
                  n--;
              s.breakpoints.push(i), (s.breakpointSettings[i] = o[e].settings);
            }
          s.breakpoints.sort(function (t, e) {
            return s.options.mobileFirst ? t - e : e - t;
          });
        }
      }),
      (e.prototype.reinit = function () {
        var e = this;
        (e.$slides = e.$slideTrack
          .children(e.options.slide)
          .addClass('slick-slide')),
          (e.slideCount = e.$slides.length),
          e.currentSlide >= e.slideCount &&
            0 !== e.currentSlide &&
            (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
          e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
          e.registerBreakpoints(),
          e.setProps(),
          e.setupInfinite(),
          e.buildArrows(),
          e.updateArrows(),
          e.initArrowEvents(),
          e.buildDots(),
          e.updateDots(),
          e.initDotEvents(),
          e.cleanUpSlideEvents(),
          e.initSlideEvents(),
          e.checkResponsive(!1, !0),
          e.options.focusOnSelect === !0 &&
            t(e.$slideTrack).children().on('click.slick', e.selectHandler),
          e.setSlideClasses(
            'number' == typeof e.currentSlide ? e.currentSlide : 0
          ),
          e.setPosition(),
          e.focusHandler(),
          (e.paused = !e.options.autoplay),
          e.autoPlay(),
          e.$slider.trigger('reInit', [e]);
      }),
      (e.prototype.resize = function () {
        var e = this;
        t(window).width() !== e.windowWidth &&
          (clearTimeout(e.windowDelay),
          (e.windowDelay = window.setTimeout(function () {
            (e.windowWidth = t(window).width()),
              e.checkResponsive(),
              e.unslicked || e.setPosition();
          }, 50)));
      }),
      (e.prototype.removeSlide = e.prototype.slickRemove =
        function (t, e, i) {
          var n = this;
          return (
            'boolean' == typeof t
              ? ((e = t), (t = e === !0 ? 0 : n.slideCount - 1))
              : (t = e === !0 ? --t : t),
            !(n.slideCount < 1 || t < 0 || t > n.slideCount - 1) &&
              (n.unload(),
              i === !0
                ? n.$slideTrack.children().remove()
                : n.$slideTrack.children(this.options.slide).eq(t).remove(),
              (n.$slides = n.$slideTrack.children(this.options.slide)),
              n.$slideTrack.children(this.options.slide).detach(),
              n.$slideTrack.append(n.$slides),
              (n.$slidesCache = n.$slides),
              void n.reinit())
          );
        }),
      (e.prototype.setCSS = function (t) {
        var e,
          i,
          n = this,
          s = {};
        n.options.rtl === !0 && (t = -t),
          (e = 'left' == n.positionProp ? Math.ceil(t) + 'px' : '0px'),
          (i = 'top' == n.positionProp ? Math.ceil(t) + 'px' : '0px'),
          (s[n.positionProp] = t),
          n.transformsEnabled === !1
            ? n.$slideTrack.css(s)
            : ((s = {}),
              n.cssTransitions === !1
                ? ((s[n.animType] = 'translate(' + e + ', ' + i + ')'),
                  n.$slideTrack.css(s))
                : ((s[n.animType] = 'translate3d(' + e + ', ' + i + ', 0px)'),
                  n.$slideTrack.css(s)));
      }),
      (e.prototype.setDimensions = function () {
        var t = this;
        t.options.vertical === !1
          ? t.options.centerMode === !0 &&
            t.$list.css({ padding: '0px ' + t.options.centerPadding })
          : (t.$list.height(
              t.$slides.first().outerHeight(!0) * t.options.slidesToShow
            ),
            t.options.centerMode === !0 &&
              t.$list.css({ padding: t.options.centerPadding + ' 0px' })),
          (t.listWidth = t.$list.width()),
          (t.listHeight = t.$list.height()),
          t.options.vertical === !1 && t.options.variableWidth === !1
            ? ((t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow)),
              t.$slideTrack.width(
                Math.ceil(
                  t.slideWidth * t.$slideTrack.children('.slick-slide').length
                )
              ))
            : t.options.variableWidth === !0
            ? t.$slideTrack.width(5e3 * t.slideCount)
            : ((t.slideWidth = Math.ceil(t.listWidth)),
              t.$slideTrack.height(
                Math.ceil(
                  t.$slides.first().outerHeight(!0) *
                    t.$slideTrack.children('.slick-slide').length
                )
              ));
        var e = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
        t.options.variableWidth === !1 &&
          t.$slideTrack.children('.slick-slide').width(t.slideWidth - e);
      }),
      (e.prototype.setFade = function () {
        var e,
          i = this;
        i.$slides.each(function (n, s) {
          (e = i.slideWidth * n * -1),
            i.options.rtl === !0
              ? t(s).css({
                  position: 'relative',
                  right: e,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0
                })
              : t(s).css({
                  position: 'relative',
                  left: e,
                  top: 0,
                  zIndex: i.options.zIndex - 2,
                  opacity: 0
                });
        }),
          i.$slides
            .eq(i.currentSlide)
            .css({ zIndex: i.options.zIndex - 1, opacity: 1 });
      }),
      (e.prototype.setHeight = function () {
        var t = this;
        if (
          1 === t.options.slidesToShow &&
          t.options.adaptiveHeight === !0 &&
          t.options.vertical === !1
        ) {
          var e = t.$slides.eq(t.currentSlide).outerHeight(!0);
          t.$list.css('height', e);
        }
      }),
      (e.prototype.setOption = e.prototype.slickSetOption =
        function () {
          var e,
            i,
            n,
            s,
            o,
            r = this,
            a = !1;
          if (
            ('object' === t.type(arguments[0])
              ? ((n = arguments[0]), (a = arguments[1]), (o = 'multiple'))
              : 'string' === t.type(arguments[0]) &&
                ((n = arguments[0]),
                (s = arguments[1]),
                (a = arguments[2]),
                'responsive' === arguments[0] &&
                'array' === t.type(arguments[1])
                  ? (o = 'responsive')
                  : 'undefined' != typeof arguments[1] && (o = 'single')),
            'single' === o)
          )
            r.options[n] = s;
          else if ('multiple' === o)
            t.each(n, function (t, e) {
              r.options[t] = e;
            });
          else if ('responsive' === o)
            for (i in s)
              if ('array' !== t.type(r.options.responsive))
                r.options.responsive = [s[i]];
              else {
                for (e = r.options.responsive.length - 1; e >= 0; )
                  r.options.responsive[e].breakpoint === s[i].breakpoint &&
                    r.options.responsive.splice(e, 1),
                    e--;
                r.options.responsive.push(s[i]);
              }
          a && (r.unload(), r.reinit());
        }),
      (e.prototype.setPosition = function () {
        var t = this;
        t.setDimensions(),
          t.setHeight(),
          t.options.fade === !1
            ? t.setCSS(t.getLeft(t.currentSlide))
            : t.setFade(),
          t.$slider.trigger('setPosition', [t]);
      }),
      (e.prototype.setProps = function () {
        var t = this,
          e = document.body.style;
        (t.positionProp = t.options.vertical === !0 ? 'top' : 'left'),
          'top' === t.positionProp
            ? t.$slider.addClass('slick-vertical')
            : t.$slider.removeClass('slick-vertical'),
          (void 0 === e.WebkitTransition &&
            void 0 === e.MozTransition &&
            void 0 === e.msTransition) ||
            (t.options.useCSS === !0 && (t.cssTransitions = !0)),
          t.options.fade &&
            ('number' == typeof t.options.zIndex
              ? t.options.zIndex < 3 && (t.options.zIndex = 3)
              : (t.options.zIndex = t.defaults.zIndex)),
          void 0 !== e.OTransform &&
            ((t.animType = 'OTransform'),
            (t.transformType = '-o-transform'),
            (t.transitionType = 'OTransition'),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (t.animType = !1)),
          void 0 !== e.MozTransform &&
            ((t.animType = 'MozTransform'),
            (t.transformType = '-moz-transform'),
            (t.transitionType = 'MozTransition'),
            void 0 === e.perspectiveProperty &&
              void 0 === e.MozPerspective &&
              (t.animType = !1)),
          void 0 !== e.webkitTransform &&
            ((t.animType = 'webkitTransform'),
            (t.transformType = '-webkit-transform'),
            (t.transitionType = 'webkitTransition'),
            void 0 === e.perspectiveProperty &&
              void 0 === e.webkitPerspective &&
              (t.animType = !1)),
          void 0 !== e.msTransform &&
            ((t.animType = 'msTransform'),
            (t.transformType = '-ms-transform'),
            (t.transitionType = 'msTransition'),
            void 0 === e.msTransform && (t.animType = !1)),
          void 0 !== e.transform &&
            t.animType !== !1 &&
            ((t.animType = 'transform'),
            (t.transformType = 'transform'),
            (t.transitionType = 'transition')),
          (t.transformsEnabled =
            t.options.useTransform && null !== t.animType && t.animType !== !1);
      }),
      (e.prototype.setSlideClasses = function (t) {
        var e,
          i,
          n,
          s,
          o = this;
        (i = o.$slider
          .find('.slick-slide')
          .removeClass('slick-active slick-center slick-current')
          .attr('aria-hidden', 'true')),
          o.$slides.eq(t).addClass('slick-current'),
          o.options.centerMode === !0
            ? ((e = Math.floor(o.options.slidesToShow / 2)),
              o.options.infinite === !0 &&
                (t >= e && t <= o.slideCount - 1 - e
                  ? o.$slides
                      .slice(t - e, t + e + 1)
                      .addClass('slick-active')
                      .attr('aria-hidden', 'false')
                  : ((n = o.options.slidesToShow + t),
                    i
                      .slice(n - e + 1, n + e + 2)
                      .addClass('slick-active')
                      .attr('aria-hidden', 'false')),
                0 === t
                  ? i
                      .eq(i.length - 1 - o.options.slidesToShow)
                      .addClass('slick-center')
                  : t === o.slideCount - 1 &&
                    i.eq(o.options.slidesToShow).addClass('slick-center')),
              o.$slides.eq(t).addClass('slick-center'))
            : t >= 0 && t <= o.slideCount - o.options.slidesToShow
            ? o.$slides
                .slice(t, t + o.options.slidesToShow)
                .addClass('slick-active')
                .attr('aria-hidden', 'false')
            : i.length <= o.options.slidesToShow
            ? i.addClass('slick-active').attr('aria-hidden', 'false')
            : ((s = o.slideCount % o.options.slidesToShow),
              (n = o.options.infinite === !0 ? o.options.slidesToShow + t : t),
              o.options.slidesToShow == o.options.slidesToScroll &&
              o.slideCount - t < o.options.slidesToShow
                ? i
                    .slice(n - (o.options.slidesToShow - s), n + s)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false')
                : i
                    .slice(n, n + o.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false')),
          'ondemand' === o.options.lazyLoad && o.lazyLoad();
      }),
      (e.prototype.setupInfinite = function () {
        var e,
          i,
          n,
          s = this;
        if (
          (s.options.fade === !0 && (s.options.centerMode = !1),
          s.options.infinite === !0 &&
            s.options.fade === !1 &&
            ((i = null), s.slideCount > s.options.slidesToShow))
        ) {
          for (
            n =
              s.options.centerMode === !0
                ? s.options.slidesToShow + 1
                : s.options.slidesToShow,
              e = s.slideCount;
            e > s.slideCount - n;
            e -= 1
          )
            (i = e - 1),
              t(s.$slides[i])
                .clone(!0)
                .attr('id', '')
                .attr('data-slick-index', i - s.slideCount)
                .prependTo(s.$slideTrack)
                .addClass('slick-cloned');
          for (e = 0; e < n; e += 1)
            (i = e),
              t(s.$slides[i])
                .clone(!0)
                .attr('id', '')
                .attr('data-slick-index', i + s.slideCount)
                .appendTo(s.$slideTrack)
                .addClass('slick-cloned');
          s.$slideTrack
            .find('.slick-cloned')
            .find('[id]')
            .each(function () {
              t(this).attr('id', '');
            });
        }
      }),
      (e.prototype.interrupt = function (t) {
        var e = this;
        t || e.autoPlay(), (e.interrupted = t);
      }),
      (e.prototype.selectHandler = function (e) {
        var i = this,
          n = t(e.target).is('.slick-slide')
            ? t(e.target)
            : t(e.target).parents('.slick-slide'),
          s = parseInt(n.attr('data-slick-index'));
        return (
          s || (s = 0),
          i.slideCount <= i.options.slidesToShow
            ? (i.setSlideClasses(s), void i.asNavFor(s))
            : void i.slideHandler(s)
        );
      }),
      (e.prototype.slideHandler = function (t, e, i) {
        var n,
          s,
          o,
          r,
          a,
          l = null,
          c = this;
        if (
          ((e = e || !1),
          (c.animating !== !0 || c.options.waitForAnimate !== !0) &&
            !(
              (c.options.fade === !0 && c.currentSlide === t) ||
              c.slideCount <= c.options.slidesToShow
            ))
        )
          return (
            e === !1 && c.asNavFor(t),
            (n = t),
            (l = c.getLeft(n)),
            (r = c.getLeft(c.currentSlide)),
            (c.currentLeft = null === c.swipeLeft ? r : c.swipeLeft),
            c.options.infinite === !1 &&
            c.options.centerMode === !1 &&
            (t < 0 || t > c.getDotCount() * c.options.slidesToScroll)
              ? void (
                  c.options.fade === !1 &&
                  ((n = c.currentSlide),
                  i !== !0
                    ? c.animateSlide(r, function () {
                        c.postSlide(n);
                      })
                    : c.postSlide(n))
                )
              : c.options.infinite === !1 &&
                c.options.centerMode === !0 &&
                (t < 0 || t > c.slideCount - c.options.slidesToScroll)
              ? void (
                  c.options.fade === !1 &&
                  ((n = c.currentSlide),
                  i !== !0
                    ? c.animateSlide(r, function () {
                        c.postSlide(n);
                      })
                    : c.postSlide(n))
                )
              : (c.options.autoplay && clearInterval(c.autoPlayTimer),
                (s =
                  n < 0
                    ? c.slideCount % c.options.slidesToScroll !== 0
                      ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                      : c.slideCount + n
                    : n >= c.slideCount
                    ? c.slideCount % c.options.slidesToScroll !== 0
                      ? 0
                      : n - c.slideCount
                    : n),
                (c.animating = !0),
                c.$slider.trigger('beforeChange', [c, c.currentSlide, s]),
                (o = c.currentSlide),
                (c.currentSlide = s),
                c.setSlideClasses(c.currentSlide),
                c.options.asNavFor &&
                  ((a = c.getNavTarget()),
                  (a = a.slick('getSlick')),
                  a.slideCount <= a.options.slidesToShow &&
                    a.setSlideClasses(c.currentSlide)),
                c.updateDots(),
                c.updateArrows(),
                c.options.fade === !0
                  ? (i !== !0
                      ? (c.fadeSlideOut(o),
                        c.fadeSlide(s, function () {
                          c.postSlide(s);
                        }))
                      : c.postSlide(s),
                    void c.animateHeight())
                  : void (i !== !0
                      ? c.animateSlide(l, function () {
                          c.postSlide(s);
                        })
                      : c.postSlide(s)))
          );
      }),
      (e.prototype.startLoad = function () {
        var t = this;
        t.options.arrows === !0 &&
          t.slideCount > t.options.slidesToShow &&
          (t.$prevArrow.hide(), t.$nextArrow.hide()),
          t.options.dots === !0 &&
            t.slideCount > t.options.slidesToShow &&
            t.$dots.hide(),
          t.$slider.addClass('slick-loading');
      }),
      (e.prototype.swipeDirection = function () {
        var t,
          e,
          i,
          n,
          s = this;
        return (
          (t = s.touchObject.startX - s.touchObject.curX),
          (e = s.touchObject.startY - s.touchObject.curY),
          (i = Math.atan2(e, t)),
          (n = Math.round((180 * i) / Math.PI)),
          n < 0 && (n = 360 - Math.abs(n)),
          n <= 45 && n >= 0
            ? s.options.rtl === !1
              ? 'left'
              : 'right'
            : n <= 360 && n >= 315
            ? s.options.rtl === !1
              ? 'left'
              : 'right'
            : n >= 135 && n <= 225
            ? s.options.rtl === !1
              ? 'right'
              : 'left'
            : s.options.verticalSwiping === !0
            ? n >= 35 && n <= 135
              ? 'down'
              : 'up'
            : 'vertical'
        );
      }),
      (e.prototype.swipeEnd = function (t) {
        var e,
          i,
          n = this;
        if (
          ((n.dragging = !1),
          (n.interrupted = !1),
          (n.shouldClick = !(n.touchObject.swipeLength > 10)),
          void 0 === n.touchObject.curX)
        )
          return !1;
        if (
          (n.touchObject.edgeHit === !0 &&
            n.$slider.trigger('edge', [n, n.swipeDirection()]),
          n.touchObject.swipeLength >= n.touchObject.minSwipe)
        ) {
          switch ((i = n.swipeDirection())) {
            case 'left':
            case 'down':
              (e = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide + n.getSlideCount())
                : n.currentSlide + n.getSlideCount()),
                (n.currentDirection = 0);
              break;
            case 'right':
            case 'up':
              (e = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide - n.getSlideCount())
                : n.currentSlide - n.getSlideCount()),
                (n.currentDirection = 1);
          }
          'vertical' != i &&
            (n.slideHandler(e),
            (n.touchObject = {}),
            n.$slider.trigger('swipe', [n, i]));
        } else
          n.touchObject.startX !== n.touchObject.curX &&
            (n.slideHandler(n.currentSlide), (n.touchObject = {}));
      }),
      (e.prototype.swipeHandler = function (t) {
        var e = this;
        if (
          !(
            e.options.swipe === !1 ||
            ('ontouchend' in document && e.options.swipe === !1) ||
            (e.options.draggable === !1 && t.type.indexOf('mouse') !== -1)
          )
        )
          switch (
            ((e.touchObject.fingerCount =
              t.originalEvent && void 0 !== t.originalEvent.touches
                ? t.originalEvent.touches.length
                : 1),
            (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
            e.options.verticalSwiping === !0 &&
              (e.touchObject.minSwipe =
                e.listHeight / e.options.touchThreshold),
            t.data.action)
          ) {
            case 'start':
              e.swipeStart(t);
              break;
            case 'move':
              e.swipeMove(t);
              break;
            case 'end':
              e.swipeEnd(t);
          }
      }),
      (e.prototype.swipeMove = function (t) {
        var e,
          i,
          n,
          s,
          o,
          r = this;
        return (
          (o = void 0 !== t.originalEvent ? t.originalEvent.touches : null),
          !(!r.dragging || (o && 1 !== o.length)) &&
            ((e = r.getLeft(r.currentSlide)),
            (r.touchObject.curX = void 0 !== o ? o[0].pageX : t.clientX),
            (r.touchObject.curY = void 0 !== o ? o[0].pageY : t.clientY),
            (r.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))
            )),
            r.options.verticalSwiping === !0 &&
              (r.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(r.touchObject.curY - r.touchObject.startY, 2)
                )
              )),
            (i = r.swipeDirection()),
            'vertical' !== i
              ? (void 0 !== t.originalEvent &&
                  r.touchObject.swipeLength > 4 &&
                  t.preventDefault(),
                (s =
                  (r.options.rtl === !1 ? 1 : -1) *
                  (r.touchObject.curX > r.touchObject.startX ? 1 : -1)),
                r.options.verticalSwiping === !0 &&
                  (s = r.touchObject.curY > r.touchObject.startY ? 1 : -1),
                (n = r.touchObject.swipeLength),
                (r.touchObject.edgeHit = !1),
                r.options.infinite === !1 &&
                  ((0 === r.currentSlide && 'right' === i) ||
                    (r.currentSlide >= r.getDotCount() && 'left' === i)) &&
                  ((n = r.touchObject.swipeLength * r.options.edgeFriction),
                  (r.touchObject.edgeHit = !0)),
                r.options.vertical === !1
                  ? (r.swipeLeft = e + n * s)
                  : (r.swipeLeft =
                      e + n * (r.$list.height() / r.listWidth) * s),
                r.options.verticalSwiping === !0 && (r.swipeLeft = e + n * s),
                r.options.fade !== !0 &&
                  r.options.touchMove !== !1 &&
                  (r.animating === !0
                    ? ((r.swipeLeft = null), !1)
                    : void r.setCSS(r.swipeLeft)))
              : void 0)
        );
      }),
      (e.prototype.swipeStart = function (t) {
        var e,
          i = this;
        return (
          (i.interrupted = !0),
          1 !== i.touchObject.fingerCount ||
          i.slideCount <= i.options.slidesToShow
            ? ((i.touchObject = {}), !1)
            : (void 0 !== t.originalEvent &&
                void 0 !== t.originalEvent.touches &&
                (e = t.originalEvent.touches[0]),
              (i.touchObject.startX = i.touchObject.curX =
                void 0 !== e ? e.pageX : t.clientX),
              (i.touchObject.startY = i.touchObject.curY =
                void 0 !== e ? e.pageY : t.clientY),
              void (i.dragging = !0))
        );
      }),
      (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
        function () {
          var t = this;
          null !== t.$slidesCache &&
            (t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.appendTo(t.$slideTrack),
            t.reinit());
        }),
      (e.prototype.unload = function () {
        var e = this;
        t('.slick-cloned', e.$slider).remove(),
          e.$dots && e.$dots.remove(),
          e.$prevArrow &&
            e.htmlExpr.test(e.options.prevArrow) &&
            e.$prevArrow.remove(),
          e.$nextArrow &&
            e.htmlExpr.test(e.options.nextArrow) &&
            e.$nextArrow.remove(),
          e.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');
      }),
      (e.prototype.unslick = function (t) {
        var e = this;
        e.$slider.trigger('unslick', [e, t]), e.destroy();
      }),
      (e.prototype.updateArrows = function () {
        var t,
          e = this;
        (t = Math.floor(e.options.slidesToShow / 2)),
          e.options.arrows === !0 &&
            e.slideCount > e.options.slidesToShow &&
            !e.options.infinite &&
            (e.$prevArrow
              .removeClass('slick-disabled')
              .attr('aria-disabled', 'false'),
            e.$nextArrow
              .removeClass('slick-disabled')
              .attr('aria-disabled', 'false'),
            0 === e.currentSlide
              ? (e.$prevArrow
                  .addClass('slick-disabled')
                  .attr('aria-disabled', 'true'),
                e.$nextArrow
                  .removeClass('slick-disabled')
                  .attr('aria-disabled', 'false'))
              : e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                e.options.centerMode === !1
              ? (e.$nextArrow
                  .addClass('slick-disabled')
                  .attr('aria-disabled', 'true'),
                e.$prevArrow
                  .removeClass('slick-disabled')
                  .attr('aria-disabled', 'false'))
              : e.currentSlide >= e.slideCount - 1 &&
                e.options.centerMode === !0 &&
                (e.$nextArrow
                  .addClass('slick-disabled')
                  .attr('aria-disabled', 'true'),
                e.$prevArrow
                  .removeClass('slick-disabled')
                  .attr('aria-disabled', 'false')));
      }),
      (e.prototype.updateDots = function () {
        var t = this;
        null !== t.$dots &&
          (t.$dots
            .find('li')
            .removeClass('slick-active')
            .attr('aria-hidden', 'true'),
          t.$dots
            .find('li')
            .eq(Math.floor(t.currentSlide / t.options.slidesToScroll))
            .addClass('slick-active')
            .attr('aria-hidden', 'false'));
      }),
      (e.prototype.visibility = function () {
        var t = this;
        t.options.autoplay &&
          (document[t.hidden] ? (t.interrupted = !0) : (t.interrupted = !1));
      }),
      (t.fn.slick = function () {
        var t,
          i,
          n = this,
          s = arguments[0],
          o = Array.prototype.slice.call(arguments, 1),
          r = n.length;
        for (t = 0; t < r; t++)
          if (
            ('object' == typeof s || 'undefined' == typeof s
              ? (n[t].slick = new e(n[t], s))
              : n[t].slick && (i = n[t].slick[s].apply(n[t].slick, o)),
            'undefined' != typeof i)
          )
            return i;
        return n;
      });
  }),
  (function (t) {
    'use strict';
    var e = function (e, i) {
      function n(t) {
        var e;
        return (e = parseFloat(t)), (e = 1e3 * e);
      }
      function s(i) {
        var s = e[0].getAttribute('data-flash-delay'),
          o = e[0].getAttribute('data-flash-duration');
        s && (r = t.extend({}, a, { delay: s })),
          o && (r = t.extend({}, r || a, { duration: o })),
          (r = i ? t.extend({}, r || a, i) : t.extend({}, r || a)),
          (r.delay = n(r.delay)),
          (r.duration = n(r.duration));
      }
      function o(t) {
        s(t),
          setTimeout(function () {
            e.addClass('flash'),
              setTimeout(function () {
                e.removeClass('flash');
              }, r.duration);
          }, r.delay);
      }
      var r = {},
        a = { duration: 0.5, delay: 0.5 };
      o(i);
    };
    t.fn.flash = function (i) {
      return this.each(function () {
        var n = i === !1 || 'destroy' === i,
          s = t(this);
        return (
          s.data('flash') || n
            ? s.data('flash') && n && s.data('flash').destroy()
            : s.data('flash', new e(s, i)),
          s
        );
      });
    };
  })(jQuery),
  (function (t, e) {
    'use strict';
    t.config = {
      activeClass: 'target-active',
      attributes: {
        Toggle: 'data-target-toggle',
        Show: 'data-target-show',
        Hide: 'data-target-hide',
        Clickoff: 'data-target-clickoff',
        Increment: 'data-target-increment',
        Decrement: 'data-target-decrement',
        Scrollbox: 'data-target-scrollbox',
        Grid: 'data-target-grid',
        Src: 'data-target-src',
        Filetext: 'data-target-filetext',
        Accordion: 'data-target-accordion',
        Scroll: 'data-target-scroll',
        Height: 'data-target-height',
        disable: 'data-target-disable',
        max: 'data-target-max',
        min: 'data-target-min'
      },
      breakpoints: { tablet: 768, desktop: 1025, large: 1440 },
      observeDom: !1,
      debounceDelay: 100
    };
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.utils = {
      mixin: function (t, e) {
        var i, n, s, o;
        for (i in e)
          if (
            e.hasOwnProperty(i) &&
            ((s = e[i]),
            (n = t[i]),
            (t[i] = e[i]),
            'object' == typeof n && 'object' == typeof s)
          )
            for (o in s) s.hasOwnProperty(o) && (n[o] = s[o]);
      },
      forEach: window.Array.prototype.forEach,
      contains: function (t, e) {
        var i,
          n = window.Array.prototype.indexOf.apply(t, [e]);
        return (i = n !== -1);
      },
      debounce: function (t, e, i) {
        var n;
        return function () {
          var s = this,
            o = arguments,
            r = function () {
              (n = null), i || t.apply(s, o);
            },
            a = i && !n;
          clearTimeout(n), (n = setTimeout(r, e)), a && t.apply(s, o);
        };
      },
      values: function (t) {
        var e = [];
        for (var i in t) t.hasOwnProperty(i) && e.push(t[i]);
        return e;
      },
      qs: document.querySelector.bind(document),
      qsa: document.querySelectorAll.bind(document),
      stripBrackets: function (t) {
        return t.replace('[', '').replace(']', '');
      },
      capitalize: function (t) {
        return t.charAt(0).toUpperCase() + t.slice(1);
      },
      isDescendant: function (t, e) {
        for (var i = e.parentNode; null !== i; ) {
          if (i === t) return !0;
          i = i.parentNode;
        }
        return !1;
      },
      noop: function () {},
      forIn: function (t, e) {
        var i;
        for (i in t) t.hasOwnProperty(i) && e(i, t);
      },
      render: (function () {
        return window.requestAnimationFrame
          ? function (t) {
              window.requestAnimationFrame(function () {
                t();
              });
            }
          : function (t) {
              t();
            };
      })(),
      isIOS: (function (t) {
        return t.match(/iphone/gi) || t.match(/ipad/gi);
      })(window.navigator.userAgent)
    };
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Queue = window.Proto.extend({
      init: function () {
        this.items = [];
      },
      push: function (t) {
        this.items.push(t);
      },
      next: function () {
        var t;
        this.items.length && (t = this.items.shift())();
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.UI = window.Proto.extend({
      init: function (t, e, i, n) {
        (this.id = e),
          (this.componentType = n),
          (this.config = i.config),
          (this.events = i.events),
          (this.utils = i.utils),
          (this.el = t),
          (this.NODE_NAME = t.nodeName),
          (this.disabled = !1),
          this.el.setAttribute('data-target-' + n + '-id', this.id),
          (this.eventHandlers = {}),
          this.addEventHandler('resize', this.setDisabled),
          this.config.observeDom &&
            this.addEventHandler('attributes.mutation', this.handleAttMutation),
          this.addEventHandler('show', this.onShow),
          this.addEventHandler('hide', this.onHide),
          (this.domEventHandlers = {}),
          this.updateAtts();
      },
      addEventHandler: function (t, e) {
        this.eventHandlers[t] = this.events.subscribe(t, e, {}, this);
      },
      addDomEventHandler: function (t, e, i) {
        var n = this,
          s = function (t) {
            e.apply(n, [t]);
          };
        i || (i = this.el),
          (this.domEventHandlers[t] = { cb: s, el: i }),
          i.addEventListener(t, s, !1);
      },
      removeEventHandler: function (t) {
        this.events.remove(t, this.eventHandlers[t].id);
      },
      removeDomEventHandler: function (t) {
        this.domEventHandlers[t] = this.domEventHandlers[
          t
        ].el.removeEventListener(t, this.domEventHandlers[t].cb);
      },
      destroy: function () {
        var t = this;
        this.utils.forIn(this.eventHandlers, function (e) {
          t.removeEventHandler(e);
        }),
          this.utils.forIn(this.domEventHandlers, function (e) {
            t.removeEventHandler(e);
          });
      },
      handleAttMutation: function (t) {
        t === this.el && this.updateAtts();
      },
      updateAtts: function () {
        (this.disableLayouts = this.el.getAttribute(
          this.config.attributes.disable
        )),
          this.disableLayouts
            ? (this.disableLayouts = this.disableLayouts.split(' '))
            : (this.disableLayouts = []),
          this.events.publish('update', this.id);
      },
      setDisabled: function (t) {
        var e,
          i,
          n,
          s = !1;
        for (e = 0, i = this.disableLayouts.length; e < i; e++)
          if (((n = this.disableLayouts[e]), t[n]() && !this.overrideLayouts)) {
            (s = !0), this.disable(!0);
            break;
          }
        s || this.overrideLayouts || this.enable(!0);
      },
      isDisabled: function () {
        return this.disabled;
      },
      disable: function (t) {
        return (this.overrideLayouts = !t), (this.disabled = !0), this;
      },
      enable: function (t) {
        return (this.overrideLayouts = !t), (this.disabled = !1), this;
      },
      show: function (t) {
        var e = this;
        t.classList.contains(this.config.activeClass) ||
          this.utils.render(function () {
            t.classList.add(e.config.activeClass), e.events.publish('show', t);
          });
      },
      hide: function (t) {
        var e = this;
        t.classList.contains(this.config.activeClass) &&
          this.utils.render(function () {
            t.classList.remove(e.config.activeClass),
              e.events.publish('hide', t);
          });
      },
      onShow: function (t) {
        this.targets &&
          this.utils.contains(this.targets, t) &&
          this.show(this.el);
      },
      onHide: function (t) {
        this.targets &&
          this.utils.contains(this.targets, t) &&
          this.hide(this.el);
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.API = window.Proto.extend({
      init: function (t) {
        var e = this;
        (this.utils = t.utils),
          (this.events = t.events),
          (this.componentFactory = t.componentFactory),
          (this.eventHandlers = {}),
          ['get', 'on', 'off', 'show', 'hide', 'toggle', 'bind'].forEach(
            function (i) {
              t[i] = e[i].bind(e);
            }
          );
      },
      normalize: function (t) {
        return 'string' == typeof t && (t = this.utils.qs(t)), t;
      },
      normalizeEls: function (t) {
        return (t =
          'string' == typeof t ? this.utils.qsa(t) : t.length ? t : [t]);
      },
      get: function (t) {
        var e;
        if (((t = this.normalize(t)), (e = this.componentFactory.find(t)), !e))
          throw (
            'Target.js Error at target.api.get(): ' +
            t.toString() +
            ' is not a Target.js element.'
          );
        return e;
      },
      show: function (t) {
        var e = this.componentFactory.use('Show', this.normalizeEls(t));
        return (
          this.utils.forEach.call(e.targets, function (t) {
            e.show(t);
          }),
          this
        );
      },
      hide: function (t) {
        var e = this.componentFactory.use('Hide', this.normalizeEls(t));
        return (
          this.utils.forEach.call(e.targets, function (t) {
            e.hide(t);
          }),
          this
        );
      },
      toggle: function (t) {
        var e = this.componentFactory.use('Toggle', this.normalizeEls(t));
        return (
          this.utils.forEach.call(e.targets, function (t) {
            e.toggle(t);
          }),
          this
        );
      },
      onWindowEvent: function (t, e) {
        return (
          this.eventHandlers[t] || (this.eventHandlers[t] = []),
          this.eventHandlers[t].push({
            cb: e,
            event: this.events.subscribe(t, e)
          }),
          this
        );
      },
      offWindowEvent: function (t, e) {
        var i = this,
          n = [];
        return (
          this.eventHandlers[t].forEach(function (s) {
            s.cb !== e ? n.push(s) : i.events.remove(t, s.event.id);
          }),
          (this.eventHandlers[t] = n),
          this
        );
      },
      onElEvent: function (t, e, i) {
        var n = this;
        return (
          (e = this.normalizeEls(e)),
          this.eventHandlers[t] || (this.eventHandlers[t] = []),
          this.utils.forEach.call(e, function (e) {
            n.eventHandlers[t].push({
              cb: i,
              el: e,
              event: n.events.subscribe(
                t,
                (function (t) {
                  return function (e) {
                    e === t && i(t);
                  };
                })(e)
              )
            });
          }),
          this
        );
      },
      offElEvent: function (t, e, i) {
        var n = this,
          s = [];
        return (
          (e = this.normalizeEls(e)),
          this.eventHandlers[t].forEach(function (o) {
            n.utils.contains(e, o.el) && i === i
              ? n.events.remove(t, o.event.id)
              : s.push(o);
          }),
          (this.eventHandlers[t] = s),
          this
        );
      },
      on: function (t, e, i) {
        return (
          'function' == typeof e
            ? this.onWindowEvent(t, e)
            : this.onElEvent(t, e, i),
          this
        );
      },
      off: function (t, e, i) {
        return (
          'function' == typeof e
            ? this.offWindowEvent(t, e)
            : this.offElEvent(t, e, i),
          this
        );
      },
      bind: function (t) {
        (t = this.normalize(t)), this.componentFactory.start(t);
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.ComponentFactory = window.Proto.extend({
      init: function (t) {
        var e;
        (this.events = t.events),
          (this.config = t.config),
          (this.utils = t.utils),
          (this.target = t),
          (this.topId = 0),
          (this.components = {}),
          (e = Object.keys(this.config.attributes)),
          (this.IGNORE_ATTS = ['disable', 'min', 'max']),
          (this.COMPONENT_CLASSES = e.filter(function (t) {
            return this.IGNORE_ATTS.indexOf(t) === -1;
          }, this)),
          this.config.observeDom &&
            this.events.subscribe('nodeadded.mutation', this.build, {}, this);
      },
      build: function (t, e) {
        var i;
        this.IGNORE_ATTS.indexOf(t) === -1 &&
          null === e.getAttribute('data-target-' + t + '-id') &&
          ((i = this.target[t]),
          this.topId++,
          (this.components[this.topId] = i.create(
            e,
            this.topId,
            this.target,
            t
          )));
      },
      initComponent: function (t, e) {
        var i,
          n = this,
          s = this.target[t],
          o = '[' + n.config.attributes[t] + ']';
        (i = e ? e.querySelectorAll(o) : n.utils.qsa(o)),
          this.utils.forEach.call(i, function (e, i) {
            n.topId++,
              (n.components[n.topId] = s.create(e, n.topId, n.target, t));
          });
      },
      find: function (t) {
        var e = !1;
        return (
          this.utils.forIn(this.components, function (i, n) {
            n[i].el === t && (e = n[i]);
          }),
          e
        );
      },
      get: function (t) {
        return this.components[t];
      },
      use: function (t, e) {
        var i = document.createElement('div'),
          n = this.target[t],
          s = n.create(i, 'tmp', this.target, t);
        return (s.targets = e), s;
      },
      start: function (t) {
        var e = this;
        this.COMPONENT_CLASSES.forEach(function (i) {
          e.initComponent(i, t);
        });
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.DomObserver = window.Proto.extend({
      init: function (t) {
        var e = this;
        (this.TEXT_NODE = 3),
          (this.COMMENT_NODE = 8),
          (this.events = t.events),
          (this.config = t.config),
          (this.utils = t.utils),
          (this.observer = new window.MutationObserver(function (t, i) {
            e.onMutation(t, i);
          })),
          this.observer.observe(document.body, {
            subtree: !0,
            childList: !0,
            attributes: !0,
            attributeFilter: t.utils.values(e.config.attributes)
          });
      },
      publishAddedNodes: function (t) {
        var e = this;
        this.utils.forEach.call(t, function (t) {
          t.nodeType !== e.TEXT_NODE &&
            t.nodeType !== e.COMMENT_NODE &&
            e.utils.forIn(e.config.attributes, function (i, n) {
              var s = n[i];
              t.getAttribute(s) && e.events.publish('nodeadded.mutation', i, t);
            });
        });
      },
      onMutation: function (t, e) {
        var i = this;
        t.forEach(function (t) {
          switch (t.type) {
            case 'attributes':
              i.events.publish('attributes.mutation', t.target);
              break;
            case 'childList':
              i.publishAddedNodes(t.addedNodes);
              break;
            default:
              i.utils.noop();
          }
        });
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Window = window.Proto.extend({
      init: function (t) {
        var e = this;
        (this.w = document.documentElement.clientWidth),
          (this.h = document.documentElement.clientHeight),
          (this.events = t.events),
          (this.config = t.config),
          (this.utils = t.utils),
          (this.is = {
            mobile: function () {
              return e.w < e.config.breakpoints.tablet;
            },
            tablet: function () {
              return (
                e.w >= e.config.breakpoints.tablet &&
                e.w < e.config.breakpoints.desktop
              );
            },
            desktop: function () {
              return e.w >= e.config.breakpoints.desktop;
            },
            large: function () {
              return e.w >= e.config.breakpoints.large;
            }
          }),
          window.addEventListener(
            'resize',
            this.utils.debounce(function (t) {
              e.onResize();
            }, this.config.debounceDelay),
            !1
          ),
          window.addEventListener('scroll', function (t) {
            e.onScroll();
          }),
          window.addEventListener('load', function () {
            e.onResize();
          }),
          (this.currentLayout = ''),
          this.events.subscribe('update', function (t) {
            e.update(t);
          });
      },
      width: function () {
        return this.w;
      },
      height: function () {
        return this.h;
      },
      onScroll: function (t) {
        this.events.publish('scroll', window.pageYOffset);
      },
      onResize: function () {
        (this.w = document.documentElement.clientWidth),
          (this.h = document.documentElement.clientHeight),
          this.update();
      },
      update: function (t) {
        var e = '';
        t || (t = ''),
          this.utils.forIn(this.is, function (t, i) {
            i[t]() && (e = t);
          }),
          (this.currentLayout = e),
          this.events.publish(
            'resize' + t,
            this.is,
            this.width(),
            this.height()
          ),
          e !== this.currentLayout &&
            this.events.publish(e, this.width(), this.height());
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Accordion = t.UI.extend({
      init: function (t, e, i, n) {
        var s = this;
        if (
          (this._super.apply(this, arguments),
          this.setArgs(),
          this.setToggles(),
          this.setContents(),
          this.toggles.length !== this.contents.length)
        )
          throw 'Target.js Error on Accordion component: component must contain an equal number of toggles and contents';
        (this.current = null),
          this.utils.forEach.call(this.toggles, function (t, e) {
            s.addDomEventHandler('click', s.toggle(t, e), t);
          });
      },
      setArgs: function () {
        var t = this.el.getAttribute(
          this.utils.stripBrackets(this.config.attributes.Accordion)
        );
        if (((t = t.split(',')), (this.args = t), 2 !== this.args.length))
          throw (
            'Target.js Error on Accordion component: the value of "' +
            this.utils.stripBrackets(this.config.attributes.Accordion) +
            '" must contain two comma-separated CSS selectors'
          );
        return this.args;
      },
      setToggles: function () {
        return (this.toggles = this.utils.qsa(this.args[0])), this.toggles;
      },
      setContents: function () {
        return (this.contents = this.utils.qsa(this.args[1])), this.contents;
      },
      toggle: function (t, e) {
        return function (i) {
          var n = this;
          this.isDisabled() ||
            ('A' === t.nodeType && i.preventDefault(),
            this.current === e
              ? ((this.current = null),
                this.hide(this.toggles[e]),
                this.hide(this.contents[e]))
              : ((this.current = e),
                this.utils.forEach.call(this.contents, function (t, e) {
                  n.hide(n.toggles[e]), n.hide(t);
                }),
                this.show(this.toggles[e]),
                this.show(this.contents[e])));
        };
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Clickoff = t.UI.extend({
      init: function (t, e, i, n) {
        this._super.apply(this, arguments),
          this.addDomEventHandler('click', this.onClick, document);
      },
      onClick: function (t) {
        var e,
          i,
          n = !0;
        return (
          !(
            !this.isDisabled() &&
            this.el.classList.contains(this.config.activeClass)
          ) ||
          ((e = t.srcElement.getAttribute(this.config.attributes.Show)),
          (i = t.srcElement.getAttribute(this.config.attributes.Toggle)),
          (t.srcElement === this.el ||
            this.utils.isDescendant(this.el, t.srcElement) ||
            e === '#' + this.el.id ||
            e === '.' + this.el.className ||
            i === '#' + this.el.id ||
            i === '.' + this.el.className) &&
            (n = !1),
          void (
            n &&
            this.el.classList.contains(this.config.activeClass) &&
            this.hide(this.el)
          ))
        );
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Decrement = t.UI.extend({
      init: function (t, e, i, n) {
        var s = this;
        this._super.apply(this, arguments),
          (this.targets = this.utils.qsa(
            this.el.getAttribute(
              this.utils.stripBrackets(this.config.attributes.Decrement)
            )
          )),
          this.utils.forEach.call(this.targets, function (t) {
            if ('INPUT' !== t.nodeName)
              throw (
                'Target.js Error on Decrement component: the selector in "' +
                s.utils.stripBrackets(s.config.attributes.Decrement) +
                '" must target an <input> element'
              );
          }),
          this.setLimits(),
          this.addDomEventHandler('click', this.onClick);
      },
      setLimits: function () {
        (this.max = this.el.getAttribute(this.config.attributes.max)),
          (this.min = this.el.getAttribute(this.config.attributes.min)),
          null === this.min
            ? (this.min = 0)
            : (this.min = parseInt(this.min, 10)),
          null !== this.max && (this.max = parseInt(this.max, 10));
      },
      decrement: function (t) {
        var e = parseInt(t.value, 10),
          i = e - 1;
        i <= this.min && this.events.publish('min', t),
          (i = Math.max(i, this.min)),
          (t.value = i);
      },
      onClick: function (t) {
        var e = this;
        this.isDisabled() ||
          this.utils.forEach.call(this.targets, function (t) {
            e.decrement(t);
          });
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Filetext = t.UI.extend({
      init: function (t, e, i, n) {
        if (
          (this._super.apply(this, arguments),
          'INPUT' !== this.NODE_NAME || 'file' !== this.el.getAttribute('type'))
        )
          throw (
            'Error on Target.Filetext component: "' +
            this.utils.stripBrackets(this.config.attributes.Filetext) +
            '" must be applied to an <input> element with \'type="file"\''
          );
        (this.targets = this.utils.qsa(
          this.el.getAttribute(
            this.utils.stripBrackets(this.config.attributes.Filetext)
          )
        )),
          this.addDomEventHandler('change', this.onChange);
      },
      onChange: function (t) {
        var e = this.el.files && this.el.files[0];
        this.isDisabled() ||
          (this.el.files.length &&
            ((e = this.el.files[0].name),
            this.utils.forEach.call(this.targets, function (t) {
              t.innerHTML = e;
            })));
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Grid = t.UI.extend({
      init: function (t, e, i, n) {
        this._super.apply(this, arguments),
          (this.TEXT_NODE = 3),
          (this.COMMENT_NODE = 8),
          (this.published = !1),
          this.setChildren(),
          this.setBreakpoints(),
          this.addEventHandler('resize', this.onResize),
          this.addEventHandler('resize' + this.id, this.onResize),
          this.events.publish('update', this.id),
          this.addDomEventHandler('load', this.onLoad, window);
      },
      setBreakpoints: function () {
        var t = this.el.getAttribute(this.config.attributes.Grid).split(' '),
          e = [],
          i = ['mobile', 'tablet', 'desktop', 'large'];
        t.forEach(function (t, n) {
          'disable' === t ? (e.push(i[n]), (t = 0)) : (t = parseInt(t, 10));
        }),
          (this.breakpoints = {
            mobile: t[0],
            tablet: t[1],
            desktop: t[2],
            large: t[3]
          }),
          e.length &&
            this.el.setAttribute(this.config.attributes.disable, e.join(' '));
      },
      onLoad: function (t) {
        this.removeDomEventHandler('load'),
          this.events.publish('update', this.id);
      },
      setChildren: function () {
        var t,
          e = this;
        return (
          (this.children = []),
          this.el.hasChildNodes()
            ? ((t = this.el.childNodes),
              void this.utils.forEach.call(t, function (t) {
                t.nodeType !== e.TEXT_NODE &&
                  t.nodeType !== e.COMMENT_NODE &&
                  e.children.push(t);
              }))
            : []
        );
      },
      setPerRow: function (t) {
        var e = this;
        return (
          (this.perRow = this.breakpoints.mobile),
          Object.keys(this.breakpoints).forEach(function (i) {
            e.breakpoints[i] && t[i]() && (e.perRow = e.breakpoints[i]);
          }),
          e.perRow
        );
      },
      buildRows: function () {
        var t = this,
          e = this.children[this.children.length - 1],
          i = [],
          n = 0;
        return (
          (this.rows = []),
          this.utils.forEach.call(this.children, function (s) {
            n >= t.perRow && (t.rows.push(i), (n = 0), (i = [])),
              i.push(s),
              n++,
              s === e && t.rows.push(i);
          }),
          this.rows
        );
      },
      calculateGrid: function (t) {
        this.setPerRow(t),
          this.buildRows(),
          this.rows.forEach(function (t) {
            var e = 0;
            t.forEach(function (t) {
              (t.style.height = ''), (e = Math.max(t.offsetHeight, e));
            }),
              t.forEach(function (t) {
                t.style.height = e + 'px';
              });
          });
      },
      resetGrid: function () {
        this.utils.forEach.call(this.children, function (t) {
          t.style.height = '';
        });
      },
      onResize: function (t) {
        this.isDisabled() ? this.resetGrid() : this.calculateGrid(t);
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Height = t.UI.extend({
      init: function (t, e, i, n) {
        this._super.apply(this, arguments),
          this.initHeight(),
          this.addEventHandler('resize', this.setHeight),
          this.addEventHandler('resize' + this.id, this.setHeight),
          this.events.publish('update', this.id);
      },
      initHeight: function () {
        (this.height = this.el.getAttribute(this.config.attributes.Height)),
          this.height && 'window' !== this.height
            ? (this.height = parseInt(this.height, 10))
            : (this.height = 0);
      },
      getHeight: function () {
        return this.height > 0 ? this.height : this.windowHeight + this.height;
      },
      setHeight: function (t, e, i) {
        (this.windowHeight = i),
          this.isDisabled()
            ? (this.el.style.height = '')
            : (this.el.style.height = this.getHeight() + 'px');
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Hide = t.UI.extend({
      init: function (t, e, i, n) {
        this._super.apply(this, arguments),
          (this.targets = this.utils.qsa(
            this.el.getAttribute(
              this.utils.stripBrackets(this.config.attributes.Hide)
            )
          )),
          this.addDomEventHandler('click', this.onClick);
      },
      onClick: function (t) {
        var e = this;
        this.isDisabled() ||
          ('A' === this.NODE_NAME && t.preventDefault(),
          this.utils.forEach.call(this.targets, function (t) {
            e.hide(t);
          }));
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Increment = t.UI.extend({
      init: function (t, e, i, n) {
        var s = this;
        this._super.apply(this, arguments),
          (this.targets = this.utils.qsa(
            this.el.getAttribute(
              this.utils.stripBrackets(this.config.attributes.Increment)
            )
          )),
          this.utils.forEach.call(this.targets, function (t) {
            if ('INPUT' !== t.nodeName)
              throw (
                'Target.js Error on Increment component: the selector in "' +
                s.utils.stripBrackets(s.config.attributes.Increment) +
                '" must target an <input> element'
              );
          }),
          this.setLimits(),
          this.addDomEventHandler('click', this.onClick);
      },
      setLimits: function () {
        (this.max = this.el.getAttribute(this.config.attributes.max)),
          (this.min = this.el.getAttribute(this.config.attributes.min)),
          null === this.min && (this.min = 0),
          null !== this.max && (this.max = parseInt(this.max, 10));
      },
      increment: function (t) {
        var e = parseInt(t.value, 10),
          i = e + 1;
        null !== this.max &&
          (this.max >= i && this.events.publish('max', t),
          (i = Math.min(i, this.max))),
          (t.value = i);
      },
      onClick: function (t) {
        var e = this;
        this.isDisabled() ||
          this.utils.forEach.call(this.targets, function (t) {
            e.increment(t);
          });
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    var i = 0.2;
    t.Scroll = t.UI.extend({
      init: function (t, e, i, n) {
        this._super.apply(this, arguments),
          this.getOffset(),
          this.addEventHandler('resize', this.onResize),
          this.addEventHandler('resize' + this.id, this.onResize),
          this.addEventHandler('scroll', this.onScroll),
          this.events.publish('update', this.id);
      },
      getOffset: function () {
        (this.offset = this.el.getAttribute(
          this.utils.stripBrackets(this.config.attributes.Scroll)
        )),
          this.offset
            ? (this.offset = parseInt(this.offset, 10))
            : (this.offset = 0),
          (this.top = 0);
      },
      calculateThreshold: function (t) {
        var e = this.el.getBoundingClientRect();
        this.threshold = e.top + this.top - t * (1 - i);
      },
      onScroll: function (t) {
        (this.top = t),
          this.top >= this.threshold + this.offset ||
          this.top >= this.docH - this.windowH
            ? this.show(this.el)
            : this.hide(this.el);
      },
      getDocHeight: function () {
        var t = document.body,
          e = document.documentElement,
          i = Math.max(
            t.scrollHeight,
            t.offsetHeight,
            e.clientHeight,
            e.scrollHeight,
            e.offsetHeight
          );
        return i;
      },
      onResize: function (t, e, i) {
        (this.docH = this.getDocHeight()),
          (this.windowH = i),
          this.calculateThreshold(i);
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Scrollbox = t.UI.extend({
      init: function (t, e, i, n) {
        this._super.apply(this, arguments),
          (this.maxHeight = this.el.getAttribute(
            this.config.attributes.Scrollbox
          )),
          (this.maxHeight = parseInt(this.maxHeight, 10)),
          this.el.hasChildNodes() && (this.children = this.el.childNodes),
          this.addEventHandler('resize', this.onResize),
          this.addEventHandler('resize' + this.id, this.onResize),
          this.events.publish('update', this.id);
      },
      getMaxHeight: function () {
        return this.maxHeight >= 0
          ? this.maxHeight
          : document.documentElement.clientHeight + this.maxHeight;
      },
      getContentsHeight: function () {
        var t = 0;
        return (
          this.utils.forEach.call(this.children, function (e) {
            t += e.offsetHeight;
          }),
          t
        );
      },
      setOverflow: function () {
        this.getContentsHeight() > this.getMaxHeight() && !this.isDisabled()
          ? (this.el.style.overflowY = 'scroll')
          : (this.el.style.overflowY = 'auto');
      },
      setMaxHeight: function () {
        this.isDisabled()
          ? (this.el.style.maxHeight = '')
          : (this.el.style.maxHeight = this.getMaxHeight() + 'px');
      },
      onResize: function () {
        this.setMaxHeight(), this.setOverflow();
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Show = t.UI.extend({
      init: function (t, e, i, n) {
        this._super.apply(this, arguments),
          (this.targets = this.utils.qsa(
            this.el.getAttribute(
              this.utils.stripBrackets(this.config.attributes.Show)
            )
          )),
          this.addDomEventHandler('click', this.onClick);
      },
      onClick: function (t) {
        var e = this;
        this.isDisabled() ||
          ('A' === this.NODE_NAME && t.preventDefault(),
          this.utils.forEach.call(this.targets, function (t) {
            e.show(t);
          }));
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    var i = 'targetJsImgsLoaded',
      n = {
        contains: function (t) {
          return this.images.indexOf(t) !== -1;
        },
        add: function (e) {
          this.contains(e) || (this.images += e),
            !t.utils.isIOS && localStorage && (localStorage[i] = this.images);
        },
        init: function () {
          !t.utils.isIOS && localStorage && localStorage[i]
            ? (this.images = localStorage[i])
            : (this.images = '');
        }
      };
    n.init();
    var s = document.createElement('img');
    t.Src = t.UI.extend({
      init: function (t, e, i, o) {
        if (
          (this._super.apply(this, arguments),
          'IMG' !== this.NODE_NAME && 'DIV' !== this.NODE_NAME)
        )
          throw (
            'Target.js Error on Src component: "' +
            this.utils.stripBrackets(this.config.attributes.Src) +
            '" must be applied to an <img> or <div> element'
          );
        (this.published = !1),
          (this.isLoading = !1),
          (this.img = s),
          this.getSrcs(),
          (this.imageCache = n),
          this.addEventHandler('resize', this.onResize),
          this.addEventHandler('resize' + this.id, this.onResize),
          this.events.publish('update', this.id);
      },
      getSrcs: function () {
        var t = this,
          e = this.el.getAttribute(this.config.attributes.Src),
          i = e.split(' '),
          n = null;
        (this.srcs = { mobile: '', tablet: '', desktop: '', large: '' }),
          (this.currentSrc = ''),
          Object.keys(this.srcs).forEach(function (e, s) {
            var o = i[s];
            o && o.indexOf('/') !== -1 && (n = o), (t.srcs[e] = n);
          });
      },
      showImage: function (t) {
        var e = this;
        (this.currentSrc = t),
          'IMG' === this.NODE_NAME
            ? (this.el.src = t)
            : 'DIV' === this.NODE_NAME &&
              ((this.el.style.backgroundImage = 'url("' + t + '")'),
              this.utils.render(function () {
                e.show(e.el);
              }));
      },
      onLoad: function () {
        this.domEventHandlers.load && this.removeDomEventHandler('load'),
          this.isLoading && (this.isLoading = !1),
          this.imageCache.add(this.loadingImg),
          this.showImage(this.loadingImg);
      },
      load: function (t) {
        var e = this;
        (this.isLoading = !0),
          (this.loadingImg = t),
          this.addDomEventHandler('load', this.onLoad, this.img),
          (this.loadingFallback = setTimeout(function () {
            e.isLoading && (e.onLoad(), clearTimeout(e.loadingFallback));
          }, 5e3)),
          (this.img.src = t);
      },
      onResize: function (t, e, i) {
        var n = this;
        Object.keys(this.srcs).forEach(function (e) {
          var i = n.srcs[e];
          t[e]() &&
            i !== n.currentSrc &&
            (n.imageCache.contains(i)
              ? n.showImage(i)
              : ('DIV' === n.NODE_NAME && n.hide(n.el), n.load(i)));
        });
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.Toggle = t.UI.extend({
      init: function (t, e, i, n) {
        this._super.apply(this, arguments),
          (this.targets = this.utils.qsa(
            this.el.getAttribute(
              this.utils.stripBrackets(this.config.attributes.Toggle)
            )
          )),
          this.addDomEventHandler('click', this.onClick);
      },
      onClick: function (t) {
        var e = this;
        this.isDisabled() ||
          ('A' === this.NODE_NAME && t.preventDefault(),
          this.utils.forEach.call(this.targets, function (t) {
            e.toggle(t);
          }));
      },
      toggle: function (t) {
        t.classList.contains(this.config.activeClass)
          ? this.hide(t)
          : this.show(t);
      }
    });
  })((window.target = window.target || {})),
  (function (t, e) {
    'use strict';
    t.init = function (e) {
      t.utils.mixin(t.config, e),
        (t.events = new window.Mediator()),
        (t.window = t.Window.create(t)),
        t.config.observeDom && (t.domObserver = t.DomObserver.create(t)),
        (t.componentFactory = t.ComponentFactory.create(t)),
        (t.api = t.API.create(t)),
        t.componentFactory.start();
    };
  })((window.target = window.target || {})),
  jQuery(function (t) {
    'use strict';
    function e() {
      setTimeout(function () {
        t('.fader').addClass('ready');
      }, 500);
    }
    if (!window.MutationObserver) return !1;
    var i = new window.MutationObserver(function (t, i) {
      e();
    });
    i.observe(document, { subtree: !0, childList: !0 });
  }),
  jQuery(function (t) {
    'use strict';
    if ((t('[data-flash]').flash(), !window.MutationObserver)) return !1;
    var e = new window.MutationObserver(function (e, i) {
      t('[data-flash]').flash();
    });
    e.observe(document, { subtree: !0, childList: !0 });
  }),
  jQuery(function (t) {
    'use strict';
    function e() {
      t('[data-modal-trigger]').magnificPopup({
        disableOn: 767,
        type: 'inline',
        mainClass: 'mfp-zoom-in mfp-default',
        removalDelay: 300,
        preloader: !1,
        closeBtnInside: !0,
        midClick: !0,
        fixedContentPos: 'auto',
        closeMarkup:
          '<button type="button" title="%title%" class="mfp-close x x--contrast">X</button>'
      });
    }
    if ((e(), !window.MutationObserver)) return !1;
    var i = new window.MutationObserver(function (t, i) {
      e();
    });
    i.observe(document, { subtree: !0, childList: !0 });
  }),
  jQuery(function (t) {
    'use strict';
    var e = 'data-slick-product-id',
      i = 'data-theme-slick-variant',
      n = 'data-theme-slick-variant-count',
      s = 'data-has-only-default-variant',
      o = t(document);
    t('[' + e + ']').each(function () {
      var r = this.getAttribute(e),
        a = t(this),
        l = this.getAttribute(i),
        c = this.getAttribute(n),
        d = l.replace(/(["|'])/g, '\\$1'),
        u = this.getAttribute(s);
      a.on('init reInit', function (t, e) {
        o.trigger('slickInit' + r);
      }),
        o.on('slickGoTo' + r, function (t, e) {
          a.slick('slickGoTo', e);
        }),
        a.slick({
          slidesToShow: 5,
          vertical: !0,
          infinite: !1,
          prevArrow:
            '<a class="slick-arrow slick-prev"><span class="visuallyhidden">Previous</span><span class="icon icon--caret-up"></span></a>',
          nextArrow:
            '<a class="slick-arrow slick-next"><span class="visuallyhidden">Next</span><span class="icon icon--caret-down"></span></a>',
          responsive: [
            {
              breakpoint: 767,
              settings: {
                arrows: !0,
                dots: !1,
                slidesToShow: 1,
                vertical: !1,
                prevArrow:
                  '<a class="slick-arrow slick-prev"><span class="visuallyhidden">Previous</span><span class="icon icon--caret-left"></span></a>',
                nextArrow:
                  '<a class="slick-arrow slick-next"><span class="visuallyhidden">Next</span><span class="icon icon--caret-right"></span></a>'
              }
            }
          ]
        }),
        parseInt(c) >= 1 &&
          'false' === u &&
          a.slick('slickFilter', function () {
            var e = t(this),
              i = e.hasClass('has_product_video'),
              n = e.data('current-variant-video'),
              s = e.data('option2');
            if (s === 'All Variants' || d === s || (0 == n && i)) return e;
          });
    });
  }),
  jQuery(function (t) {
    'use strict';
    function e() {
      t('.slick-init').each(function () {
        var e = t(this),
          i = this.id,
          n = t('[data-slick-nav-for="#' + i + '"]');
        return (
          e.slick({
            adaptiveHeight: !0,
            arrows: !0,
            dots: !1,
            prevArrow: '<div class="prev-arrow"></div>',
            nextArrow: '<div class="next-arrow"></div>',
            responsive: [
              { breakpoint: 768, settings: { arrows: !1, dots: !0 } }
            ]
          }),
          !!n.length &&
            (n.on('click', 'a', function (i) {
              i.preventDefault();
              var s = n.find('li').index(t(this).parent());
              e.slick('slickGoTo', [s]);
            }),
            void e.on('beforeChange', function (t, e, i, s) {
              var o = n.find('li');
              o.find('a')
                .removeClass('current')
                .end()
                .eq(s)
                .find('a')
                .addClass('current');
            }))
        );
      });
    }
    e();
  }),
  (function (t, e, i, n) {
    'use strict';
    i.init({ breakpoints: { tablet: 768, desktop: 1025, large: 1440 } });
  })(window.jQuery, (window.themeleon = window.themeleon || {}), window.target),
  (function (t, e, i) {
    'use strict';
    e.NewsletterPopup = function (e) {
      function i() {
        (a = t.extend(!0, {}, h, e)),
          (a.delay = parseInt(a.seconds + '000', 10));
      }
      function n() {
        var e,
          i,
          n,
          s,
          o = +new Date();
        if (((p.days.value = t.cookie(p.days.name)), p.days.value)) {
          for (e = parseInt(p.days.value, 10), s = o - e, n = 0; s > c; s -= c)
            n++;
          i = n >= a.days;
        } else i = !1;
        return (p.days.value = o), i;
      }
      function s() {
        return (
          (p.subscriber.value = t.cookie(p.subscriber.name)), p.subscriber.value
        );
      }
      function o() {
        var e,
          i = 0;
        return (
          (p.pageviews.value = t.cookie(p.pageviews.name)),
          p.pageviews.value && (i = parseInt(p.pageviews.value, 10)),
          i++,
          (p.pageviews.value = i),
          (e = i === a.pageviews)
        );
      }
      function r(e, i) {
        t.cookie(e, i, { path: '/', expires: l });
      }
      var a,
        l = 365,
        c = 864e5,
        d = this,
        u = '#newsletter-popup',
        p = {
          pageviews: { name: 'cometCardinalPageviews' },
          days: { name: 'cometCardinalDays' },
          subscriber: { name: 'cometCardinalSubscriber' }
        },
        h = { enabled: !1, pageviews: 1, days: 1, seconds: 0 };
      (this.open = function () {
        t.magnificPopup.open(
          {
            items: { src: u },
            type: 'inline',
            mainClass: 'mfp-move-horizontal',
            removalDelay: 300
          },
          0
        ),
          event && event.preventDefault && event.preventDefault();
      }),
        (this.init = function () {
          var t, e, l;
          return (
            i(),
            !!a.enabled &&
              ((e = s()),
              (t = o()),
              (l = n()),
              e ||
                (!t && !l) ||
                (setTimeout(d.open, a.delay), r(p.days.name, p.days.value)),
              r(p.pageviews.name, p.pageviews.value),
              void (a.force && setTimeout(d.open, a.delay)))
          );
        });
    };
  })(window.jQuery, (window.themeleon = window.themeleon || {})),
  (function (t, e, i) {
    'use strict';
    (e.init = function () {
      e.newsletterPopup = new e.NewsletterPopup();
    }),
      e.init();
  })(window.jQuery, (window.themeleon = window.themeleon || {}));
